export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    /** An ISO 8601-encoded datetime */
    ISO8601DateTime: any;
    /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
    DateTime: any;
    /** Arbitrary object */
    Object: any;
    /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSON: any;
    /** Parse DateTime columns (UNIX milliseconds) as ISO strings */
    DateISOString: any;
    /** An ISO 8601-encoded date */
    ISO8601Date: any;
    /** Any type */
    AnyScalar: any;
    /** Money scalar type */
    Money: any;
};

export type AccessoriesReturnStep = BasicReturnStep & {
    __typename?: 'AccessoriesReturnStep';
    accessories: Array<Scalars['String']>;
    description: Scalars['String'];
    headline: Scalars['String'];
    name: Scalars['String'];
    warning?: Maybe<Scalars['String']>;
};

export type AccountBasicModel = {
    __typename?: 'AccountBasicModel';
    accountUuid: Scalars['String'];
    amount: Scalars['Money'];
    currency: Scalars['String'];
    uuid: Scalars['String'];
};

export type AccountManualBookingModel = {
    __typename?: 'AccountManualBookingModel';
    orderNumber: Scalars['String'];
    otpLink: Scalars['String'];
};

export type AccountModel = {
    __typename?: 'AccountModel';
    deleted: Scalars['Boolean'];
    type: Scalars['String'];
    uuid: Scalars['ID'];
    walletUuid: Scalars['String'];
};

export type AccountPayByInvoiceModel = {
    __typename?: 'AccountPayByInvoiceModel';
    viban: Scalars['String'];
};

export type AccountPaymentServiceModel = {
    __typename?: 'AccountPaymentServiceModel';
    gateway: Scalars['String'];
    referenceId: Scalars['String'];
    transactionId: Scalars['String'];
    transactionToken?: Maybe<Scalars['String']>;
};

export type AccountReservation = {
    __typename?: 'AccountReservation';
    amount: CardAmount;
    description?: Maybe<Scalars['String']>;
    expiresAt?: Maybe<Scalars['String']>;
    id: Scalars['String'];
    loyaltyAction?: Maybe<LoyaltyActionResultReservation>;
    metaInfo?: Maybe<BookingMetaInfo>;
    metaInfoRaw: Scalars['String'];
    reservationType: ReservationType;
};

export type AccountStatementInfo = {
    period: Scalars['Float'];
    year: Scalars['String'];
};

export type AccountStatementPdfResult = {
    __typename?: 'AccountStatementPDFResult';
    encodedContent: Scalars['String'];
    mimeType: Scalars['String'];
};

export type AccountType =
    | AccountBasicModel
    | AccountManualBookingModel
    | AccountPayByInvoiceModel
    | AccountPaymentServiceModel;

export type Action = {
    __typename?: 'Action';
    defaultMessage?: Maybe<Scalars['String']>;
    href?: Maybe<Scalars['String']>;
    text: Scalars['String'];
    type: Scalars['String'];
};

export type ActionInputType = {
    campaignUuid: Scalars['String'];
    content: Scalars['AnyScalar'];
    type: ActionTypes;
};

export enum ActionTypes {
    copyToClipboardAction = 'copyToClipboardAction',
    launchFlowActionModel = 'launchFlowActionModel',
    linkAction = 'linkAction',
}

export type ActionUnionModel = CopyToClipboardActionModel | LaunchFlowActionModel | LinkActionModel;

export type ActivateCardInfo = {
    cardId: Scalars['String'];
    verificationToken: Scalars['String'];
};

export type ActivateCardResult = {
    __typename?: 'ActivateCardResult';
    status: CardStatus;
};

/** Input type for adding an account to the Billing system */
export type AddAccountInput = {
    currency: Scalars['String'];
    externalCustomer: Scalars['String'];
    gateway: Gateway;
    referenceId: Scalars['String'];
    transactionId: Scalars['String'];
    transactionToken?: Maybe<Scalars['String']>;
};

/** Input type for adding a pay-by-invoice account to the Billing system */
export type AddPayByInvoiceAccountInput = {
    currency: Scalars['String'];
    externalCustomer: Scalars['String'];
    viban: Scalars['String'];
};

export type AddProductsToCampaignInput = {
    productCampaignId: Scalars['ID'];
    skus: Array<Scalars['String']>;
};

export type AddProductsToCountdownTimerInput = {
    countdownTimerId: Scalars['ID'];
    skus: Array<Scalars['String']>;
};

export type AddProductsToCountdownTimerOutput = {
    __typename?: 'AddProductsToCountdownTimerOutput';
    numberOfCreatedRecords: Scalars['Int'];
};

export type AddReferenceAccountResult = {
    __typename?: 'AddReferenceAccountResult';
    status: Scalars['String'];
};

export type Address = {
    __typename?: 'Address';
    additionalInfo?: Maybe<Scalars['String']>;
    billingAddress: Scalars['Boolean'];
    city: Scalars['String'];
    country: Scalars['String'];
    countryIso: Scalars['String'];
    id: Scalars['ID'];
    line1: Scalars['String'];
    line2?: Maybe<Scalars['String']>;
    shippingAddress: Scalars['Boolean'];
    stateAbbr?: Maybe<Scalars['String']>;
    zip: Scalars['String'];
};

export type AddressInfo = {
    addressAdditionalInfo?: Maybe<Scalars['String']>;
    city: Scalars['String'];
    postalCode: Scalars['String'];
    street: Scalars['String'];
    streetNumber: Scalars['String'];
};

export type AdjustmentInput = {
    code?: Maybe<Scalars['String']>;
};

export type AffectedRowsOutput = {
    __typename?: 'AffectedRowsOutput';
    count: Scalars['Int'];
};

export type AllocationResult = {
    __typename?: 'AllocationResult';
    allocation?: Maybe<AssetAllocation>;
    success: Scalars['Boolean'];
};

/** Autogenerated input type of ApplyLoyaltyDiscount */
export type ApplyLoyaltyDiscountInput = {
    amountInCents: Scalars['Int'];
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    paymentId: Scalars['ID'];
};

/** Autogenerated return type of ApplyLoyaltyDiscount */
export type ApplyLoyaltyDiscountPayload = {
    __typename?: 'ApplyLoyaltyDiscountPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    payment: PaymentsUnion;
};

/** Autogenerated input type of ApplySurpriseDiscount */
export type ApplySurpriseDiscountInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    subscriptionId: Scalars['ID'];
};

/** Autogenerated return type of ApplySurpriseDiscount */
export type ApplySurpriseDiscountPayload = {
    __typename?: 'ApplySurpriseDiscountPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    errors: Array<Scalars['String']>;
    subscriptionDetails: SubscriptionDetails;
};

export type Asset = {
    __typename?: 'Asset';
    isDeviceLocked?: Maybe<Scalars['Boolean']>;
    productNumber: Scalars['String'];
    serialNumber?: Maybe<Scalars['String']>;
};

export type AssetAllocation = {
    __typename?: 'AssetAllocation';
    asset?: Maybe<AssetModel>;
    assetUid?: Maybe<Scalars['String']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    orderMode?: Maybe<JunoOrderMode>;
    orderNumber?: Maybe<Scalars['String']>;
    replacedBy: ReplacementModel;
    replacement: ReplacementModel;
    replacements?: Maybe<Array<ReplacementModel>>;
    reservation?: Maybe<Reservation>;
    reservationUid?: Maybe<Scalars['String']>;
    salesforceAllocationId?: Maybe<Scalars['String']>;
    salesforceAssetId?: Maybe<Scalars['String']>;
    salesforceSubscriptionId?: Maybe<Scalars['String']>;
    serialNumber?: Maybe<Scalars['String']>;
    shipments: Array<Shipment>;
    skuVariantCode?: Maybe<Scalars['String']>;
    store?: Maybe<Store>;
    storeId?: Maybe<Scalars['Int']>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AssetAllocationCollection = {
    __typename?: 'AssetAllocationCollection';
    count: Scalars['Float'];
    rows: Array<AssetAllocation>;
};

export type AssetAllocationFilterInput = {
    assetUid?: Maybe<Scalars['String']>;
    orderMode?: Maybe<JunoOrderMode>;
    orderNumber?: Maybe<Scalars['String']>;
    reservationUid?: Maybe<Scalars['String']>;
    salesforceAllocationId?: Maybe<Scalars['String']>;
    salesforceAssetId?: Maybe<Scalars['String']>;
    salesforceSubscriptionId?: Maybe<Scalars['String']>;
    serialNumber?: Maybe<Scalars['String']>;
    skuVariantCode?: Maybe<Scalars['String']>;
    storeId?: Maybe<Scalars['Float']>;
    uid?: Maybe<Scalars['String']>;
};

export type AssetCollection = {
    __typename?: 'AssetCollection';
    count: Scalars['Float'];
    rows: Array<AssetModel>;
};

export enum AssetCondition {
    Agan = 'Agan',
    Damaged = 'Damaged',
    Incomplete = 'Incomplete',
    Irreparable = 'Irreparable',
    Locked = 'Locked',
    New = 'New',
    Used = 'Used',
    Warranty = 'Warranty',
}

export type AssetFilterInput = {
    capitalSourceName?: Maybe<Scalars['String']>;
    condition?: Maybe<AssetCondition>;
    salesforceId?: Maybe<Scalars['String']>;
    salesforcePurchaseRequestId?: Maybe<Scalars['String']>;
    salesforceStatus?: Maybe<Scalars['String']>;
    serialNumber?: Maybe<Scalars['String']>;
    skuVariantCode?: Maybe<Scalars['String']>;
    status?: Maybe<AssetStatus>;
    stockUid?: Maybe<Scalars['String']>;
    supplierName?: Maybe<Scalars['String']>;
    uid?: Maybe<Scalars['String']>;
    warehouseCode?: Maybe<Scalars['String']>;
};

export type AssetModel = {
    __typename?: 'AssetModel';
    activeContract?: Maybe<Contract>;
    capitalSourceName?: Maybe<Scalars['String']>;
    condition?: Maybe<AssetCondition>;
    createdAt?: Maybe<Scalars['DateTime']>;
    deletedAt?: Maybe<Scalars['DateTime']>;
    isDeviceLocked?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    purchaseRequest?: Maybe<PurchaseRequest>;
    purchaseRequestItem?: Maybe<PurchaseRequestItem>;
    salesforceCapitalSourceId?: Maybe<Scalars['String']>;
    salesforceId?: Maybe<Scalars['String']>;
    salesforceLastModifiedDate?: Maybe<Scalars['DateTime']>;
    salesforceStatus?: Maybe<Scalars['String']>;
    salesforceStockUid?: Maybe<Scalars['String']>;
    salesforceSupplierId?: Maybe<Scalars['String']>;
    serialNumber?: Maybe<Scalars['String']>;
    skuUid?: Maybe<Scalars['String']>;
    skuVariantCode?: Maybe<Scalars['String']>;
    status?: Maybe<AssetStatus>;
    statusUpdatedAt?: Maybe<Scalars['DateTime']>;
    stock?: Maybe<Stock>;
    stockUid?: Maybe<Scalars['String']>;
    supplierName?: Maybe<Scalars['String']>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
    variant?: Maybe<Variant>;
    warehouseCode?: Maybe<Scalars['String']>;
};

export enum AssetStatus {
    InDebtCollection = 'InDebtCollection',
    InRepair = 'InRepair',
    InStock = 'InStock',
    Incomplete = 'Incomplete',
    InvestigationCarrier = 'InvestigationCarrier',
    InvestigationWarehouse = 'InvestigationWarehouse',
    Irreparable = 'Irreparable',
    LockedDevice = 'LockedDevice',
    Lost = 'Lost',
    OnLoan = 'OnLoan',
    Reserved = 'Reserved',
    Returned = 'Returned',
    ReturnedToSupplier = 'ReturnedToSupplier',
    Sold = 'Sold',
    TransferredToWarehouse = 'TransferredToWarehouse',
    Warranty = 'Warranty',
}

export type AssociateProductInput = {
    sku: Scalars['String'];
};

export type AttentionNote = TextNoteInterface & {
    __typename?: 'AttentionNote';
    text?: Maybe<Scalars['String']>;
};

export type AuthDevice = {
    __typename?: 'AuthDevice';
    createdAt: Scalars['ISO8601DateTime'];
    deviceType: AuthDeviceType;
    history: Array<AuthDeviceHistoryItem>;
    id: Scalars['ID'];
    lastLocation?: Maybe<AuthDeviceHistoryItem>;
    os: Os;
    platform: Platform;
    stale: Scalars['Boolean'];
    userAgent: Scalars['String'];
};

/** The connection type for AuthDevice. */
export type AuthDeviceConnection = {
    __typename?: 'AuthDeviceConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<AuthDeviceEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<AuthDevice>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AuthDeviceEdge = {
    __typename?: 'AuthDeviceEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<AuthDevice>;
};

export type AuthDeviceHistoryItem = {
    __typename?: 'AuthDeviceHistoryItem';
    city: Scalars['String'];
    country: Scalars['String'];
    countryIso: Scalars['String'];
    createdAt: Scalars['ISO8601DateTime'];
    ipAddress: Scalars['String'];
    lastSeenAt: Scalars['ISO8601DateTime'];
};

export type AuthDeviceInfo = {
    deviceId: Scalars['String'];
};

export type AuthDeviceResult = {
    __typename?: 'AuthDeviceResult';
    createdAt: Scalars['DateTime'];
    expiresAt: Scalars['DateTime'];
    id: Scalars['String'];
    stringToSign: Scalars['String'];
    type: Scalars['String'];
};

export enum AuthDeviceType {
    DESKTOP = 'DESKTOP',
    MOBILE = 'MOBILE',
    OTHER = 'OTHER',
    TABLET = 'TABLET',
}

export type AuthorizeScaChallengesInfo = {
    changeRequestId: Scalars['String'];
    deviceId: Scalars['String'];
    scaChallengeId: Scalars['String'];
};

export type AvailabilityCampaign = {
    __typename?: 'AvailabilityCampaign';
    allocationDate?: Maybe<Scalars['DateTime']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    createdBy?: Maybe<Scalars['String']>;
    defaultThreshold?: Maybe<Scalars['Float']>;
    description?: Maybe<Scalars['String']>;
    finalAvailability?: Maybe<AvailabilityMode>;
    finishDate?: Maybe<Scalars['DateTime']>;
    name?: Maybe<Scalars['String']>;
    skuThresholds?: Maybe<Array<AvailabilityCampaignSkuThreshold>>;
    startAvailability?: Maybe<AvailabilityMode>;
    startDate?: Maybe<Scalars['DateTime']>;
    status?: Maybe<AvailabilityCampaignStatus>;
    storeIds?: Maybe<Array<Scalars['Int']>>;
    supplierNames?: Maybe<Array<Scalars['String']>>;
    type?: Maybe<AvailabilityCampaignType>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AvailabilityCampaignCollection = {
    __typename?: 'AvailabilityCampaignCollection';
    count: Scalars['Float'];
    rows: Array<AvailabilityCampaign>;
};

export type AvailabilityCampaignFilterInput = {
    skuVariantCode?: Maybe<Scalars['String']>;
    status?: Maybe<AvailabilityCampaignStatus>;
    storeId?: Maybe<Scalars['Float']>;
    uid?: Maybe<Scalars['ID']>;
};

export type AvailabilityCampaignSkuThreshold = {
    __typename?: 'AvailabilityCampaignSkuThreshold';
    skuVariantCode: Scalars['String'];
    threshold?: Maybe<Scalars['Float']>;
};

export type AvailabilityCampaignSkuThresholdInput = {
    skuVariantCode: Scalars['String'];
    threshold?: Maybe<Scalars['Float']>;
};

export enum AvailabilityCampaignStatus {
    Active = 'Active',
    Cancelled = 'Cancelled',
    Closed = 'Closed',
    Created = 'Created',
}

export enum AvailabilityCampaignType {
    PreOrder = 'PreOrder',
    Simple = 'Simple',
}

export type AvailabilityCampaignUpsertInput = {
    allocationDate?: Maybe<Scalars['DateTime']>;
    defaultThreshold?: Maybe<Scalars['Float']>;
    description?: Maybe<Scalars['String']>;
    finalAvailability?: Maybe<AvailabilityMode>;
    finishDate?: Maybe<Scalars['DateTime']>;
    name?: Maybe<Scalars['String']>;
    skuThresholds?: Maybe<Array<AvailabilityCampaignSkuThresholdInput>>;
    startAvailability?: Maybe<AvailabilityMode>;
    startDate?: Maybe<Scalars['DateTime']>;
    storeIds?: Maybe<Array<Scalars['Int']>>;
    supplierNames?: Maybe<Array<Scalars['String']>>;
    type?: Maybe<AvailabilityCampaignType>;
    uid?: Maybe<Scalars['ID']>;
};

export enum AvailabilityMode {
    Automatic = 'Automatic',
    Disabled = 'Disabled',
    Enabled = 'Enabled',
    WaitingList = 'WaitingList',
}

export type BasicAmount = {
    __typename?: 'BasicAmount';
    cents: Scalars['Int'];
    currency: Scalars['String'];
};

export type BasicContract = {
    actions?: Maybe<Array<ContractAction>>;
    activatedAt?: Maybe<Scalars['ISO8601DateTime']>;
    billingAccountId: Scalars['ID'];
    billingTerms: BillingTerms;
    createdAt: Scalars['ISO8601DateTime'];
    currentFlow?: Maybe<Flow>;
    endingTerm: EndingTerm;
    flow?: Maybe<Flows>;
    good?: Maybe<Goods>;
    goods?: Maybe<Array<Goods>>;
    id: Scalars['ID'];
    revocationTerms?: Maybe<RevocationTerms>;
    state: ContractState;
    terminatedAt?: Maybe<Scalars['ISO8601DateTime']>;
    terminationReason?: Maybe<ContractTerminationReason>;
    userId: Scalars['ID'];
};

export type BasicContractGoodArgs = {
    id: Scalars['ID'];
};

export type BasicMarketingCardContentModel = {
    __typename?: 'BasicMarketingCardContentModel';
    actions?: Maybe<Array<ActionUnionModel>>;
    /** Markdown template. Commonly a placeholder for translations. Example: {{thankyou}}. thankyou is a translate placeholder */
    bodyTemplate: Scalars['String'];
    imageUrl?: Maybe<Scalars['String']>;
    largeImage?: Maybe<Scalars['Boolean']>;
    uuid: Scalars['ID'];
};

export type BasicMarketingCardModel = {
    __typename?: 'BasicMarketingCardModel';
    actions?: Maybe<Array<ActionUnionModel>>;
    /** Markdown template. Commonly a placeholder for translations. Example: {{thankyou}}. thankyou is a translate placeholder */
    bodyTemplate: Scalars['String'];
    colorFunction?: Maybe<ColorFunctions>;
    imageUrl?: Maybe<Scalars['String']>;
    largeImage?: Maybe<Scalars['Boolean']>;
    uuid: Scalars['ID'];
};

export type BasicReturnStep = {
    description: Scalars['String'];
    headline: Scalars['String'];
    name: Scalars['String'];
    warning?: Maybe<Scalars['String']>;
};

export type BigMigrationCreateRecurrentPaymentsContractInput = {
    id: Scalars['String'];
    nextPeriodNumber: Scalars['Int'];
    subscriptionPayments: Array<BigMigrationCreateRecurrentPaymentsContractPaymentInput>;
};

export type BigMigrationCreateRecurrentPaymentsContractPaymentInput = {
    createdAt: Scalars['String'];
    dueDate: Scalars['String'];
    paidDate: Scalars['String'];
    period: Scalars['Int'];
    price: Scalars['Float'];
    state: Scalars['String'];
    updatedAt: Scalars['String'];
};

export type BigMigrationCreateRecurrentPaymentsInput = {
    billingAccountId: Scalars['String'];
    orders: Array<BigMigrationCreateRecurrentPaymentsOrderInput>;
    userId: Scalars['String'];
};

export type BigMigrationCreateRecurrentPaymentsOrderInput = {
    additionalData: Scalars['JSON'];
    contracts: Array<BigMigrationCreateRecurrentPaymentsContractInput>;
    currency: Scalars['String'];
    lineItems: Array<Scalars['JSON']>;
    orderNumber: Scalars['String'];
    orderPaymentCreatedAt: Scalars['String'];
    orderPaymentUpdatedAt: Scalars['String'];
    totalInCents: Scalars['Int'];
};

export type BigMigrationCreateRecurrentPaymentsPayload = {
    __typename?: 'BigMigrationCreateRecurrentPaymentsPayload';
    result: Scalars['JSON'];
    success: Scalars['Boolean'];
};

export enum BillingMode {
    PREPAID = 'PREPAID',
}

export type BillingPeriod = Period & {
    __typename?: 'BillingPeriod';
    amountDue: Price;
    contractId: Scalars['ID'];
    discounts?: Maybe<Array<ContractDiscounts>>;
    ends: Scalars['ISO8601DateTime'];
    number: Scalars['Int'];
    payment?: Maybe<ContractPaymentGroupModel>;
    starts: Scalars['ISO8601DateTime'];
};

export type BillingTerms = {
    __typename?: 'BillingTerms';
    basePrice: Price;
    currentPeriod?: Maybe<BillingPeriod>;
    discounts?: Maybe<Array<ContractDiscounts>>;
    nextPeriod?: Maybe<BillingPeriod>;
    period?: Maybe<BillingPeriod>;
    periodLength: Duration;
    price: Price;
    type: BillingMode;
};

export type BillingTermsPeriodArgs = {
    number: Scalars['Int'];
};

export type BlockCardInfo = {
    cardId: Scalars['String'];
};

export type BookingMetaInfo = {
    __typename?: 'BookingMetaInfo';
    merchant: Merchant;
    originalAmount: OriginalAmount;
    posEntryMode: PosEntryModeTypes;
    transactionDate: Scalars['DateTime'];
    transactionTime: Scalars['DateTime'];
    transactionType: CardTransactionTypes;
};

export type BookingsInfo = {
    page: Scalars['Float'];
    perPage?: Maybe<Scalars['Float']>;
};

export enum BookingTypes {
    cancellationBooking = 'cancellationBooking',
    cancellationCardTransaction = 'cancellationCardTransaction',
    cancellationCardTransactionDirect = 'cancellationCardTransactionDirect',
    cancellationChargeCard = 'cancellationChargeCard',
    cancellationChargeDunning = 'cancellationChargeDunning',
    cancellationChargeSepaDirectDebitReturn = 'cancellationChargeSepaDirectDebitReturn',
    cancellationCryptoExchange = 'cancellationCryptoExchange',
    cancellationCurrencyExchangePartner = 'cancellationCurrencyExchangePartner',
    cancellationDirectDebit = 'cancellationDirectDebit',
    cancellationDoubleBooking = 'cancellationDoubleBooking',
    cancellationInterestAccrued = 'cancellationInterestAccrued',
    cancellationInterestAnnuity = 'cancellationInterestAnnuity',
    cancellationInterestLoan = 'cancellationInterestLoan',
    cancellationInternalTransfer = 'cancellationInternalTransfer',
    cancellationInternationalCreditTransfer = 'cancellationInternationalCreditTransfer',
    cancellationLoanPayout = 'cancellationLoanPayout',
    cancellationRebooking = 'cancellationRebooking',
    cancellationRebookingInterest = 'cancellationRebookingInterest',
    cancellationSepaCreditTransferReturn = 'cancellationSepaCreditTransferReturn',
    cancellationSepaDirectDebit = 'cancellationSepaDirectDebit',
    cancellationSepaDirectDebitReturn = 'cancellationSepaDirectDebitReturn',
    cancellationTransferAnnuity = 'cancellationTransferAnnuity',
    cardAuthDecline = 'cardAuthDecline',
    cardDirectDebit = 'cardDirectDebit',
    cardTransaction = 'cardTransaction',
    cardTransactionDirect = 'cardTransactionDirect',
    chargeAccountMaintenance = 'chargeAccountMaintenance',
    chargeCard = 'chargeCard',
    chargeDunning = 'chargeDunning',
    chargeSepaDirectDebitReturn = 'chargeSepaDirectDebitReturn',
    commissionOverdraft = 'commissionOverdraft',
    creditTransferCancellation = 'creditTransferCancellation',
    cryptoExchange = 'cryptoExchange',
    currencyExchangePartner = 'currencyExchangePartner',
    directDebit = 'directDebit',
    foreignPayment = 'foreignPayment',
    interestAccrued = 'interestAccrued',
    interestAnnuity = 'interestAnnuity',
    interestLoan = 'interestLoan',
    internalTransfer = 'internalTransfer',
    internationalCreditTransfer = 'internationalCreditTransfer',
    loanPayout = 'loanPayout',
    other = 'other',
    rebooking = 'rebooking',
    rebookingInterest = 'rebookingInterest',
    sepaCreditTransfer = 'sepaCreditTransfer',
    sepaCreditTransferReturn = 'sepaCreditTransferReturn',
    sepaDirectDebit = 'sepaDirectDebit',
    sepaDirectDebitReturn = 'sepaDirectDebitReturn',
    transferAnnuity = 'transferAnnuity',
}

export type BoolFilter = {
    equals?: Maybe<Scalars['Boolean']>;
    not?: Maybe<NestedBoolFilter>;
};

export type Bundle = {
    __typename?: 'Bundle';
    active: Scalars['Boolean'];
    campaignName?: Maybe<Scalars['String']>;
    createdAt: Scalars['DateTime'];
    description?: Maybe<Scalars['String']>;
    discountCode?: Maybe<Scalars['String']>;
    id: Scalars['Int'];
    /** Fetches product by sku. Prefer `mainProductSku` if needed only sku */
    mainProduct?: Maybe<Product>;
    mainProductSku: Scalars['String'];
    /** Fetches product by sku. Prefer `secondarySkus` if needed only sku */
    secondaryProducts?: Maybe<Array<Maybe<Product>>>;
    secondarySkus: Array<Scalars['String']>;
    store: Scalars['String'];
    title?: Maybe<Scalars['String']>;
    updatedAt: Scalars['DateTime'];
    userId: Scalars['Int'];
};

export type BundleBulkCreateInput = {
    bundles?: Maybe<Array<Maybe<BundleCreateInput>>>;
};

export type BundleCreateInput = {
    active?: Maybe<Scalars['Boolean']>;
    description?: Maybe<Scalars['String']>;
    mainProductSku: Scalars['String'];
    secondarySkus: Array<Scalars['String']>;
    store: Scalars['String'];
    title?: Maybe<Scalars['String']>;
};

export type BundleError = {
    __typename?: 'BundleError';
    code?: Maybe<Scalars['String']>;
    message?: Maybe<Scalars['String']>;
};

export type BundleOrderByInput = {
    active?: Maybe<SortOrder>;
    createdAt?: Maybe<SortOrder>;
    description?: Maybe<SortOrder>;
    id?: Maybe<SortOrder>;
    mainProductSku?: Maybe<SortOrder>;
    secondarySkus?: Maybe<SortOrder>;
    store?: Maybe<SortOrder>;
    title?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
    userId?: Maybe<SortOrder>;
};

export type BundleOrError = Bundle | BundleError;

export type BundlePaginationOutput = {
    __typename?: 'BundlePaginationOutput';
    rows: Array<Bundle>;
    totalCount: Scalars['Int'];
};

export type BundleUpdateInput = {
    active?: Maybe<Scalars['Boolean']>;
    description?: Maybe<Scalars['String']>;
    mainProductSku?: Maybe<Scalars['String']>;
    secondarySkus?: Maybe<Array<Maybe<Scalars['String']>>>;
    store?: Maybe<Scalars['String']>;
    title?: Maybe<Scalars['String']>;
};

export type BundleWhereInput = {
    AND?: Maybe<Array<BundleWhereInput>>;
    NOT?: Maybe<Array<BundleWhereInput>>;
    OR?: Maybe<Array<BundleWhereInput>>;
    active?: Maybe<BoolFilter>;
    createdAt?: Maybe<DateTimeFilter>;
    description?: Maybe<StringNullableFilter>;
    id?: Maybe<IntFilter>;
    mainProductSku?: Maybe<StringFilter>;
    secondarySkus?: Maybe<StringNullableListFilter>;
    store?: Maybe<StringFilter>;
    title?: Maybe<StringNullableFilter>;
    updatedAt?: Maybe<DateTimeFilter>;
    userId?: Maybe<IntFilter>;
};

export type BundleWhereUniqueInput = {
    id?: Maybe<Scalars['Int']>;
};

export type Buyout = {
    __typename?: 'Buyout';
    /** @deprecated Use graphql __typename instead */
    action: Scalars['String'];
    remainingMonths?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    unavailableReason?: Maybe<Scalars['String']>;
};

export type BuyoutCalculation = {
    __typename?: 'BuyoutCalculation';
    marketPriceWithMarkupInCents: Scalars['Int'];
    markup: Scalars['Float'];
    requiredMonths: Scalars['Int'];
};

export type ByInvoice = PaymentMethodInterface & {
    __typename?: 'ByInvoice';
    billingAccountId?: Maybe<Scalars['String']>;
    viban?: Maybe<Scalars['String']>;
};

export type CampaignFilterInputType = {
    level?: Maybe<LevelTypes>;
    status?: Maybe<StatusTypes>;
};

export type CampaignInputType = {
    conditionUuid?: Maybe<Scalars['String']>;
    content: Scalars['AnyScalar'];
    level: LevelTypes;
    name: Scalars['String'];
    pages?: Maybe<Array<Scalars['String']>>;
    platforms?: Maybe<Array<PlatformTypes>>;
    status?: Maybe<StatusTypes>;
    stores?: Maybe<Array<Scalars['String']>>;
    type: CampaignTypes;
};

export type CampaignModel = {
    __typename?: 'CampaignModel';
    condition?: Maybe<ConditionsContentModel>;
    conditionUuid?: Maybe<Scalars['String']>;
    content?: Maybe<ContentUnionModel>;
    createdAt: Scalars['DateTime'];
    /** Returns goal entity */
    goal?: Maybe<GoalModel>;
    level: Scalars['String'];
    /** Calculates dismissed, finished and usersInCampaign metrics */
    metrics: MetricsModel;
    name: Scalars['String'];
    pages?: Maybe<Array<Scalars['String']>>;
    platforms?: Maybe<Array<PlatformTypes>>;
    status: StatusTypes;
    stores?: Maybe<Array<Scalars['String']>>;
    translate: Scalars['JSON'];
    type: CampaignTypes;
    updatedAt: Scalars['DateTime'];
    uuid: Scalars['ID'];
};

export enum CampaignTypes {
    basicMarketingCard = 'basicMarketingCard',
    hint = 'hint',
    pollCard = 'pollCard',
    subscriptionBadge = 'subscriptionBadge',
}

/** Autogenerated input type of CancelContract */
export type CancelContractInput = {
    cancellationReason: ContractCancellationReason;
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contractId: Scalars['ID'];
};

/** Autogenerated return type of CancelContract */
export type CancelContractPayload = {
    __typename?: 'CancelContractPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contract?: Maybe<Contract>;
    errors?: Maybe<Array<Scalars['String']>>;
};

export type CancelOrderEarly = {
    __typename?: 'CancelOrderEarly';
    /** @deprecated Use graphql __typename instead */
    action: Scalars['String'];
    available: Scalars['Boolean'];
};

/** Autogenerated input type of CancelOrderEarly */
export type CancelOrderEarlyInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    orderNumber: Scalars['ID'];
};

/** Autogenerated return type of CancelOrderEarly */
export type CancelOrderEarlyPayload = {
    __typename?: 'CancelOrderEarlyPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contracts: Array<Contract>;
};

export type CancelSubscription = {
    __typename?: 'CancelSubscription';
    available: Scalars['Boolean'];
};

/** Autogenerated input type of CancelSwap */
export type CancelSwapInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    orderNumber: Scalars['ID'];
};

/** Autogenerated return type of CancelSwap */
export type CancelSwapPayload = {
    __typename?: 'CancelSwapPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    error?: Maybe<SwapCancellationError>;
    swap?: Maybe<Swap>;
};

export type Card = PaymentMethodInterface & {
    __typename?: 'Card';
    billingAccountId?: Maybe<Scalars['String']>;
    brand?: Maybe<Scalars['String']>;
    lastDigits?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
};

export type CardAmount = {
    __typename?: 'CardAmount';
    currency: Scalars['String'];
    unit: CardAmountUnitTypes;
    value: Scalars['Int'];
};

export enum CardAmountUnitTypes {
    cents = 'cents',
}

export type CardBlockUnblockResult = {
    __typename?: 'CardBlockUnblockResult';
    status: CardStatus;
};

export type CardBooking = {
    __typename?: 'CardBooking';
    amount: CardAmount;
    bookingType: BookingTypes;
    date?: Maybe<Scalars['DateTime']>;
    description?: Maybe<Scalars['String']>;
    endToEndId?: Maybe<Scalars['String']>;
    id: Scalars['String'];
    loyaltyAction?: Maybe<LoyaltyFederatedBooking>;
    metaInfo?: Maybe<BookingMetaInfo>;
    recipientBic?: Maybe<Scalars['String']>;
    recipientIban?: Maybe<Scalars['String']>;
    recipientName?: Maybe<Scalars['String']>;
    returnTransactionId?: Maybe<Scalars['String']>;
    senderBic?: Maybe<Scalars['String']>;
    senderIban?: Maybe<Scalars['String']>;
    senderName?: Maybe<Scalars['String']>;
    transactionId?: Maybe<Scalars['String']>;
};

export enum CardLossReason {
    COUNTERFEIT_PLASTIC = 'COUNTERFEIT_PLASTIC',
    HOME_INVASION = 'HOME_INVASION',
    LEFT_AT_MERCHANT = 'LEFT_AT_MERCHANT',
    LOST = 'LOST',
    MAILBOX_THEFT = 'MAILBOX_THEFT',
    MAIL_ORDER = 'MAIL_ORDER',
    MISSING_AT_HOME = 'MISSING_AT_HOME',
    PICK_POCKET = 'PICK_POCKET',
    PREVENTIVE_BLOCK = 'PREVENTIVE_BLOCK',
    SUSPECTED_MERCHANT_FRAUD = 'SUSPECTED_MERCHANT_FRAUD',
}

export enum CardStatus {
    ACTIVATION_BLOCKED_BY_SOLARIS = 'ACTIVATION_BLOCKED_BY_SOLARIS',
    ACTIVE = 'ACTIVE',
    BLOCKED = 'BLOCKED',
    BLOCKED_BY_SOLARIS = 'BLOCKED_BY_SOLARIS',
    CLOSED = 'CLOSED',
    CLOSED_BY_SOLARIS = 'CLOSED_BY_SOLARIS',
    INACTIVE = 'INACTIVE',
    LOST = 'LOST',
    PROCESSING = 'PROCESSING',
    STOLEN = 'STOLEN',
}

export enum CardTransactionTypes {
    cashAtm = 'cashAtm',
    cashAtmReversal = 'cashAtmReversal',
    cashManual = 'cashManual',
    cashManualReversal = 'cashManualReversal',
    creditPresentment = 'creditPresentment',
    debitPresentment = 'debitPresentment',
    disputeTransaction = 'disputeTransaction',
    forcePostTransaction = 'forcePostTransaction',
    oct = 'oct',
    purchase = 'purchase',
    purchaseReversal = 'purchaseReversal',
}

export type CardTypeUnionModel = BasicMarketingCardModel | PollCardModel | SubscriptionBadgeModel;

export type CartAddressInput = {
    additionalInfo?: Maybe<Scalars['String']>;
    city: Scalars['String'];
    country: Scalars['String'];
    countryIso: Scalars['String'];
    id: Scalars['ID'];
    line1: Scalars['String'];
    line2?: Maybe<Scalars['String']>;
    state?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    zip: Scalars['String'];
};

export type CartOrder = {
    __typename?: 'CartOrder';
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    dashboardSubscriptions?: Maybe<SubscriptionCardConnection>;
    guestToken?: Maybe<Scalars['String']>;
    homeAddress?: Maybe<Address>;
    id: Scalars['ID'];
    lineItems: Array<FlexLineItem>;
    orderNumber: Scalars['String'];
    paymentMethod?: Maybe<PaymentMethod>;
    price: Price;
    pricingDetails?: Maybe<PricingDetails>;
    shippingAddress?: Maybe<Address>;
    step?: Maybe<Scalars['String']>;
    store: Store;
};

export type CartOrderDashboardSubscriptionsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

/** The connection type for CartOrder. */
export type CartOrderConnection = {
    __typename?: 'CartOrderConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<CartOrderEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<CartOrder>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

export type CartOrderCreateInput = {
    adjustment?: Maybe<AdjustmentInput>;
    lineItems: Array<Maybe<MixLineItemInput>>;
    orderMode?: Maybe<OrderMode>;
    shippingDetails?: Maybe<ShippingDetails>;
};

/** An edge in a connection. */
export type CartOrderEdge = {
    __typename?: 'CartOrderEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<CartOrder>;
};

export type CartOrderSubmitInput = {
    attemptReference?: Maybe<Scalars['String']>;
    billingAddress?: Maybe<CartAddressInput>;
    creditCheckAcceptedAt?: Maybe<Scalars['String']>;
    fraudCheckConsent?: Maybe<Scalars['Boolean']>;
    initiateFraudCheck?: Maybe<Scalars['Boolean']>;
    orderMode?: Maybe<OrderMode>;
    paymentMethod?: Maybe<CartPaymentMethodInput>;
    profileReference?: Maybe<Scalars['String']>;
    shippingAddress?: Maybe<CartAddressInput>;
    store?: Maybe<CartStoreInput>;
    user?: Maybe<CartUserInput>;
};

export type CartOrderUpdateInput = {
    address?: Maybe<CartAddressInput>;
    orderMode?: Maybe<OrderMode>;
    paymentMethod?: Maybe<CartPaymentMethodInput>;
    step?: Maybe<Scalars['String']>;
};

export type CartPaymentMethodInput = {
    billingAccountId: Scalars['String'];
    id: Scalars['Int'];
    type?: Maybe<Scalars['String']>;
};

export type CartStoreInput = {
    countryCode?: Maybe<Scalars['String']>;
    countryId?: Maybe<Scalars['Int']>;
    currency?: Maybe<Scalars['String']>;
    storeCode?: Maybe<Scalars['String']>;
    storeId?: Maybe<Scalars['ID']>;
    storeType?: Maybe<Scalars['String']>;
};

export type CartUserInput = {
    birthdate?: Maybe<Scalars['String']>;
    email: Scalars['String'];
    firstName: Scalars['String'];
    language?: Maybe<Scalars['String']>;
    lastName: Scalars['String'];
    phone: Scalars['String'];
    userId: Scalars['Int'];
    userType?: Maybe<Scalars['String']>;
};

export type CartVoucher = {
    __typename?: 'CartVoucher';
    code: Scalars['String'];
    discount: Price;
    recurrent: Scalars['Boolean'];
};

export type CatalogAffectedRowsOutput = {
    __typename?: 'CatalogAffectedRowsOutput';
    count: Scalars['Int'];
};

export type CatalogItem = {
    categoryId: Scalars['ID'];
    product: Product;
    productSku: Scalars['ID'];
    subCategoryId: Scalars['ID'];
};

export type CatalogItemVariant = {
    assetId?: Maybe<Scalars['String']>;
    categoryId: Scalars['ID'];
    product: Product;
    productSku: Scalars['ID'];
    subCategoryId: Scalars['ID'];
    variant: Variant;
    variantSku: Scalars['ID'];
};

export type Category = {
    __typename?: 'Category';
    children?: Maybe<Array<Category>>;
    iconSvgPath?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    parent?: Maybe<Category>;
    permalink?: Maybe<Scalars['String']>;
    productFilters?: Maybe<Array<ProductFilter>>;
    rentalPlanTests?: Maybe<Array<RentalPlanTest>>;
    /** Translated title for category */
    title?: Maybe<Scalars['String']>;
};

export type ChangePaymentMethod = {
    __typename?: 'ChangePaymentMethod';
    /** @deprecated Use subscription payment method instead */
    email?: Maybe<Scalars['String']>;
    /** @deprecated Use subscription payment method instead */
    ibanFirstDigits?: Maybe<Scalars['String']>;
    /** @deprecated Use subscription payment method instead */
    ibanLastDigits?: Maybe<Scalars['String']>;
    /** @deprecated Use subscription payment method instead */
    last4Digits?: Maybe<Scalars['String']>;
    /** @deprecated Use subscription payment method instead */
    type?: Maybe<Scalars['String']>;
};

export type ChangePinInfo = {
    cardId: Scalars['String'];
    deviceId: Scalars['String'];
    pin: Scalars['Float'];
};

export type ChangeRequestPending = {
    __typename?: 'ChangeRequestPending';
    changeRequestId: Scalars['String'];
    stringToSign: Scalars['String'];
};

export type ChangeTaxIdInfo = {
    countryCode: Scalars['String'];
    taxId: Scalars['String'];
};

export type ChangeTaxIdResult = {
    __typename?: 'ChangeTaxIdResult';
    id: Scalars['String'];
};

export type CheckProviderReport = {
    reportUrl: Scalars['String'];
    result: ProviderCheckResult;
};

export enum ColorFunctions {
    CAUTION = 'CAUTION',
    NEGATIVE = 'NEGATIVE',
    POSITIVE = 'POSITIVE',
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
}

export type ColumnOrderType = {
    column: Scalars['String'];
    order: ShippingOrderEnum;
};

export type CompaniesWhereInput = {
    and?: Maybe<Array<CompaniesWhereInput>>;
    hrv?: Maybe<StringComparisonInput>;
    id?: Maybe<IntegerComparisonInput>;
    legalRepresentativeEmail?: Maybe<StringComparisonInput>;
    name?: Maybe<StringComparisonInput>;
    size?: Maybe<CompanySizeComparisonInput>;
    status?: Maybe<StringComparisonInput>;
    ust?: Maybe<StringComparisonInput>;
};

export type Company = {
    __typename?: 'Company';
    address?: Maybe<CompanyAddress>;
    authorizedByLegalRepresentative?: Maybe<Scalars['Boolean']>;
    canPayByInvoice: Scalars['Boolean'];
    forceApprovedUser?: Maybe<User>;
    groverWorkEnabled?: Maybe<Scalars['Boolean']>;
    hrv?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    legalRepresentativeEmail?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    size?: Maybe<CompanySize>;
    status: Scalars['String'];
    type: CompanyType;
    user: User;
    ust?: Maybe<Scalars['String']>;
    verificationCheck?: Maybe<CompanyVerificationCheck>;
    viban?: Maybe<Scalars['String']>;
};

export type CompanyAddress = {
    __typename?: 'CompanyAddress';
    additionalInfo?: Maybe<Scalars['String']>;
    city: Scalars['String'];
    country: Scalars['String'];
    countryIso: Scalars['String'];
    id: Scalars['ID'];
    line1: Scalars['String'];
    line2: Scalars['String'];
    zip: Scalars['String'];
};

/** The connection type for Company. */
export type CompanyConnection = {
    __typename?: 'CompanyConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<CompanyEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<Company>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CompanyEdge = {
    __typename?: 'CompanyEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<Company>;
};

export enum CompanySize {
    /** 1-10 */
    _1 = '_1',
    /** 11-50 */
    _11 = '_11',
    /** 51-200 */
    _51 = '_51',
    /** 201-500 */
    _201 = '_201',
    /** 501-1000 */
    _501 = '_501',
    /** 1000+ */
    _1001 = '_1001',
}

export type CompanySizeComparisonInput = {
    _eq?: Maybe<CompanySize>;
    _neq?: Maybe<CompanySize>;
};

export type CompanyType = {
    __typename?: 'CompanyType';
    id: Scalars['ID'];
    individual: Scalars['Boolean'];
    name: Scalars['String'];
    ustIdRequired: Scalars['Boolean'];
};

export type CompanyVerificationCheck = CheckProviderReport & {
    __typename?: 'CompanyVerificationCheck';
    firstName: Scalars['String'];
    id: Scalars['ID'];
    lastName: Scalars['String'];
    reportUrl: Scalars['String'];
    result: ProviderCheckResult;
    verificationType: CompanyVerificationType;
};

export enum CompanyVerificationType {
    BANK_ACCOUNT_SNAPSHOT = 'BANK_ACCOUNT_SNAPSHOT',
    ID_VERIFICATION = 'ID_VERIFICATION',
}

export enum ComparisonType {
    contains = 'contains',
    endsWith = 'endsWith',
    equals = 'equals',
    gt = 'gt',
    gte = 'gte',
    in = 'in',
    lt = 'lt',
    lte = 'lte',
    not = 'not',
    notContains = 'notContains',
    notEndsWith = 'notEndsWith',
    notIn = 'notIn',
    notStartsWith = 'notStartsWith',
    startsWith = 'startsWith',
}

/** Autogenerated input type of CompleteContract */
export type CompleteContractInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contractId: Scalars['ID'];
};

/** Autogenerated return type of CompleteContract */
export type CompleteContractPayload = {
    __typename?: 'CompleteContractPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contract?: Maybe<Contract>;
};

export type Completion = Operation & {
    __typename?: 'Completion';
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    startedAt: Scalars['ISO8601DateTime'];
    startedBy: User;
    state: InboundShipmentStates;
};

export type ConditionInputType = {
    groverApi?: Maybe<GroverApiInputType>;
};

export type ConditionsContentModel = {
    __typename?: 'ConditionsContentModel';
    contractService?: Maybe<ContractServiceConditionModel>;
    groverApi?: Maybe<GroverApiConditionModel>;
};

export type ConfirmableReturnStep = BasicReturnStep & {
    __typename?: 'ConfirmableReturnStep';
    checkbox?: Maybe<Scalars['String']>;
    description: Scalars['String'];
    headline: Scalars['String'];
    name: Scalars['String'];
    warning?: Maybe<Scalars['String']>;
};

export type ContentUnionModel =
    | BasicMarketingCardContentModel
    | HintContentModel
    | PollCardContentModel
    | SubscriptionBadgeContentModel;

export type Contract = Flex | Mix;

export type ContractAction =
    | Buyout
    | CancelOrderEarly
    | PrintReturnLabel
    | ReportDamage
    | SupportRequest;

export enum ContractCancellationReason {
    CANCELLATION_BEFORE_ALLOCATION = 'CANCELLATION_BEFORE_ALLOCATION',
    DAMAGE_CLAIM = 'DAMAGE_CLAIM',
    EARLY_ORDER_CANCELLATION = 'EARLY_ORDER_CANCELLATION',
    END_OF_CYCLE_RETURN = 'END_OF_CYCLE_RETURN',
    FAILED_DELIVERY = 'FAILED_DELIVERY',
    HANDED_OVER_TO_DCA = 'HANDED_OVER_TO_DCA',
    MID_CYCLE_REPLACEMENT = 'MID_CYCLE_REPLACEMENT',
    REPLACEMENT_WITHIN_14_DAYS = 'REPLACEMENT_WITHIN_14_DAYS',
    REVOCATION = 'REVOCATION',
}

/** The connection type for Contract. */
export type ContractConnection = {
    __typename?: 'ContractConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<ContractEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<Contract>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

export type ContractDiscounts = InternalDiscount;

/** An edge in a connection. */
export type ContractEdge = {
    __typename?: 'ContractEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<Contract>;
};

export type ContractFilterInput = {
    orderNumber?: Maybe<Scalars['ID']>;
    state?: Maybe<Array<ContractState>>;
    type?: Maybe<ContractType>;
    userId?: Maybe<Scalars['ID']>;
};

export type ContractGoods = {
    contractId: Scalars['ID'];
    deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
    id: Scalars['ID'];
    returnedAt?: Maybe<Scalars['ISO8601DateTime']>;
    state: ContractGoodState;
};

export enum ContractGoodState {
    AWAITING_RETURN = 'AWAITING_RETURN',
    NEVER_SENT = 'NEVER_SENT',
    PROCESSING_RETURN = 'PROCESSING_RETURN',
    RESERVED = 'RESERVED',
    RETURN_REJECTED = 'RETURN_REJECTED',
    RETURN_SUCCEEDED = 'RETURN_SUCCEEDED',
    SHIPPING = 'SHIPPING',
    SHIPPING_FAILED = 'SHIPPING_FAILED',
    SHIPPING_RETURN = 'SHIPPING_RETURN',
    SHIPPING_RETURN_FAILED = 'SHIPPING_RETURN_FAILED',
    SOLD = 'SOLD',
    WITH_CUSTOMER = 'WITH_CUSTOMER',
}

/** Contract Payment Group Filter */
export type ContractPaymentGroupFilterInput = {
    externalContract?: Maybe<Scalars['String']>;
    externalCustomer?: Maybe<Scalars['String']>;
    status?: Maybe<PaymentGroupStatusTypes>;
};

export type ContractPaymentGroupModel = {
    __typename?: 'ContractPaymentGroupModel';
    amount: InCentsModel;
    billingDate: Scalars['DateTime'];
    dueDate: Scalars['DateTime'];
    externalContract: Scalars['String'];
    externalCustomer: Scalars['String'];
    period: Scalars['Float'];
    status: PaymentGroupStatusTypes;
    uuid: Scalars['ID'];
};

export type ContractServiceConditionModel = {
    __typename?: 'ContractServiceConditionModel';
    numberOfActiveMixContracts?: Maybe<Scalars['AnyScalar']>;
};

export type ContractServiceRecurrentModel = {
    __typename?: 'ContractServiceRecurrentModel';
    currentPeriod: Scalars['Float'];
    dueDate: Scalars['DateTime'];
    externalContract: Scalars['String'];
    externalCustomer: Scalars['String'];
    paymentGroups: Array<PaymentGroupModel>;
    recurrentPaymentUuid: Scalars['String'];
    scopeUuid?: Maybe<Scalars['String']>;
    status: RecurrentPaymentStatusTypes;
    type: Scalars['String'];
    uuid: Scalars['ID'];
};

export enum ContractState {
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    DRAFT = 'DRAFT',
    ENDED = 'ENDED',
    FULFILLING = 'FULFILLING',
    PAUSED = 'PAUSED',
    REFUSED = 'REFUSED',
}

export enum ContractTerminationReason {
    CANCELLATION_BEFORE_ALLOCATION = 'CANCELLATION_BEFORE_ALLOCATION',
    COMPLETED_BY_CUSTOMER = 'COMPLETED_BY_CUSTOMER',
    DAMAGE_CLAIM = 'DAMAGE_CLAIM',
    EARLY_ORDER_CANCELLATION = 'EARLY_ORDER_CANCELLATION',
    END_OF_CYCLE_RETURN = 'END_OF_CYCLE_RETURN',
    FAILED_DELIVERY = 'FAILED_DELIVERY',
    HANDED_OVER_TO_DCA = 'HANDED_OVER_TO_DCA',
    MID_CYCLE_REPLACEMENT = 'MID_CYCLE_REPLACEMENT',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    PURCHASED = 'PURCHASED',
    REPLACEMENT_WITHIN_14_DAYS = 'REPLACEMENT_WITHIN_14_DAYS',
    REVOCATION = 'REVOCATION',
    REVOKED = 'REVOKED',
    RISK_DECLINED = 'RISK_DECLINED',
}

export enum ContractType {
    FLEX = 'FLEX',
    MIX = 'MIX',
}

export type ContractValidationResult = ValidationResult & {
    __typename?: 'ContractValidationResult';
    valid: Scalars['Boolean'];
};

export type CopyToClipboardActionModel = {
    __typename?: 'CopyToClipboardActionModel';
    text: Scalars['String'];
    value: Scalars['String'];
};

export type CountdownTimer = {
    __typename?: 'CountdownTimer';
    createdAt: Scalars['DateTime'];
    description?: Maybe<Scalars['String']>;
    endAt: Scalars['DateTime'];
    id: Scalars['ID'];
    isActive: Scalars['Boolean'];
    name: Scalars['String'];
    products?: Maybe<Array<Product>>;
    startAt: Scalars['DateTime'];
    storeCodes: Array<Scalars['String']>;
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CountdownTimerCreateInput = {
    description?: Maybe<Scalars['String']>;
    endAt: Scalars['DateTime'];
    isActive: Scalars['Boolean'];
    name: Scalars['String'];
    products?: Maybe<Array<AssociateProductInput>>;
    startAt: Scalars['DateTime'];
    storeCodes: Array<Scalars['String']>;
};

export type CountdownTimerOrderByInput = {
    endAt?: Maybe<Scalars['DateTime']>;
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    startAt?: Maybe<Scalars['DateTime']>;
};

export type CountdownTimerPaginationOutput = {
    __typename?: 'CountdownTimerPaginationOutput';
    rows: Array<CountdownTimer>;
    totalCount: Scalars['Int'];
};

export type CountdownTimerUpdateInput = {
    description?: Maybe<Scalars['String']>;
    endAt?: Maybe<Scalars['DateTime']>;
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    startAt?: Maybe<Scalars['DateTime']>;
    storeCodes?: Maybe<Array<Scalars['String']>>;
};

export type CountdownTimerWhereInput = {
    description?: Maybe<Scalars['String']>;
    endAt?: Maybe<Scalars['DateTime']>;
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    startAt?: Maybe<Scalars['DateTime']>;
    stores?: Maybe<Array<Scalars['String']>>;
};

export type Country = {
    __typename?: 'Country';
    id: Scalars['ID'];
    iso: Scalars['String'];
    iso3: Scalars['String'];
    isoName: Scalars['String'];
    name: Scalars['String'];
    numcode: Scalars['Int'];
    statesRequired: Scalars['Boolean'];
};

/** Autogenerated input type of CreateAddress */
export type CreateAddressInput = {
    additionalInfo?: Maybe<Scalars['String']>;
    billingAddress: Scalars['Boolean'];
    city: Scalars['String'];
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    countryIso: Scalars['String'];
    line1: Scalars['String'];
    line2?: Maybe<Scalars['String']>;
    shippingAddress: Scalars['Boolean'];
    stateAbbr?: Maybe<Scalars['String']>;
    userId: Scalars['ID'];
    zip: Scalars['String'];
};

/** Autogenerated return type of CreateAddress */
export type CreateAddressPayload = {
    __typename?: 'CreateAddressPayload';
    address: Address;
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateCheckoutAttempt = {
    __typename?: 'CreateCheckoutAttempt';
    reference?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCompanyAddress */
export type CreateCompanyAddressInput = {
    additionalInfo?: Maybe<Scalars['String']>;
    city: Scalars['String'];
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    companyId: Scalars['ID'];
    countryIso: Scalars['String'];
    line1: Scalars['String'];
    line2?: Maybe<Scalars['String']>;
    stateAbbr?: Maybe<Scalars['String']>;
    zip: Scalars['String'];
};

/** Autogenerated return type of CreateCompanyAddress */
export type CreateCompanyAddressPayload = {
    __typename?: 'CreateCompanyAddressPayload';
    address: Address;
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateEmployeeInput = {
    address?: Maybe<WorkCreateAddressInput>;
    email: Scalars['String'];
    externalId?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    phone?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreatePaymentMethod */
export type CreatePaymentMethodInput = {
    cancelUrl?: Maybe<Scalars['String']>;
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    confirmUrl?: Maybe<Scalars['String']>;
    paymentGatewayId: Scalars['Int'];
    token?: Maybe<Scalars['String']>;
    transactionKeyName?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreatePaymentMethod */
export type CreatePaymentMethodPayload = {
    __typename?: 'CreatePaymentMethodPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    paymentMethod: PaymentMethod;
};

export type CreateSwapOrderInput = {
    contractId: Scalars['String'];
    orderMode?: Maybe<OrderMode>;
    replacedItem: ReplacedLineItemInput;
    replacementItem: MixLineItemInput;
    shippingAddressId?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of CreateWaitingListTicket */
export type CreateWaitingListTicketInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    slug: Scalars['String'];
};

/** Autogenerated return type of CreateWaitingListTicket */
export type CreateWaitingListTicketPayload = {
    __typename?: 'CreateWaitingListTicketPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    waitingListTicket: WaitingListTicket;
};

export type CreditorInfo = {
    __typename?: 'CreditorInfo';
    address?: Maybe<Scalars['String']>;
    city?: Maybe<Scalars['String']>;
    country?: Maybe<Scalars['String']>;
    iban: Scalars['String'];
    name?: Maybe<Scalars['String']>;
    postalCode?: Maybe<Scalars['String']>;
    state?: Maybe<Scalars['String']>;
};

export type CreditorRepresentativeInfo = {
    __typename?: 'CreditorRepresentativeInfo';
    address?: Maybe<Scalars['String']>;
    caseNumber: Scalars['String'];
    city?: Maybe<Scalars['String']>;
    country?: Maybe<Scalars['String']>;
    iban: Scalars['String'];
    name?: Maybe<Scalars['String']>;
    postalCode?: Maybe<Scalars['String']>;
    state?: Maybe<Scalars['String']>;
};

export type DashboardMixDevice = {
    __typename?: 'DashboardMixDevice';
    assetId?: Maybe<Scalars['String']>;
    category: Category;
    deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    product: Product;
    returnedAt?: Maybe<Scalars['ISO8601DateTime']>;
    serialNumber?: Maybe<Scalars['String']>;
    state: DashboardMixDeviceState;
    subCategory: Category;
    variant: Variant;
};

/** The connection type for DashboardMixDevice. */
export type DashboardMixDeviceConnection = {
    __typename?: 'DashboardMixDeviceConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<DashboardMixDeviceEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<DashboardMixDevice>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DashboardMixDeviceEdge = {
    __typename?: 'DashboardMixDeviceEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<DashboardMixDevice>;
};

export enum DashboardMixDeviceState {
    AWAITING_RETURN = 'AWAITING_RETURN',
    NEVER_SENT = 'NEVER_SENT',
    PROCESSING_RETURN = 'PROCESSING_RETURN',
    RESERVED = 'RESERVED',
    RETURN_REJECTED = 'RETURN_REJECTED',
    RETURN_SUCCEEDED = 'RETURN_SUCCEEDED',
    SHIPPING = 'SHIPPING',
    SHIPPING_FAILED = 'SHIPPING_FAILED',
    SHIPPING_RETURN = 'SHIPPING_RETURN',
    SHIPPING_RETURN_FAILED = 'SHIPPING_RETURN_FAILED',
    WITH_CUSTOMER = 'WITH_CUSTOMER',
}

export type DashboardMixSubscription = {
    __typename?: 'DashboardMixSubscription';
    activatedAt?: Maybe<Scalars['ISO8601DateTime']>;
    createdAt: Scalars['ISO8601DateTime'];
    currentSwap?: Maybe<DashboardMixSwap>;
    id: Scalars['ID'];
    mixDevice?: Maybe<DashboardMixDevice>;
    mixDevices: DashboardMixDeviceConnection;
    orderNumber: Scalars['ID'];
    payments: PaymentsUnionConnection;
    returnLabelUrl?: Maybe<Scalars['String']>;
    shipmentTrackingUrl?: Maybe<Scalars['String']>;
    state: DashboardMixSubscriptionState;
    terminatedAt?: Maybe<Scalars['ISO8601DateTime']>;
    user: User;
};

export type DashboardMixSubscriptionMixDeviceArgs = {
    id: Scalars['ID'];
};

export type DashboardMixSubscriptionMixDevicesArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    states?: Maybe<Array<Scalars['String']>>;
};

export type DashboardMixSubscriptionPaymentsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export enum DashboardMixSubscriptionState {
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    DRAFT = 'DRAFT',
    ENDED = 'ENDED',
    FULFILLING = 'FULFILLING',
    PAUSED = 'PAUSED',
    REFUSED = 'REFUSED',
}

export type DashboardMixSwap = {
    __typename?: 'DashboardMixSwap';
    cancelledAt?: Maybe<Scalars['ISO8601DateTime']>;
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    createdAt: Scalars['ISO8601DateTime'];
    expiresAt: Scalars['ISO8601DateTime'];
    id: Scalars['ID'];
    mixSubscription: DashboardMixSubscription;
    newDevice: DashboardMixDevice;
    oldDevice: DashboardMixDevice;
    orderNumber: Scalars['ID'];
    returnLabelUrl?: Maybe<Scalars['String']>;
    shipmentTrackingUrl?: Maybe<Scalars['String']>;
    shippingProgress?: Maybe<DashboardMixSwapShippingProgress>;
    state: DashboardMixSwapState;
};

export enum DashboardMixSwapShippingProgress {
    AWAITING_RETURN = 'AWAITING_RETURN',
    CHECKING_RETURN = 'CHECKING_RETURN',
    NEW_DEVICE_AWAITING_PICKUP = 'NEW_DEVICE_AWAITING_PICKUP',
    NEW_DEVICE_DELIVERED = 'NEW_DEVICE_DELIVERED',
    NEW_DEVICE_IN_TRANSIT = 'NEW_DEVICE_IN_TRANSIT',
    OLD_DEVICE_IN_TRANSIT = 'OLD_DEVICE_IN_TRANSIT',
    PROBLEM_WITH_RETURN = 'PROBLEM_WITH_RETURN',
}

export enum DashboardMixSwapState {
    CANCELLED = 'CANCELLED',
    COMPLETED = 'COMPLETED',
    EXPIRED = 'EXPIRED',
    ONGOING = 'ONGOING',
}

export type Date = {
    __typename?: 'Date';
    iso8601: Scalars['ISO8601DateTime'];
};

export type DateTimeFilter = {
    equals?: Maybe<Scalars['DateTime']>;
    gt?: Maybe<Scalars['DateTime']>;
    gte?: Maybe<Scalars['DateTime']>;
    in?: Maybe<Array<Scalars['DateTime']>>;
    lt?: Maybe<Scalars['DateTime']>;
    lte?: Maybe<Scalars['DateTime']>;
    not?: Maybe<NestedDateTimeFilter>;
    notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateUnion = Date | TimeEstimate;

export type DebtorInfo = {
    __typename?: 'DebtorInfo';
    address?: Maybe<Scalars['String']>;
    city?: Maybe<Scalars['String']>;
    country?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    postalCode?: Maybe<Scalars['String']>;
    state?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteAddresses */
export type DeleteAddressesInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of DeleteAddresses */
export type DeleteAddressesPayload = {
    __typename?: 'DeleteAddressesPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteAuthDevice */
export type DeleteAuthDeviceInput = {
    clientDeviceId: Array<Scalars['ID']>;
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of DeleteAuthDevice */
export type DeleteAuthDevicePayload = {
    __typename?: 'DeleteAuthDevicePayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteModel = {
    __typename?: 'DeleteModel';
    /** Number of rows affected */
    affected: Scalars['Float'];
};

export type DeleteProductFromCountdownTimerOutput = {
    __typename?: 'DeleteProductFromCountdownTimerOutput';
    isDeleted: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteUser */
export type DeleteUserInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    userId: Scalars['ID'];
};

/** Autogenerated return type of DeleteUser */
export type DeleteUserPayload = {
    __typename?: 'DeleteUserPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    success: Scalars['Boolean'];
};

export type DeliveryEstimates = {
    __typename?: 'DeliveryEstimates';
    from?: Maybe<Scalars['Int']>;
    to?: Maybe<Scalars['Int']>;
};

export type Discount = {
    amount: Price;
    recurring: Scalars['Boolean'];
};

export type DiscountVoucher = {
    __typename?: 'DiscountVoucher';
    active: Scalars['Boolean'];
    code: Scalars['String'];
    createdAt: Scalars['DateTime'];
    id: Scalars['Int'];
    offerId: Scalars['Int'];
    orderNumber?: Maybe<Scalars['String']>;
    productSku?: Maybe<Scalars['String']>;
    updatedAt: Scalars['DateTime'];
    used: Scalars['Boolean'];
};

export type DismissModel = {
    __typename?: 'DismissModel';
    campaignUuid: Scalars['String'];
    entity: MarketingEntityType;
    externalEntity: Scalars['String'];
    id: Scalars['ID'];
};

export type DistributionRule = {
    __typename?: 'DistributionRule';
    body?: Maybe<Scalars['String']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    deletedAt?: Maybe<Scalars['DateTime']>;
    description?: Maybe<Scalars['String']>;
    expireAt?: Maybe<Scalars['DateTime']>;
    expired: Scalars['Boolean'];
    inputType?: Maybe<DistributionRuleTypeName>;
    name?: Maybe<Scalars['String']>;
    outputType?: Maybe<Scalars['String']>;
    priority?: Maybe<Scalars['Float']>;
    relatedToUid?: Maybe<Scalars['String']>;
    stock?: Maybe<Stock>;
    type?: Maybe<DistributionRuleType>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DistributionRuleCollection = {
    __typename?: 'DistributionRuleCollection';
    count: Scalars['Float'];
    rows: Array<DistributionRule>;
};

export type DistributionRuleFilterInput = {
    inputType?: Maybe<DistributionRuleTypeName>;
    name?: Maybe<Scalars['String']>;
    outputType?: Maybe<Scalars['String']>;
    relatedToUid?: Maybe<Scalars['String']>;
    type?: Maybe<DistributionRuleType>;
    uid?: Maybe<Scalars['ID']>;
};

export type DistributionRuleInput = {
    body?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
    expireAt?: Maybe<Scalars['DateTime']>;
    inputType?: Maybe<DistributionRuleTypeName>;
    name?: Maybe<Scalars['String']>;
    outputType?: Maybe<Scalars['String']>;
    priority?: Maybe<Scalars['Float']>;
    relatedToUid?: Maybe<Scalars['String']>;
    type?: Maybe<DistributionRuleType>;
    uid?: Maybe<Scalars['ID']>;
};

export enum DistributionRuleType {
    AssetDistributionAutomatic = 'AssetDistributionAutomatic',
    AssetDistributionOnDemand = 'AssetDistributionOnDemand',
}

export enum DistributionRuleTypeName {
    Asset = 'Asset',
    AvailabilityCampaign = 'AvailabilityCampaign',
    ChangeSet = 'ChangeSet',
    CustomerAssetAllocation = 'CustomerAssetAllocation',
    JunoSpreadsheet = 'JunoSpreadsheet',
    Replacement = 'Replacement',
    ReplicationCursor = 'ReplicationCursor',
    Reservation = 'Reservation',
    ReservationAttempt = 'ReservationAttempt',
    Rule = 'Rule',
    Sku = 'Sku',
    Stock = 'Stock',
    StockVariantAvailability = 'StockVariantAvailability',
    Store = 'Store',
    StoreStockLink = 'StoreStockLink',
    StoreVariantAvailability = 'StoreVariantAvailability',
    StoreVariantAvailabilityChanges = 'StoreVariantAvailabilityChanges',
}

/** Autogenerated input type of DropUserPhoneNumber */
export type DropUserPhoneNumberInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    userId: Scalars['ID'];
};

/** Autogenerated return type of DropUserPhoneNumber */
export type DropUserPhoneNumberPayload = {
    __typename?: 'DropUserPhoneNumberPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    user: User;
};

export type Duration = {
    __typename?: 'Duration';
    unit: TimeUnit;
    value: Scalars['Int'];
};

export type EditPersonInfo = {
    address?: Maybe<AddressInfo>;
    deviceId: Scalars['String'];
    email?: Maybe<Scalars['String']>;
    employmentStatus?: Maybe<EmploymentStatus>;
};

export enum EmploymentStatus {
    APPRENTICE = 'APPRENTICE',
    EMPLOYED = 'EMPLOYED',
    FREELANCER = 'FREELANCER',
    HOUSEWORK = 'HOUSEWORK',
    MANAGEMENT = 'MANAGEMENT',
    MILITARY_OR_COMMUNITY_SERVICE = 'MILITARY_OR_COMMUNITY_SERVICE',
    PROFESSIONAL_SOLDIER = 'PROFESSIONAL_SOLDIER',
    PUBLIC_SECTOR_EMPLOYEE = 'PUBLIC_SECTOR_EMPLOYEE',
    RETIRED = 'RETIRED',
    SELF_EMPLOYED = 'SELF_EMPLOYED',
    STUDENT = 'STUDENT',
    UNEMPLOYED = 'UNEMPLOYED',
}

/** Autogenerated input type of EnableInvoicePayments */
export type EnableInvoicePaymentsInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
};

/** Autogenerated return type of EnableInvoicePayments */
export type EnableInvoicePaymentsPayload = {
    __typename?: 'EnableInvoicePaymentsPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

export type EndedNote = TextNoteInterface & {
    __typename?: 'EndedNote';
    text?: Maybe<Scalars['String']>;
};

export type EndingTerm = {
    __typename?: 'EndingTerm';
    availableAfter?: Maybe<Scalars['ISO8601DateTime']>;
    lastCommittedPeriod?: Maybe<LastCommittedPeriod>;
    timeUntilAvailable?: Maybe<Duration>;
};

export type EnergyLabel = {
    __typename?: 'EnergyLabel';
    createdAt: Scalars['DateTime'];
    energyRating: EnergyRating;
    energySpecs: Scalars['JSON'];
    id: Scalars['ID'];
    imageUrl: Scalars['String'];
    product: Product;
    productSku: Scalars['String'];
    storeCodes: Array<Scalars['String']>;
    updatedAt: Scalars['DateTime'];
};

export type EnergyLabelBulkCreateInput = {
    energyLabels: Array<EnergyLabelCreateInput>;
};

export type EnergyLabelCreateInput = {
    energyRating: Scalars['String'];
    energySpecs: Languages;
    imageUrl: Scalars['String'];
    productSku: Scalars['String'];
    storeCodes: Array<Scalars['String']>;
};

export type EnergyLabelError = GenericError & {
    __typename?: 'EnergyLabelError';
    code: Scalars['String'];
    message: Scalars['String'];
};

export type EnergyLabelOrderByInput = {
    id?: Maybe<SortOrder>;
};

export type EnergyLabelOrError = EnergyLabel | EnergyLabelError;

export type EnergyLabelPaginationOutput = {
    __typename?: 'EnergyLabelPaginationOutput';
    rows: Array<EnergyLabel>;
    totalCount: Scalars['Int'];
};

export type EnergyLabelUpdateInput = {
    energyRating?: Maybe<Scalars['String']>;
    energySpecs?: Maybe<Languages>;
    imageUrl?: Maybe<Scalars['String']>;
    productSku?: Maybe<Scalars['String']>;
    storeCodes?: Maybe<Array<Scalars['String']>>;
};

export type EnergyLabelWhereInput = {
    storeCode?: Maybe<Scalars['String']>;
};

export enum EnergyRating {
    A = 'A',
    A1 = 'A1',
    A2 = 'A2',
    A3 = 'A3',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
    G = 'G',
}

export enum EntityType {
    card = 'card',
    order = 'order',
    product = 'product',
    subscription = 'subscription',
}

export type ExportMutationResult = {
    __typename?: 'ExportMutationResult';
    fileUrl?: Maybe<Scalars['String']>;
    success: Scalars['Boolean'];
};

export type FieldReview = {
    __typename?: 'FieldReview';
    applied?: Maybe<Scalars['Boolean']>;
    currentValue: Scalars['String'];
    fieldName: Scalars['String'];
    mismatch: Scalars['Boolean'];
    previousValue?: Maybe<Scalars['String']>;
    providerValue: Scalars['String'];
    significant: Scalars['Boolean'];
};

export type FilterButton = {
    __typename?: 'FilterButton';
    filter: SubscriptionListFilter;
    title: Scalars['String'];
};

export type FindAndCountInput = {
    orderMode?: Maybe<Scalars['String']>;
    orderNumber?: Maybe<Scalars['String']>;
    storeId?: Maybe<Scalars['Int']>;
    userId?: Maybe<Scalars['Int']>;
};

export type FinishedModel = {
    __typename?: 'FinishedModel';
    campaignUuid: Scalars['String'];
    entity: MarketingEntityType;
    externalEntity: Scalars['String'];
    id: Scalars['ID'];
    result: Scalars['String'];
};

export type Flex = BasicContract & {
    __typename?: 'Flex';
    actions?: Maybe<Array<ContractAction>>;
    activatedAt?: Maybe<Scalars['ISO8601DateTime']>;
    billingAccountId: Scalars['ID'];
    billingTerms: BillingTerms;
    countryIso?: Maybe<Scalars['String']>;
    createdAt: Scalars['ISO8601DateTime'];
    currentFlow?: Maybe<Flow>;
    endingTerm: EndingTerm;
    flow?: Maybe<Flows>;
    good: FlexDevice;
    goods: Array<FlexDevice>;
    history: Array<HistoryItem>;
    id: Scalars['ID'];
    isDeviceLocked?: Maybe<Scalars['Boolean']>;
    name: Scalars['String'];
    note?: Maybe<SubscriptionNote>;
    orderNumber: Scalars['ID'];
    paymentMethod?: Maybe<PaymentMethod>;
    payments: PaymentsUnionConnection;
    purchaseTerm?: Maybe<PurchaseTerm>;
    revocationTerms?: Maybe<RevocationTerms>;
    shipmentLabels?: Maybe<Array<ShipmentLabel>>;
    state: ContractState;
    storeCode: Scalars['String'];
    terminatedAt?: Maybe<Scalars['ISO8601DateTime']>;
    terminationReason?: Maybe<ContractTerminationReason>;
    user: User;
    userId: Scalars['ID'];
};

export type FlexGoodArgs = {
    id: Scalars['ID'];
};

export type FlexGoodsArgs = {
    states?: Maybe<Array<ContractGoodState>>;
};

export type FlexPaymentsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type FlexCartLineItemMeta = LineItemMeta & {
    __typename?: 'FlexCartLineItemMeta';
    allowPurchase?: Maybe<Scalars['Boolean']>;
    allowRentalUpgrade?: Maybe<Scalars['Boolean']>;
    category?: Maybe<LineItemCategory>;
    committedMonths: Scalars['Int'];
    discountAmount?: Maybe<Scalars['Int']>;
    price: Price;
    product?: Maybe<Product>;
    total: Price;
    variant: LineItemVariant;
    voucherShare?: Maybe<Price>;
};

export type FlexDetails = Flex | SubscriptionDetails;

export type FlexDevice = CatalogItem &
    CatalogItemVariant &
    ContractGoods & {
        __typename?: 'FlexDevice';
        asset?: Maybe<AssetModel>;
        assetId?: Maybe<Scalars['String']>;
        categoryId: Scalars['ID'];
        contractId: Scalars['ID'];
        deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
        id: Scalars['ID'];
        name?: Maybe<Scalars['String']>;
        outboundShipmentLabel?: Maybe<ShipmentLabel>;
        product: Product;
        productSku: Scalars['ID'];
        returnedAt?: Maybe<Scalars['ISO8601DateTime']>;
        shipmentLabel?: Maybe<ShipmentLabel>;
        state: ContractGoodState;
        subCategoryId: Scalars['ID'];
        variant: Variant;
        variantSku: Scalars['ID'];
    };

export type FlexLineItem = {
    __typename?: 'FlexLineItem';
    coreAttribute?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    imageUrl: Scalars['String'];
    meta: FlexLineItemMeta;
    name: Scalars['String'];
    quantity?: Maybe<Scalars['Int']>;
    slug?: Maybe<Scalars['String']>;
};

export type FlexLineItemMeta = {
    __typename?: 'FlexLineItemMeta';
    minimumTermMonths: Scalars['Int'];
    price: Price;
    rentalPlans: Array<RentalPlan>;
    selectedPlan?: Maybe<RentalPlan>;
    total: Price;
    variant: Variant;
};

export enum Flow {
    CANCELLATION = 'CANCELLATION',
    COMPLETION = 'COMPLETION',
    PURCHASE = 'PURCHASE',
    REPLACEMENT = 'REPLACEMENT',
    REVOCATION = 'REVOCATION',
    SWAPPING = 'SWAPPING',
}

export type Flows = Completion | Purchase | Replacement | Revocation;

/** Autogenerated input type of ForceApprove */
export type ForceApproveInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
};

/** Autogenerated return type of ForceApprove */
export type ForceApprovePayload = {
    __typename?: 'ForceApprovePayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ForcePasswordReset */
export type ForcePasswordResetInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    userId: Scalars['ID'];
};

/** Autogenerated return type of ForcePasswordReset */
export type ForcePasswordResetPayload = {
    __typename?: 'ForcePasswordResetPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    user: User;
};

export enum Gateway {
    bankcard = 'bankcard',
    paypal = 'paypal',
    sepa = 'sepa',
}

export type GenericError = {
    code: Scalars['String'];
    message: Scalars['String'];
};

export type GetPaymentOrdersFilters = {
    billingDate?: Maybe<Scalars['DateTime']>;
    /** Contract ID  (first payment group for an order lacks contractId) */
    contractId?: Maybe<Scalars['String']>;
    contractType?: Maybe<Scalars['String']>;
    countryCode?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
    dueDate?: Maybe<Scalars['DateTime']>;
    group?: Maybe<Scalars['String']>;
    groupStrategy?: Maybe<Scalars['String']>;
    orderNumber?: Maybe<Scalars['String']>;
    paymentPurpose?: Maybe<Scalars['String']>;
    paymentType?: Maybe<PaymentOrderPaymentTypes>;
    period?: Maybe<Scalars['Float']>;
    price?: Maybe<Scalars['Money']>;
    quantity?: Maybe<Scalars['Float']>;
    scopeUuid?: Maybe<Scalars['String']>;
    shippingCost?: Maybe<Scalars['Money']>;
    status?: Maybe<PaymentGroupStatusTypes>;
    /** Tax included */
    taxIncluded?: Maybe<Scalars['Boolean']>;
    uuid?: Maybe<Scalars['ID']>;
    walletUuid?: Maybe<Scalars['String']>;
};

export type GetPaymentOrdersResponse = {
    __typename?: 'GetPaymentOrdersResponse';
    items: Array<PaymentOrderModel>;
    pageInfo: ListPageInfo;
};

export type GetPendingScaChallengesInfo = {
    cardId: Scalars['String'];
};

export type GetSmartAgentCasesInfo = {
    resolution: SmartAgentCaseResolutionEnum;
};

export type GoalInputType = {
    campaignUuid: Scalars['String'];
    conditions: Scalars['AnyScalar'];
    entityIdField: Scalars['String'];
    eventName: Scalars['String'];
    isMember: Scalars['Boolean'];
    topic: Scalars['String'];
};

export type GoalModel = {
    __typename?: 'GoalModel';
    campaignUuid: Scalars['String'];
    conditions?: Maybe<Scalars['JSON']>;
    entityIdField: Scalars['String'];
    eventName: Scalars['String'];
    isMember: Scalars['Boolean'];
    topic: Scalars['String'];
    uuid: Scalars['ID'];
};

export type Goods = FlexDevice | MixDevice;

export type GraphQlFilter = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
};

export type GraphQlFilterPaymentGroups = {
    /** Contract ID  (first payment group for an order lacks contractId) */
    contractId?: Maybe<Scalars['String']>;
    /** Either Order Number or Contract ID for old records */
    id?: Maybe<Scalars['String']>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    /** Order Number */
    orderNumber?: Maybe<Scalars['String']>;
};

export type GroupBilling = {
    __typename?: 'GroupBilling';
    chosenBillingDay?: Maybe<Scalars['Float']>;
    enabled: Scalars['Boolean'];
};

export type GroupPayment = PaymentInterface & {
    __typename?: 'GroupPayment';
    basePrice: Price;
    byInvoice: Scalars['Boolean'];
    contracts?: Maybe<ContractConnection>;
    discountableLoyaltyPrice: Price;
    discountedLoyaltyPrice: Price;
    dueDate: DateUnion;
    id: Scalars['ID'];
    invoiceNumber?: Maybe<Scalars['String']>;
    invoiceUrl?: Maybe<Scalars['String']>;
    price: Price;
    remoteId?: Maybe<Scalars['String']>;
    state: PaymentState;
};

export type GroupPaymentContractsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type GroverApiConditionModel = {
    __typename?: 'GroverApiConditionModel';
    amountOfActiveSubscriptions?: Maybe<Scalars['AnyScalar']>;
    amountOfProcessingSubscriptions?: Maybe<Scalars['AnyScalar']>;
    payment?: Maybe<GroverApiPaymentConditionModel>;
    rentsGSMDevice?: Maybe<Scalars['Boolean']>;
    rentsProductMoreThanOnce?: Maybe<Scalars['Boolean']>;
    subscription?: Maybe<GroverApiSubscriptionConditionModel>;
    userType?: Maybe<Scalars['AnyScalar']>;
};

export type GroverApiInputType = {
    amountOfActiveSubscriptions?: Maybe<Scalars['AnyScalar']>;
    amountOfProcessingSubscriptions?: Maybe<Scalars['AnyScalar']>;
    rentsGSMDevice?: Maybe<Scalars['Boolean']>;
    rentsProductMoreThanOnce?: Maybe<Scalars['Boolean']>;
    subscription?: Maybe<GroverApiSubscriptionConditionInputType>;
    userType?: Maybe<UserTypes>;
};

export type GroverApiPaymentConditionModel = {
    __typename?: 'GroverApiPaymentConditionModel';
    dateIsEstimated?: Maybe<Scalars['AnyScalar']>;
    state?: Maybe<Scalars['AnyScalar']>;
    type?: Maybe<Scalars['AnyScalar']>;
};

export type GroverApiSubscriptionConditionInputType = {
    canUpgradePlan?: Maybe<Scalars['Boolean']>;
    eligibleForReturn?: Maybe<Scalars['Boolean']>;
};

export type GroverApiSubscriptionConditionModel = {
    __typename?: 'GroverApiSubscriptionConditionModel';
    canUpgradePlan?: Maybe<Scalars['AnyScalar']>;
    eligibleForReturn?: Maybe<Scalars['AnyScalar']>;
};

export type GroverAsset = {
    __typename?: 'GroverAsset';
    activatedAt?: Maybe<Scalars['DateTime']>;
    asset?: Maybe<AssetModel>;
    /** Juno asset id */
    assetId: Scalars['ID'];
    assetStatus: WorkAssetStatus;
    brandName: Scalars['String'];
    categoryId: Scalars['String'];
    companyId: Scalars['ID'];
    contract: Contract;
    contractId: Scalars['ID'];
    createdAt: Scalars['DateTime'];
    employee?: Maybe<GroverEmployee>;
    employeeId?: Maybe<Scalars['ID']>;
    externalId: Scalars['ID'];
    /** Product name */
    name: Scalars['String'];
    orderNumber: Scalars['String'];
    price: Price;
    product: Product;
    productSku?: Maybe<Scalars['String']>;
    serialNumber?: Maybe<Scalars['String']>;
    source: Scalars['String'];
    subCategoryId: Scalars['String'];
    terminatedAt?: Maybe<Scalars['DateTime']>;
    updatedAt: Scalars['DateTime'];
    updatedBy: Scalars['ID'];
    uuid: Scalars['ID'];
    variantSku?: Maybe<Scalars['String']>;
};

export type GroverCard = {
    __typename?: 'GroverCard';
    createdAt: Scalars['DateTime'];
    deliveryEstimatedAt: Scalars['DateTime'];
    expirationDate?: Maybe<Scalars['String']>;
    id: Scalars['String'];
    internalStatus: Scalars['String'];
    maskedPan?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    pinSetAt?: Maybe<Scalars['DateTime']>;
    reissuedAt?: Maybe<Scalars['DateTime']>;
    status: Scalars['String'];
};

export type GroverEmployee = {
    __typename?: 'GroverEmployee';
    address?: Maybe<WorkAddress>;
    assets?: Maybe<Array<GroverAsset>>;
    companyId: Scalars['ID'];
    createdAt: Scalars['DateTime'];
    email: Scalars['String'];
    externalId?: Maybe<Scalars['String']>;
    monthlySubscriptionTotal: Price;
    name: Scalars['String'];
    phone?: Maybe<Scalars['String']>;
    updatedAt: Scalars['DateTime'];
    updatedBy: Scalars['ID'];
    uuid: Scalars['ID'];
};

export type HintContentModel = {
    __typename?: 'HintContentModel';
    /** Markdown template. Commonly a placeholder for translations. Example: {{thankyou}}. thankyou is a translate placeholder */
    bodyTemplate: Scalars['String'];
    uuid: Scalars['ID'];
};

export type HintModel = {
    __typename?: 'HintModel';
    /** Markdown template. Commonly a placeholder for translations. Example: {{thankyou}}. thankyou is a translate placeholder */
    bodyTemplate: Scalars['String'];
    uuid: Scalars['ID'];
};

export type HistoryItem = {
    __typename?: 'HistoryItem';
    fromState: ContractState;
    metadata: HistoryMetadata;
    timestamp: Scalars['ISO8601DateTime'];
    toState: ContractState;
};

export type HistoryMetadata = TriggerEventMetadata | UserActionMetadata;

export type IdComparisonInput = {
    _eq?: Maybe<Scalars['ID']>;
};

export enum InboundShipmentStates {
    AWAITING_RETURN = 'AWAITING_RETURN',
    COMPLETED = 'COMPLETED',
    PROCESSING_RETURN = 'PROCESSING_RETURN',
    SHIPPING_RETURN = 'SHIPPING_RETURN',
    STARTED = 'STARTED',
}

export type InCentsModel = {
    __typename?: 'InCentsModel';
    currency: Scalars['String'];
    inCents: Scalars['ID'];
};

export type IntegerComparisonInput = {
    _eq?: Maybe<Scalars['Int']>;
    _gt?: Maybe<Scalars['Int']>;
    _lt?: Maybe<Scalars['Int']>;
    _neq?: Maybe<Scalars['Int']>;
};

export type InternalDiscount = Discount & {
    __typename?: 'InternalDiscount';
    amount: Price;
    name: Scalars['String'];
    recurring: Scalars['Boolean'];
};

export type IntFilter = {
    equals?: Maybe<Scalars['Int']>;
    gt?: Maybe<Scalars['Int']>;
    gte?: Maybe<Scalars['Int']>;
    in?: Maybe<Array<Scalars['Int']>>;
    lt?: Maybe<Scalars['Int']>;
    lte?: Maybe<Scalars['Int']>;
    not?: Maybe<NestedIntFilter>;
    notIn?: Maybe<Array<Scalars['Int']>>;
};

export type Invoice = {
    __typename?: 'Invoice';
    paymentGroupId: Scalars['ID'];
    publicUrl?: Maybe<Scalars['String']>;
};

export type ItemMetaInput = {
    allowPurchase?: Maybe<Scalars['Boolean']>;
    allowRentalUpgrade?: Maybe<Scalars['Boolean']>;
    category?: Maybe<LineItemCategoryInput>;
    committedMonths?: Maybe<Scalars['Int']>;
    discountAmount?: Maybe<Scalars['Int']>;
    price?: Maybe<Scalars['Float']>;
    product?: Maybe<LineItemProductInput>;
    variant?: Maybe<LineItemVariantInput>;
};

export enum JoinType {
    AND = 'AND',
    OR = 'OR',
}

export enum JunoOrderMode {
    Flex = 'Flex',
    FlexLegacy = 'FlexLegacy',
    Mix = 'Mix',
    Swap = 'Swap',
}

export type Jwe = {
    alg: Scalars['String'];
    enc: Scalars['String'];
};

export type Jwk = {
    alg: Scalars['String'];
    e: Scalars['String'];
    kid: Scalars['String'];
    kty: Scalars['String'];
    n: Scalars['String'];
};

export type KeywordFilter = {
    __typename?: 'KeywordFilter';
    category?: Maybe<Category>;
    id: Scalars['ID'];
    label?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    position?: Maybe<Scalars['Int']>;
    storeCodes: Array<Scalars['String']>;
    type: ProductFilterType;
};

export type KeywordFilterOrError = KeywordFilter | ProductFilterError;

export type Languages = {
    de?: Maybe<Scalars['String']>;
    en?: Maybe<Scalars['String']>;
    es?: Maybe<Scalars['String']>;
    nl?: Maybe<Scalars['String']>;
};

export type LastCommittedPeriod = Period & {
    __typename?: 'LastCommittedPeriod';
    ends: Scalars['ISO8601DateTime'];
    number: Scalars['Int'];
    starts: Scalars['ISO8601DateTime'];
};

export type LaunchFlowActionModel = {
    __typename?: 'LaunchFlowActionModel';
    flow: Scalars['String'];
};

export enum LevelTypes {
    orderPayment = 'orderPayment',
    root = 'root',
    subscription = 'subscription',
    subscriptionPayment = 'subscriptionPayment',
}

export type LineItem = {
    __typename?: 'LineItem';
    id: Scalars['ID'];
    imageUrl?: Maybe<Scalars['String']>;
    minimumTermMonths: Scalars['Int'];
    name: Scalars['String'];
    price: Price;
    quantity: Scalars['Int'];
    total: Price;
    variant: Variant;
};

export type LineItemCatalogMeta = LineItemMeta & {
    __typename?: 'LineItemCatalogMeta';
    category?: Maybe<LineItemCategory>;
    product?: Maybe<Product>;
    variant: LineItemVariant;
};

export type LineItemCategory = {
    __typename?: 'LineItemCategory';
    categoryId?: Maybe<Scalars['ID']>;
    subCategoryId?: Maybe<Scalars['ID']>;
};

export type LineItemCategoryInput = {
    categoryId: Scalars['ID'];
    subCategoryId: Scalars['ID'];
};

export type LineItemMeta = {
    product?: Maybe<Product>;
    variant: LineItemVariant;
};

export type LineItemProduct = {
    __typename?: 'LineItemProduct';
    coreAttribute?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['ID']>;
    name?: Maybe<Scalars['String']>;
    sku?: Maybe<Scalars['String']>;
    slug?: Maybe<Scalars['String']>;
};

export type LineItemProductInput = {
    coreAttribute?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name?: Maybe<Scalars['String']>;
    sku: Scalars['String'];
    slug?: Maybe<Scalars['String']>;
};

export type LineItemUpdateInput = {
    id: Scalars['Int'];
    meta?: Maybe<ItemMetaInput>;
    quantity?: Maybe<Scalars['Int']>;
};

export type LineItemVariant = {
    __typename?: 'LineItemVariant';
    colorCodes?: Maybe<Array<Scalars['String']>>;
    colorTitle?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['ID']>;
    imageUrl?: Maybe<Scalars['String']>;
    mixable?: Maybe<Scalars['Boolean']>;
    sku?: Maybe<Scalars['ID']>;
};

export type LineItemVariantInput = {
    colorCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
    colorTitle?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    imageUrl?: Maybe<Scalars['String']>;
    mixable?: Maybe<Scalars['Boolean']>;
    sku: Scalars['String'];
};

export type LinkActionModel = {
    __typename?: 'LinkActionModel';
    path: Scalars['String'];
    text: Scalars['String'];
};

export type ListPageInfo = {
    __typename?: 'ListPageInfo';
    hasNextPage: Scalars['Boolean'];
    nextOffset: Scalars['Int'];
    total: Scalars['Int'];
};

export type LoopSimulatorModel = {
    __typename?: 'LoopSimulatorModel';
    externalSubscription: Scalars['String'];
    recurrentPaymentUuid: Scalars['String'];
};

export type LoyaltyActionResultBooking = {
    __typename?: 'LoyaltyActionResultBooking';
    amount: Scalars['Int'];
    id: Scalars['String'];
    person: CardBooking;
    status: LoyaltyActionStatus;
    type: LoyaltyActionType;
    uniqueKey: Scalars['String'];
    userId: Scalars['String'];
};

export type LoyaltyActionResultReservation = {
    __typename?: 'LoyaltyActionResultReservation';
    amount: Scalars['Int'];
    id: Scalars['String'];
    person: AccountReservation;
    status: LoyaltyActionStatus;
    type: LoyaltyActionType;
    uniqueKey: Scalars['String'];
    userId: Scalars['String'];
};

export enum LoyaltyActionStatus {
    CANCELLED = 'CANCELLED',
    FAILED = 'FAILED',
    NEW = 'NEW',
    PROCESSED = 'PROCESSED',
}

export enum LoyaltyActionType {
    ADD = 'ADD',
    CHARGE = 'CHARGE',
    REFUND = 'REFUND',
}

export type LoyaltyBalanceResult = {
    __typename?: 'LoyaltyBalanceResult';
    balance: Scalars['Int'];
    person: Person;
    userId: Scalars['String'];
};

export type LoyaltyCreditTransactionCaptureResult = {
    __typename?: 'LoyaltyCreditTransactionCaptureResult';
    captureId: Scalars['String'];
    userId: Scalars['String'];
};

export type LoyaltyCreditTransactionCommitInfo = {
    amount: Scalars['Int'];
    captureId: Scalars['String'];
    paymentId?: Maybe<Scalars['String']>;
};

export type LoyaltyCreditTransactionResult = {
    __typename?: 'LoyaltyCreditTransactionResult';
    amount: Scalars['Int'];
    expiresAt?: Maybe<Scalars['DateTime']>;
    externalId?: Maybe<Scalars['String']>;
    id: Scalars['String'];
    inputTransaction?: Maybe<Scalars['String']>;
    status: LoyaltyCreditTransactionStatus;
    userId: Scalars['String'];
};

export enum LoyaltyCreditTransactionStatus {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    COMPLETED = 'COMPLETED',
    OVER_LIMIT = 'OVER_LIMIT',
}

export type LoyaltyFederatedBooking = {
    __typename?: 'LoyaltyFederatedBooking';
    amount: Scalars['Int'];
    id: Scalars['String'];
    overLimitAmount: Scalars['Int'];
    person: CardBooking;
    status: LoyaltyActionStatus;
    type: LoyaltyActionType;
    uniqueKey: Scalars['String'];
    userId: Scalars['String'];
};

export type LoyaltyPredictedActionAmountResult = {
    __typename?: 'LoyaltyPredictedActionAmountResult';
    amount: Scalars['Int'];
};

export type LoyaltyReservationInfo = {
    categoryCode: Scalars['String'];
    fxRate: Scalars['Float'];
    id: Scalars['String'];
    posEntryMode: Scalars['String'];
    traceId: Scalars['String'];
    transactionType: Scalars['String'];
    value: Scalars['Float'];
};

export type LoyaltyShopProductResult = {
    __typename?: 'LoyaltyShopProductResult';
    description: Scalars['String'];
    externalId: Scalars['String'];
    id: Scalars['String'];
    price: Scalars['Int'];
    status: Scalars['String'];
    type: Scalars['String'];
};

export type LoyaltyShopPurchaseMetadataUnion = LoyaltyVoucherMetadata;

export type LoyaltyShopPurchaseResult = {
    __typename?: 'LoyaltyShopPurchaseResult';
    id: Scalars['String'];
    metadata: LoyaltyShopPurchaseMetadataUnion;
    price: Scalars['Int'];
    product: LoyaltyShopProductResult;
    productId: Scalars['String'];
    userId: Scalars['String'];
};

export type LoyaltyVoucherMetadata = {
    __typename?: 'LoyaltyVoucherMetadata';
    code: Scalars['String'];
    expirationDate: Scalars['DateTime'];
};

export type MarkCardAsLostStolenInfo = {
    cardId: Scalars['String'];
    lossReason: CardLossReason;
    lostAt: Scalars['DateTime'];
    shouldOrderReplacement: Scalars['Boolean'];
    shouldRetainPin: Scalars['Boolean'];
};

export type MarkCardAsLostStolenResult = {
    __typename?: 'MarkCardAsLostStolenResult';
    status: CardStatus;
};

export enum MarketingEntityType {
    orderPayment = 'orderPayment',
    subscription = 'subscription',
    subscriptionPayment = 'subscriptionPayment',
    user = 'user',
}

export type Merchant = {
    __typename?: 'Merchant';
    categoryCode: Scalars['String'];
    countryCode: Scalars['String'];
    name: Scalars['String'];
    town: Scalars['String'];
};

export type MetaPersonResult = {
    __typename?: 'MetaPersonResult';
    acceptedTncAt?: Maybe<Scalars['DateTime']>;
};

export type MetricsModel = {
    __typename?: 'MetricsModel';
    /** Number of users that dismissed the campaigns */
    dismissed: Scalars['Float'];
    /** Number of users that meet the campaign goal */
    finished: Scalars['Float'];
    /** Number of users that are a member of the campaign */
    usersInCampaign: Scalars['Float'];
};

export type Mix = BasicContract & {
    __typename?: 'Mix';
    actions?: Maybe<Array<ContractAction>>;
    activatedAt?: Maybe<Scalars['ISO8601DateTime']>;
    billingAccountId: Scalars['ID'];
    billingTerms: BillingTerms;
    countryIso?: Maybe<Scalars['String']>;
    createdAt: Scalars['ISO8601DateTime'];
    currentFlow?: Maybe<Flow>;
    endingTerm: EndingTerm;
    flow?: Maybe<Flows>;
    good: MixDevice;
    goods: Array<MixDevice>;
    history: Array<HistoryItem>;
    id: Scalars['ID'];
    orderNumber: Scalars['ID'];
    paymentMethod?: Maybe<PaymentMethod>;
    payments: PaymentsUnionConnection;
    revocationTerms?: Maybe<RevocationTerms>;
    shipmentLabels?: Maybe<Array<ShipmentLabel>>;
    state: ContractState;
    storeCode: Scalars['String'];
    swap: Swap;
    swappingTerms: SwappingTerms;
    swaps: Array<Swap>;
    terminatedAt?: Maybe<Scalars['ISO8601DateTime']>;
    terminationReason?: Maybe<ContractTerminationReason>;
    user: User;
    userId: Scalars['ID'];
};

export type MixGoodArgs = {
    id: Scalars['ID'];
};

export type MixGoodsArgs = {
    states?: Maybe<Array<ContractGoodState>>;
};

export type MixPaymentsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type MixSwapArgs = {
    orderNumber: Scalars['ID'];
};

export type MixSwapsArgs = {
    states?: Maybe<Array<SwapState>>;
};

export type MixCartOrder = {
    __typename?: 'MixCartOrder';
    billingAddressId?: Maybe<Scalars['Int']>;
    completedAt?: Maybe<Scalars['DateISOString']>;
    contractId?: Maybe<Scalars['String']>;
    createdAt?: Maybe<Scalars['DateISOString']>;
    currency?: Maybe<Scalars['String']>;
    estimatedTax?: Maybe<Price>;
    guestToken?: Maybe<Scalars['String']>;
    itemTotal: Price;
    itemTotalDiscount?: Maybe<Price>;
    lineItems: Array<Maybe<MixLineItem>>;
    netTotal?: Maybe<Price>;
    orderMode: OrderMode;
    orderNumber: Scalars['ID'];
    paymentMethod?: Maybe<PaymentMethodStub>;
    placedAt?: Maybe<Scalars['DateISOString']>;
    shippingAddressId?: Maybe<Scalars['Int']>;
    shippingCost?: Maybe<Price>;
    step?: Maybe<Scalars['String']>;
    storeCode?: Maybe<Scalars['String']>;
    total?: Maybe<Price>;
    vat?: Maybe<Scalars['String']>;
    vatTotal?: Maybe<Price>;
    voucher?: Maybe<CartVoucher>;
};

export type MixDevice = CatalogItem &
    CatalogItemVariant &
    ContractGoods & {
        __typename?: 'MixDevice';
        asset?: Maybe<AssetModel>;
        assetId?: Maybe<Scalars['String']>;
        categoryId: Scalars['ID'];
        contractId: Scalars['ID'];
        deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
        id: Scalars['ID'];
        name?: Maybe<Scalars['String']>;
        product: Product;
        productSku: Scalars['ID'];
        returnedAt?: Maybe<Scalars['ISO8601DateTime']>;
        shipmentLabel?: Maybe<ShipmentLabel>;
        state: ContractGoodState;
        subCategoryId: Scalars['ID'];
        swappable: Scalars['Boolean'];
        variant: Variant;
        variantSku: Scalars['ID'];
    };

export type MixDeviceSwappableArgs = {
    withProduct: ProductVariantInput;
};

/** The connection type for MixDevice. */
export type MixDeviceConnection = {
    __typename?: 'MixDeviceConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<MixDeviceEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<MixDevice>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MixDeviceEdge = {
    __typename?: 'MixDeviceEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<MixDevice>;
};

export type MixLineItem = OrderLineItem & {
    __typename?: 'MixLineItem';
    id: Scalars['ID'];
    meta: LineItemMeta;
    quantity?: Maybe<Scalars['Int']>;
};

export type MixLineItemInput = {
    meta?: Maybe<ItemMetaInput>;
    quantity?: Maybe<Scalars['Int']>;
    shippingDetails?: Maybe<ShippingDetails>;
};

export type MixSummary = {
    __typename?: 'MixSummary';
    contract: Contract;
    contractId: Scalars['ID'];
    devices: Array<MixDevice>;
    orderNumber: Scalars['ID'];
    pastDevices?: Maybe<MixDeviceConnection>;
    payments: PaymentsUnionConnection;
    state: ContractState;
    swap?: Maybe<Swap>;
};

export type MixSummaryPastDevicesArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type MixSummaryPaymentsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export enum MixSwapShippingProgress {
    AWAITING_RETURN = 'AWAITING_RETURN',
    CHECKING_RETURN = 'CHECKING_RETURN',
    NEW_DEVICE_AWAITING_PICKUP = 'NEW_DEVICE_AWAITING_PICKUP',
    NEW_DEVICE_DELIVERED = 'NEW_DEVICE_DELIVERED',
    NEW_DEVICE_IN_TRANSIT = 'NEW_DEVICE_IN_TRANSIT',
    OLD_DEVICE_IN_TRANSIT = 'OLD_DEVICE_IN_TRANSIT',
    PROBLEM_WITH_RETURN = 'PROBLEM_WITH_RETURN',
}

export type MonthsToOwn = {
    __typename?: 'MonthsToOwn';
    availableSince: Scalars['ISO8601Date'];
    monthsRequired: Scalars['Int'];
    monthsToCoverRemaining: Scalars['Int'];
};

export enum Mood {
    angry = 'angry',
    happy = 'happy',
    inLove = 'inLove',
    neutral = 'neutral',
    sad = 'sad',
}

export type MoodDatasetResults = {
    __typename?: 'MoodDatasetResults';
    data: MoodResult;
    point: Scalars['String'];
};

export type MoodOption = {
    __typename?: 'MoodOption';
    mood: Mood;
};

export type MoodOptions = {
    __typename?: 'MoodOptions';
    options: Array<MoodOption>;
};

export type MoodResult = {
    __typename?: 'MoodResult';
    angryVotes: Scalars['Int'];
    happyVotes: Scalars['Int'];
    inLoveVotes: Scalars['Int'];
    neutralVotes: Scalars['Int'];
    sadVotes: Scalars['Int'];
};

export type MoodResults = {
    __typename?: 'MoodResults';
    dataset?: Maybe<Array<MoodDatasetResults>>;
    moodResults: Array<MoodResult>;
    total: TotalResults;
};

export type Mutation = {
    __typename?: 'Mutation';
    acceptTNC: RegisterCardPersonResult;
    accountStatement: AccountStatementPdfResult;
    /** Activates physical VISA GroverCard by verification token writen on it. */
    activateCard: ActivateCardResult;
    addAccount: AccountModel;
    addPayByInvoiceAccount: AccountModel;
    addProductsToCampaign: ProductCampaign;
    addProductsToCountdownTimer: AddProductsToCountdownTimerOutput;
    allocateManually: AllocationResult;
    applyLoyaltyDiscount?: Maybe<ApplyLoyaltyDiscountPayload>;
    applySurpriseDiscount?: Maybe<ApplySurpriseDiscountPayload>;
    applyVoucher?: Maybe<MixCartOrder>;
    assignAssetsToEmployee: WorkEmployee;
    assignEmployeeToAsset: WorkAsset;
    authoriseDevice: AuthDeviceResult;
    authorizeSCAChallenge: ChangeRequestPending;
    bigMigrationCreateRecurrentPayments: BigMigrationCreateRecurrentPaymentsPayload;
    bigMigrationRevertRecurrentPayments: BigMigrationCreateRecurrentPaymentsPayload;
    blockCard: CardBlockUnblockResult;
    bumpReservationPriority: Array<Reservation>;
    cancelContract?: Maybe<CancelContractPayload>;
    cancelOrderEarly?: Maybe<CancelOrderEarlyPayload>;
    cancelPayments: Array<PaymentOrderModel>;
    cancelSwap?: Maybe<CancelSwapPayload>;
    /** Initiates Person Identificaiton process via IDNow. */
    cardPersonIdentification: PersonIdentification;
    /** Modifies person settings incl. language */
    cardPersonSettings: PersonSettings;
    castVote: Vote;
    changePin: ChangeRequestPending;
    changeTaxId: ChangeTaxIdResult;
    clearAssetEmployeeAssignment: WorkAsset;
    completeContract?: Maybe<CompleteContractPayload>;
    /** Creates a campaign action, you can add several actions for one campaign */
    createAction: UuidModel;
    createAddress?: Maybe<CreateAddressPayload>;
    createBundle?: Maybe<BundleOrError>;
    /** Creates a campaign. Please make sure that you have a proper translations for bodyTemplate */
    createCampaign: UuidModel;
    createCheckoutAttempt?: Maybe<CreateCheckoutAttempt>;
    createCompanyAddress?: Maybe<CreateCompanyAddressPayload>;
    /**
     * Creates a condition for a campaign, could be created before campaign or after,
     * but in this case you have to update conditionUuid for campaign
     */
    createCondition: UuidModel;
    createCountdownTimer: CountdownTimer;
    /** Creates a campaign goal (Kafka event handler) */
    createGoal: UuidModel;
    createManyBundles: AffectedRowsOutput;
    createOffer: Offer;
    createPaymentMethod?: Maybe<CreatePaymentMethodPayload>;
    createProductCampaign: ProductCampaign;
    createReplacement: ReplacementModel;
    createSeizurePayment: ChangeRequestPending;
    createSwapReturnShipment: SwapReturnResult;
    /** Creates a translation */
    createTranslate: UuidModel;
    createVariantFlag: VariantFlagCreateManyOutput;
    createWaitingListTicket?: Maybe<CreateWaitingListTicketPayload>;
    createWorkEmployee?: Maybe<WorkEmployee>;
    /** Deletes an action */
    deleteAction: DeleteModel;
    deleteAddresses?: Maybe<DeleteAddressesPayload>;
    deleteAuthDevice?: Maybe<DeleteAuthDevicePayload>;
    deleteAvailabilityCampaign: AvailabilityCampaign;
    deleteBundle?: Maybe<Bundle>;
    /** Deletes a campaign */
    deleteCampaign: DeleteModel;
    /** Deletes a condition */
    deleteCondition: DeleteModel;
    deleteDismiss: DeleteModel;
    /** Deletes a campaign dismiss for selected entity */
    deleteDismissCampaign: DeleteModel;
    deleteDistributionRule: Array<DistributionRule>;
    deleteFinish: DeleteModel;
    /** Deletes a finished campaign for selected entity */
    deleteFinishCampaign: DeleteModel;
    /** Deletes a campaign goal (Kafka event handler) */
    deleteGoal: DeleteModel;
    deleteManyBundles: AffectedRowsOutput;
    deleteOffer: Offer;
    deleteProductsFromCountdownTimer: DeleteProductFromCountdownTimerOutput;
    deleteReplacement: ReplacementModel;
    /** Deletes a translation */
    deleteTranslate: DeleteModel;
    deleteUser?: Maybe<DeleteUserPayload>;
    disableVoucher: DiscountVoucher;
    dismiss: DismissModel;
    /** Dismiss a campaign for selected entity */
    dismissCampaign: DismissModel;
    dropUserPhoneNumber?: Maybe<DropUserPhoneNumberPayload>;
    editPerson: ChangeRequestPending;
    enableCompanyPayByInvoice?: Maybe<EnableInvoicePaymentsPayload>;
    energyLabelCreate: EnergyLabelOrError;
    energyLabelDelete?: Maybe<EnergyLabelOrError>;
    energyLabelUpdate?: Maybe<EnergyLabelOrError>;
    energyLabelsUpsertMany: CatalogAffectedRowsOutput;
    exportShipments: ExportMutationResult;
    forceApproveCompany?: Maybe<ForceApprovePayload>;
    forcePasswordReset?: Maybe<ForcePasswordResetPayload>;
    getVotingTicket: Ticket;
    loyaltyCaptureAmount: LoyaltyCreditTransactionCaptureResult;
    loyaltyCommitCapturedTransactions: LoyaltyCreditTransactionCaptureResult;
    loyaltyReleaseCapturedTransactions: LoyaltyCreditTransactionCaptureResult;
    loyaltyShopPurchase: LoyaltyShopPurchaseResult;
    markCardAsLostStolen: MarkCardAsLostStolenResult;
    moveAssetsToStock: Array<AssetModel>;
    orderAddressAdd?: Maybe<MixCartOrder>;
    orderAddressChange?: Maybe<MixCartOrder>;
    orderCreate?: Maybe<MixCartOrder>;
    orderLineItemAdd?: Maybe<MixCartOrder>;
    orderLineItemEdit?: Maybe<MixCartOrder>;
    orderLineItemRemove?: Maybe<MixCartOrder>;
    orderLineItemsRemove?: Maybe<MixCartOrder>;
    orderOfferAccept?: Maybe<OrderOffer>;
    orderOfferCreate?: Maybe<OrderOffer>;
    orderOfferReject?: Maybe<OrderOffer>;
    orderOfferUpdate?: Maybe<OrderOffer>;
    orderOffersDelete?: Maybe<Array<Maybe<OrderOffer>>>;
    orderPaymentMethodAdd?: Maybe<MixCartOrder>;
    orderPaymentMethodChange?: Maybe<MixCartOrder>;
    orderSubmit?: Maybe<MixCartOrder>;
    orderUpdate?: Maybe<MixCartOrder>;
    paymentGroupRefund: Array<TransactionModel>;
    payoutReferenceAccount: AddReferenceAccountResult;
    productFilterKeywordCreate: KeywordFilterOrError;
    productFilterKeywordDelete: KeywordFilterOrError;
    productFilterKeywordUpdate: KeywordFilterOrError;
    productFilterRangeCreate: RangeFilterOrError;
    productFilterRangeDelete: RangeFilterOrError;
    productFilterRangeUpdate: RangeFilterOrError;
    productsWidgetCreate: ProductsWidgetOrError;
    productsWidgetDelete?: Maybe<ProductsWidgetOrError>;
    productsWidgetUpdate?: Maybe<ProductsWidgetOrError>;
    putOnHoldPayments: Array<PaymentOrderModel>;
    referenceAccount: AddReferenceAccountResult;
    refreshOfferDiscounts: Offer;
    refundPayments: Array<PaymentOrderActionResponseItem>;
    /**
     * Initiates an onboarding procedure for GroverCard. That includes creating a
     * Person entity, thier credit record and pre-paid card application.
     */
    registerCardPerson: RegisterCardPersonResult;
    registerIncomingAssets: RegisterIncomingAssetsResult;
    /** Initiates Device Binding procedure by registering mobile device by phone number and public key. */
    registerMobilePhone: RegisterMobilePhoneResult;
    removeWorkAsset: WorkAsset;
    removeWorkEmployee: WorkEmployee;
    rentalPlanTestActivate?: Maybe<RentalPlanTestOrError>;
    rentalPlanTestCreate: RentalPlanTestOrError;
    rentalPlanTestDelete?: Maybe<RentalPlanTestOrError>;
    rentalPlanTestEnd?: Maybe<RentalPlanTestOrError>;
    rentalPlanTestUpdate?: Maybe<RentalPlanTestOrError>;
    resetVerification?: Maybe<ResetVerificationPayload>;
    resetVoucher?: Maybe<MixCartOrder>;
    retryPayments: Array<PaymentOrderModel>;
    revokeContract?: Maybe<RevokeContractPayload>;
    secureCardDetails: SecureCardDetailsResult;
    /** Send pre-contractual information via email to the customer, if it has not sent before */
    sendPreContractualInformation: PreContractualInformationResult;
    /** You can set condition after a campaign creation. This is useful if you what to update campaign conditions */
    setConditionUuid: CampaignModel;
    /** Set the timestamp when the user accepts the FATCA. */
    setOwnEconomicInterestSignedAtResult: OwnEconomicInterestSignedAtResult;
    /** Set the timestamp when the user accepts the Sepa Direct Debit Mandate. */
    setSddAcceptedAt: SddAcceptedAtResult;
    smartAgentCaseUpdate: SmartAgentCasesResult;
    startPurchase?: Maybe<StartPurchasePayload>;
    startReplacement?: Maybe<StartReplacementPayload>;
    submitVerificationDecision?: Maybe<SubmitVerificationDecisionPayload>;
    swapCreate?: Maybe<MixCartOrder>;
    swapSubmit?: Maybe<MixCartOrder>;
    syncUserPaymentMethods?: Maybe<SyncUserPaymentMethodsPayload>;
    transactionRefund: TransactionModel;
    unBlockCard: CardBlockUnblockResult;
    unlockUser?: Maybe<UnlockUserPayload>;
    updateAddress?: Maybe<UpdateAddressPayload>;
    updateBundle?: Maybe<BundleOrError>;
    /** All campaigns are created with PAUSED status by default, you can change the status to ACTIVE and opposite any time */
    updateCampaignStatus: CampaignModel;
    updateCompany?: Maybe<UpdateCompanyPayload>;
    updateCompanyAddress?: Maybe<CreateCompanyAddressPayload>;
    updateCountdownTimer: CountdownTimer;
    /** Updates a notification trigger filter */
    updateNotificationTriggerFilter: NotificationTriggerFilter;
    updateOffer: Offer;
    updatePaymentMethodForContract: UpdatePaymentMethodForContractPayload;
    updateProductCampaign: ProductCampaign;
    updateSCAChallengeStatus: VerifyChangeRequestResult;
    updateSubscription?: Maybe<UpdateSubscriptionPayload>;
    /** Updates a translation */
    updateTranslate: UpdateModel;
    updateUser?: Maybe<UpdateUserPayload>;
    updateUserNewsletterOptInState?: Maybe<UpdateUserNewsletterOptInStatePayload>;
    updateUserTeams?: Maybe<UpdateUserTeamsPayload>;
    updateVariantFlag: VariantFlag;
    updateWorkAsset: WorkAsset;
    updateWorkEmployee: WorkEmployee;
    upsertAvailabilityCampaign: AvailabilityCampaign;
    upsertDistributionRule: DistributionRule;
    upsertManyBundles: AffectedRowsOutput;
    verifyChangePin: VerifyChangeRequestResult;
    verifyChangeRequest: VerifyChangeRequestResult;
    /** Finalise Device Binding process by verifying signature of SMS-TAN received after `registerMobilePhone` */
    verifyDevice: VerifyDeviceResult;
    verifyDeviceAuthorisation: VerifyDeviceAuthResult;
};

export type MutationAccountStatementArgs = {
    info: AccountStatementInfo;
};

export type MutationActivateCardArgs = {
    info: ActivateCardInfo;
};

export type MutationAddAccountArgs = {
    options: AddAccountInput;
};

export type MutationAddPayByInvoiceAccountArgs = {
    options: AddPayByInvoiceAccountInput;
};

export type MutationAddProductsToCampaignArgs = {
    addProducstToCampaignInput: AddProductsToCampaignInput;
};

export type MutationAddProductsToCountdownTimerArgs = {
    addProductsToCountdownTimerInput: AddProductsToCountdownTimerInput;
};

export type MutationAllocateManuallyArgs = {
    assetUid: Scalars['String'];
    reservationUid: Scalars['String'];
    skipReservationStatusCheck?: Maybe<Scalars['Boolean']>;
    skipSkuCheck?: Maybe<Scalars['Boolean']>;
};

export type MutationApplyLoyaltyDiscountArgs = {
    input: ApplyLoyaltyDiscountInput;
};

export type MutationApplySurpriseDiscountArgs = {
    input: ApplySurpriseDiscountInput;
};

export type MutationApplyVoucherArgs = {
    orderNumber?: Maybe<Scalars['ID']>;
    voucher?: Maybe<VoucherRedemptionInput>;
};

export type MutationAssignAssetsToEmployeeArgs = {
    assetUuids: Array<Scalars['String']>;
    employeeUuid: Scalars['String'];
};

export type MutationAssignEmployeeToAssetArgs = {
    assetUuid: Scalars['String'];
    employeeUuid: Scalars['String'];
};

export type MutationAuthoriseDeviceArgs = {
    info: AuthDeviceInfo;
};

export type MutationAuthorizeScaChallengeArgs = {
    info: AuthorizeScaChallengesInfo;
};

export type MutationBigMigrationCreateRecurrentPaymentsArgs = {
    input: BigMigrationCreateRecurrentPaymentsInput;
};

export type MutationBigMigrationRevertRecurrentPaymentsArgs = {
    input: BigMigrationCreateRecurrentPaymentsInput;
};

export type MutationBlockCardArgs = {
    info: BlockCardInfo;
};

export type MutationBumpReservationPriorityArgs = {
    orderNumber?: Maybe<Scalars['String']>;
    priority: Scalars['Float'];
    uid?: Maybe<Scalars['String']>;
};

export type MutationCancelContractArgs = {
    input: CancelContractInput;
};

export type MutationCancelOrderEarlyArgs = {
    input: CancelOrderEarlyInput;
};

export type MutationCancelPaymentsArgs = {
    payments: Array<PaymentOrdersRequest>;
};

export type MutationCancelSwapArgs = {
    input: CancelSwapInput;
};

export type MutationCardPersonIdentificationArgs = {
    info: PersonIdentificationInfo;
};

export type MutationCardPersonSettingsArgs = {
    info: PersonSettingsInfo;
};

export type MutationCastVoteArgs = {
    comment?: Maybe<Scalars['String']>;
    ticket: Scalars['String'];
    userId?: Maybe<Scalars['Int']>;
    voteSlug: Scalars['String'];
};

export type MutationChangePinArgs = {
    info: ChangePinInfo;
};

export type MutationChangeTaxIdArgs = {
    info: ChangeTaxIdInfo;
};

export type MutationClearAssetEmployeeAssignmentArgs = {
    assetUuid: Scalars['String'];
};

export type MutationCompleteContractArgs = {
    input: CompleteContractInput;
};

export type MutationCreateActionArgs = {
    action: ActionInputType;
};

export type MutationCreateAddressArgs = {
    input: CreateAddressInput;
};

export type MutationCreateBundleArgs = {
    data: BundleCreateInput;
};

export type MutationCreateCampaignArgs = {
    campaign: CampaignInputType;
};

export type MutationCreateCheckoutAttemptArgs = {
    orderNumber?: Maybe<Scalars['String']>;
    sessionId?: Maybe<Scalars['String']>;
};

export type MutationCreateCompanyAddressArgs = {
    input: CreateCompanyAddressInput;
};

export type MutationCreateConditionArgs = {
    condition: ConditionInputType;
};

export type MutationCreateCountdownTimerArgs = {
    countdownTimerCreateInput: CountdownTimerCreateInput;
};

export type MutationCreateGoalArgs = {
    goal: GoalInputType;
};

export type MutationCreateManyBundlesArgs = {
    data: BundleBulkCreateInput;
};

export type MutationCreateOfferArgs = {
    campaignName: Scalars['String'];
    externalId: Scalars['String'];
};

export type MutationCreatePaymentMethodArgs = {
    input: CreatePaymentMethodInput;
};

export type MutationCreateProductCampaignArgs = {
    productCampaignCreateInput: ProductCampaignCreateInput;
};

export type MutationCreateReplacementArgs = {
    allocationUid: Scalars['String'];
    assetUid?: Maybe<Scalars['String']>;
    reason: ReplacementReason;
};

export type MutationCreateSeizurePaymentArgs = {
    info: SeizurePaymentInfo;
};

export type MutationCreateSwapReturnShipmentArgs = {
    orderNumber: Scalars['String'];
    sync?: Maybe<Scalars['Boolean']>;
};

export type MutationCreateTranslateArgs = {
    translate: TranslateInputType;
};

export type MutationCreateVariantFlagArgs = {
    variantFlagCreateInput: Array<VariantFlagCreateInput>;
};

export type MutationCreateWaitingListTicketArgs = {
    input: CreateWaitingListTicketInput;
};

export type MutationCreateWorkEmployeeArgs = {
    createEmployeeInput: CreateEmployeeInput;
};

export type MutationDeleteActionArgs = {
    uuid: Scalars['String'];
};

export type MutationDeleteAddressesArgs = {
    input: DeleteAddressesInput;
};

export type MutationDeleteAuthDeviceArgs = {
    input: DeleteAuthDeviceInput;
};

export type MutationDeleteAvailabilityCampaignArgs = {
    AvailabilityCampaign: AvailabilityCampaignFilterInput;
};

export type MutationDeleteBundleArgs = {
    where: BundleWhereUniqueInput;
};

export type MutationDeleteCampaignArgs = {
    uuid: Scalars['String'];
};

export type MutationDeleteConditionArgs = {
    uuid: Scalars['String'];
};

export type MutationDeleteDismissArgs = {
    campaignUuid: Scalars['String'];
    externalCustomer: Scalars['String'];
};

export type MutationDeleteDismissCampaignArgs = {
    campaignUuid: Scalars['String'];
    entity: Scalars['String'];
    externalEntity: Scalars['String'];
};

export type MutationDeleteDistributionRuleArgs = {
    rule: DistributionRuleInput;
};

export type MutationDeleteFinishArgs = {
    campaignUuid: Scalars['String'];
    externalCustomer: Scalars['String'];
};

export type MutationDeleteFinishCampaignArgs = {
    campaignUuid: Scalars['String'];
    entity: Scalars['String'];
    externalEntity: Scalars['String'];
};

export type MutationDeleteGoalArgs = {
    uuid: Scalars['String'];
};

export type MutationDeleteManyBundlesArgs = {
    where?: Maybe<BundleWhereInput>;
};

export type MutationDeleteOfferArgs = {
    campaignName: Scalars['String'];
    externalId: Scalars['String'];
};

export type MutationDeleteProductsFromCountdownTimerArgs = {
    countdownTimerId: Scalars['ID'];
    productSku: Scalars['String'];
};

export type MutationDeleteReplacementArgs = {
    replacementUid: Scalars['String'];
};

export type MutationDeleteTranslateArgs = {
    uuid: Scalars['String'];
};

export type MutationDeleteUserArgs = {
    input: DeleteUserInput;
};

export type MutationDisableVoucherArgs = {
    code: Scalars['String'];
};

export type MutationDismissArgs = {
    campaignUuid: Scalars['String'];
};

export type MutationDismissCampaignArgs = {
    campaignUuid: Scalars['String'];
    entity: Scalars['String'];
    externalEntity: Scalars['String'];
};

export type MutationDropUserPhoneNumberArgs = {
    input: DropUserPhoneNumberInput;
};

export type MutationEditPersonArgs = {
    info: EditPersonInfo;
};

export type MutationEnableCompanyPayByInvoiceArgs = {
    input: EnableInvoicePaymentsInput;
};

export type MutationEnergyLabelCreateArgs = {
    data: EnergyLabelCreateInput;
};

export type MutationEnergyLabelDeleteArgs = {
    id: Scalars['Int'];
};

export type MutationEnergyLabelUpdateArgs = {
    data: EnergyLabelUpdateInput;
    id: Scalars['Int'];
};

export type MutationEnergyLabelsUpsertManyArgs = {
    data: EnergyLabelBulkCreateInput;
};

export type MutationExportShipmentsArgs = {
    filter?: Maybe<Array<ShipmentFilterType>>;
};

export type MutationForceApproveCompanyArgs = {
    input: ForceApproveInput;
};

export type MutationForcePasswordResetArgs = {
    input: ForcePasswordResetInput;
};

export type MutationGetVotingTicketArgs = {
    entityId?: Maybe<Scalars['String']>;
    entityType?: Maybe<EntityType>;
    slug: Scalars['String'];
    userId?: Maybe<Scalars['Int']>;
};

export type MutationLoyaltyCaptureAmountArgs = {
    amount: Scalars['Int'];
};

export type MutationLoyaltyCommitCapturedTransactionsArgs = {
    commitInfo: LoyaltyCreditTransactionCommitInfo;
};

export type MutationLoyaltyReleaseCapturedTransactionsArgs = {
    captureId: Scalars['String'];
};

export type MutationLoyaltyShopPurchaseArgs = {
    productId: Scalars['String'];
};

export type MutationMarkCardAsLostStolenArgs = {
    info: MarkCardAsLostStolenInfo;
};

export type MutationMoveAssetsToStockArgs = {
    assetUids: Array<Scalars['String']>;
    stockUid: Scalars['String'];
};

export type MutationOrderAddressAddArgs = {
    input?: Maybe<CartOrderUpdateInput>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationOrderAddressChangeArgs = {
    input?: Maybe<CartOrderUpdateInput>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationOrderCreateArgs = {
    order?: Maybe<CartOrderCreateInput>;
};

export type MutationOrderLineItemAddArgs = {
    item?: Maybe<MixLineItemInput>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationOrderLineItemEditArgs = {
    item: LineItemUpdateInput;
    orderNumber: Scalars['ID'];
};

export type MutationOrderLineItemRemoveArgs = {
    itemId?: Maybe<Scalars['Int']>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationOrderLineItemsRemoveArgs = {
    itemIds: Array<Scalars['Int']>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationOrderOfferAcceptArgs = {
    offerAccept?: Maybe<OrderOfferAcceptInput>;
};

export type MutationOrderOfferCreateArgs = {
    offer?: Maybe<OrderOfferCreateInput>;
};

export type MutationOrderOfferRejectArgs = {
    id?: Maybe<Scalars['Int']>;
};

export type MutationOrderOfferUpdateArgs = {
    offerUpdate?: Maybe<OrderOfferUpdateInput>;
};

export type MutationOrderOffersDeleteArgs = {
    ids: Array<Scalars['Int']>;
};

export type MutationOrderPaymentMethodAddArgs = {
    input?: Maybe<CartOrderUpdateInput>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationOrderPaymentMethodChangeArgs = {
    input?: Maybe<CartOrderUpdateInput>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationOrderSubmitArgs = {
    input?: Maybe<CartOrderSubmitInput>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationOrderUpdateArgs = {
    orderNumber?: Maybe<Scalars['ID']>;
    step?: Maybe<Scalars['String']>;
};

export type MutationPaymentGroupRefundArgs = {
    amount: Scalars['Float'];
    paymentGroupUuid: Scalars['String'];
};

export type MutationPayoutReferenceAccountArgs = {
    info: PayoutReferenceAccountInfo;
};

export type MutationProductFilterKeywordCreateArgs = {
    data: ProductFilterKeywordCreateInput;
};

export type MutationProductFilterKeywordDeleteArgs = {
    id: Scalars['Int'];
};

export type MutationProductFilterKeywordUpdateArgs = {
    data: ProductFilterKeywordUpdateInput;
    id: Scalars['Int'];
};

export type MutationProductFilterRangeCreateArgs = {
    data: ProductFilterRangeCreateInput;
};

export type MutationProductFilterRangeDeleteArgs = {
    id: Scalars['Int'];
};

export type MutationProductFilterRangeUpdateArgs = {
    data: ProductFilterRangeUpdateInput;
    id: Scalars['Int'];
};

export type MutationProductsWidgetCreateArgs = {
    data: ProductsWidgetCreateInput;
};

export type MutationProductsWidgetDeleteArgs = {
    id: Scalars['Int'];
};

export type MutationProductsWidgetUpdateArgs = {
    data: ProductsWidgetUpdateInput;
    id: Scalars['Int'];
};

export type MutationPutOnHoldPaymentsArgs = {
    payments: Array<PaymentOrdersRequest>;
};

export type MutationReferenceAccountArgs = {
    info: ReferenceAccountInfo;
};

export type MutationRefreshOfferDiscountsArgs = {
    campaignName: Scalars['String'];
};

export type MutationRefundPaymentsArgs = {
    payments: Array<PaymentOrderRefundRequest>;
};

export type MutationRegisterCardPersonArgs = {
    info: RegisterCardPersonInfo;
};

export type MutationRegisterIncomingAssetsArgs = {
    purchaseRequestItemName: Scalars['String'];
    serialNumbers: Array<Scalars['String']>;
};

export type MutationRegisterMobilePhoneArgs = {
    info: RegisterMobilePhoneInfo;
};

export type MutationRemoveWorkAssetArgs = {
    uuid: Scalars['String'];
};

export type MutationRemoveWorkEmployeeArgs = {
    uuid: Scalars['String'];
};

export type MutationRentalPlanTestActivateArgs = {
    id: Scalars['Int'];
};

export type MutationRentalPlanTestCreateArgs = {
    data: RentalPlanTestCreateInput;
};

export type MutationRentalPlanTestDeleteArgs = {
    id: Scalars['Int'];
};

export type MutationRentalPlanTestEndArgs = {
    id: Scalars['Int'];
};

export type MutationRentalPlanTestUpdateArgs = {
    data: RentalPlanTestUpdateInput;
    id: Scalars['Int'];
};

export type MutationResetVerificationArgs = {
    input: ResetVerificationInput;
};

export type MutationResetVoucherArgs = {
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationRetryPaymentsArgs = {
    payments: Array<PaymentOrderRetryRequest>;
};

export type MutationRevokeContractArgs = {
    input: RevokeContractInput;
};

export type MutationSecureCardDetailsArgs = {
    info: SecureCardDetailsInfo;
};

export type MutationSetConditionUuidArgs = {
    conditionUuid: Scalars['String'];
    uuid: Scalars['String'];
};

export type MutationSmartAgentCaseUpdateArgs = {
    info: SmartAgentCasesInfo;
};

export type MutationStartPurchaseArgs = {
    input: StartPurchaseInput;
};

export type MutationStartReplacementArgs = {
    input: StartReplacementInput;
};

export type MutationSubmitVerificationDecisionArgs = {
    input: SubmitVerificationDecisionInput;
};

export type MutationSwapCreateArgs = {
    order?: Maybe<CreateSwapOrderInput>;
};

export type MutationSwapSubmitArgs = {
    input?: Maybe<CartOrderSubmitInput>;
    orderNumber?: Maybe<Scalars['ID']>;
};

export type MutationSyncUserPaymentMethodsArgs = {
    input: SyncUserPaymentMethodsInput;
};

export type MutationTransactionRefundArgs = {
    amount: Scalars['Float'];
    currency: Scalars['String'];
    transactionUuid: Scalars['String'];
};

export type MutationUnBlockCardArgs = {
    info: UnBlockCardInfo;
};

export type MutationUnlockUserArgs = {
    input: UnlockUserInput;
};

export type MutationUpdateAddressArgs = {
    input: UpdateAddressInput;
};

export type MutationUpdateBundleArgs = {
    data: BundleUpdateInput;
    where: BundleWhereUniqueInput;
};

export type MutationUpdateCampaignStatusArgs = {
    status: StatusTypes;
    uuid: Scalars['String'];
};

export type MutationUpdateCompanyArgs = {
    input: UpdateCompanyInput;
};

export type MutationUpdateCompanyAddressArgs = {
    input: CreateCompanyAddressInput;
};

export type MutationUpdateCountdownTimerArgs = {
    countdownTimerUpdateInput: CountdownTimerUpdateInput;
    id: Scalars['ID'];
};

export type MutationUpdateNotificationTriggerFilterArgs = {
    trigger: NotificationTriggerFilterUpdateInput;
    uuid: Scalars['ID'];
};

export type MutationUpdateOfferArgs = {
    campaignName: Scalars['String'];
    externalId: Scalars['String'];
};

export type MutationUpdatePaymentMethodForContractArgs = {
    input: UpdatePaymentMethodForContractInput;
};

export type MutationUpdateProductCampaignArgs = {
    id: Scalars['ID'];
    productCampaignUpdateInput: ProductCampaignUpdateInput;
};

export type MutationUpdateScaChallengeStatusArgs = {
    info: UpdateScaChallengesInfo;
};

export type MutationUpdateSubscriptionArgs = {
    input: UpdateSubscriptionInput;
};

export type MutationUpdateTranslateArgs = {
    translate: TranslateUpdateInputType;
    uuid: Scalars['String'];
};

export type MutationUpdateUserArgs = {
    input: UpdateUserInput;
};

export type MutationUpdateUserNewsletterOptInStateArgs = {
    input: UpdateUserNewsletterOptInStateInput;
};

export type MutationUpdateUserTeamsArgs = {
    input: UpdateUserTeamsInput;
};

export type MutationUpdateVariantFlagArgs = {
    id: Scalars['ID'];
    variantFlagUpdateInput: VariantFlagUpdateInput;
};

export type MutationUpdateWorkAssetArgs = {
    updateAssetInput: UpdateAssetInput;
};

export type MutationUpdateWorkEmployeeArgs = {
    updateEmployeeInput: UpdateEmployeeInput;
};

export type MutationUpsertAvailabilityCampaignArgs = {
    AvailabilityCampaign: AvailabilityCampaignUpsertInput;
};

export type MutationUpsertDistributionRuleArgs = {
    rule: DistributionRuleInput;
};

export type MutationUpsertManyBundlesArgs = {
    data: BundleBulkCreateInput;
};

export type MutationVerifyChangePinArgs = {
    info: VerifyChangePinInfo;
};

export type MutationVerifyChangeRequestArgs = {
    info: VerifyChangeRequestInfo;
};

export type MutationVerifyDeviceArgs = {
    info: VerifyDeviceInfo;
};

export type MutationVerifyDeviceAuthorisationArgs = {
    info: VerifyDeviceAuthInfo;
};

export type NestedBoolFilter = {
    equals?: Maybe<Scalars['Boolean']>;
    not?: Maybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
    equals?: Maybe<Scalars['DateTime']>;
    gt?: Maybe<Scalars['DateTime']>;
    gte?: Maybe<Scalars['DateTime']>;
    in?: Maybe<Array<Scalars['DateTime']>>;
    lt?: Maybe<Scalars['DateTime']>;
    lte?: Maybe<Scalars['DateTime']>;
    not?: Maybe<NestedDateTimeFilter>;
    notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type NestedIntFilter = {
    equals?: Maybe<Scalars['Int']>;
    gt?: Maybe<Scalars['Int']>;
    gte?: Maybe<Scalars['Int']>;
    in?: Maybe<Array<Scalars['Int']>>;
    lt?: Maybe<Scalars['Int']>;
    lte?: Maybe<Scalars['Int']>;
    not?: Maybe<NestedIntFilter>;
    notIn?: Maybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
    contains?: Maybe<Scalars['String']>;
    endsWith?: Maybe<Scalars['String']>;
    equals?: Maybe<Scalars['String']>;
    gt?: Maybe<Scalars['String']>;
    gte?: Maybe<Scalars['String']>;
    in?: Maybe<Array<Scalars['String']>>;
    lt?: Maybe<Scalars['String']>;
    lte?: Maybe<Scalars['String']>;
    not?: Maybe<NestedStringFilter>;
    notIn?: Maybe<Array<Scalars['String']>>;
    startsWith?: Maybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
    contains?: Maybe<Scalars['String']>;
    endsWith?: Maybe<Scalars['String']>;
    equals?: Maybe<Scalars['String']>;
    gt?: Maybe<Scalars['String']>;
    gte?: Maybe<Scalars['String']>;
    in?: Maybe<Array<Scalars['String']>>;
    lt?: Maybe<Scalars['String']>;
    lte?: Maybe<Scalars['String']>;
    not?: Maybe<NestedStringNullableFilter>;
    notIn?: Maybe<Array<Scalars['String']>>;
    startsWith?: Maybe<Scalars['String']>;
};

export type NethoneOrder = {
    __typename?: 'NethoneOrder';
    createdAt?: Maybe<Scalars['DateTime']>;
    orderNumber?: Maybe<Scalars['String']>;
    sessionId?: Maybe<Scalars['String']>;
    userId?: Maybe<Scalars['String']>;
};

export type NextPaymentNote = {
    __typename?: 'NextPaymentNote';
    date?: Maybe<Scalars['ISO8601DateTime']>;
    paymentMethod?: Maybe<PaymentMethod>;
};

export type Node = {
    id: Scalars['ID'];
};

export enum NotificationChannel {
    EMAIL = 'EMAIL',
    PUSH = 'PUSH',
    SMS = 'SMS',
}

export type NotificationEnrichMapping = {
    __typename?: 'NotificationEnrichMapping';
    createdAt: Scalars['DateTime'];
    enrichType: Scalars['String'];
    mapping: Scalars['JSON'];
    updatedAt: Scalars['DateTime'];
    uuid: Scalars['ID'];
};

export type NotificationSendResult = Node & {
    __typename?: 'NotificationSendResult';
    address: Scalars['String'];
    body?: Maybe<Scalars['String']>;
    channel: NotificationChannel;
    correlation: Scalars['String'];
    createdAt: Scalars['DateTime'];
    enrichContext: Scalars['JSON'];
    enrichType: Scalars['String'];
    id: Scalars['ID'];
    reason?: Maybe<Scalars['String']>;
    status: NotificationSendResultStatus;
    template: Scalars['String'];
    triggerFilter?: Maybe<NotificationTriggerFilter>;
    updatedAt: Scalars['DateTime'];
    user?: Maybe<User>;
    userId: Scalars['String'];
};

export enum NotificationSendResultStatus {
    FAILED = 'FAILED',
    SKIPPED = 'SKIPPED',
    SUCCESS = 'SUCCESS',
}

export type NotificationTriggerFilter = {
    __typename?: 'NotificationTriggerFilter';
    channels: Array<NotificationChannel>;
    conditions: Scalars['JSON'];
    createdAt: Scalars['DateTime'];
    deferInSeconds: Scalars['Float'];
    enrichMapping?: Maybe<NotificationEnrichMapping>;
    enrichType: Scalars['String'];
    id: Scalars['ID'];
    name: Scalars['String'];
    status: NotificationTriggerFilterStatus;
    template: Scalars['String'];
    thirtyDayVolume: Scalars['Int'];
    totalSent: Scalars['Int'];
    updatedAt: Scalars['DateTime'];
};

export type NotificationTriggerFilterListInput = {
    channel?: Maybe<NotificationChannel>;
    name?: Maybe<Scalars['String']>;
    status?: Maybe<NotificationTriggerFilterStatus>;
};

export enum NotificationTriggerFilterStatus {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
}

export type NotificationTriggerFilterUpdateInput = {
    name?: Maybe<Scalars['String']>;
    status?: Maybe<NotificationTriggerFilterStatus>;
};

export type Offer = {
    __typename?: 'Offer';
    campaignName: Scalars['String'];
    createdAt: Scalars['DateTime'];
    discounts: Array<DiscountVoucher>;
    externalId: Scalars['String'];
    id: Scalars['Int'];
    updatedAt: Scalars['DateTime'];
};

export type OffsetPaginationInput = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
};

export type OnboardingStatusResult = {
    __typename?: 'OnboardingStatusResult';
    cardStatus: Scalars['String'];
};

export type OnfidoCheck = CheckProviderReport & {
    __typename?: 'OnfidoCheck';
    reportUrl: Scalars['String'];
    result: ProviderCheckResult;
};

export type Operation = {
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    startedAt: Scalars['ISO8601DateTime'];
    startedBy: User;
};

export type Order = {
    __typename?: 'Order';
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    discountAmount: Price;
    guestToken?: Maybe<Scalars['String']>;
    homeAddress?: Maybe<Address>;
    id: Scalars['ID'];
    itemsTotal: Price;
    lineItems: Array<LineItem>;
    number: Scalars['String'];
    price: Price;
    shippingAddress?: Maybe<Address>;
    shippingPrice: Price;
    step?: Maybe<Scalars['String']>;
    store: Store;
};

export enum OrderByDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export type OrderFulfillment = {
    __typename?: 'OrderFulfillment';
    createdAt: Scalars['DateTime'];
    deletedAt?: Maybe<Scalars['DateTime']>;
    lifecycleEvents?: Maybe<Array<OrderFulfillmentLifecycleEvent>>;
    orderAssets?: Maybe<Scalars['String']>;
    orderMode?: Maybe<Scalars['String']>;
    orderNumber: Scalars['String'];
    orderShipments?: Maybe<Scalars['String']>;
    state: OrderFulfillmentState;
    storeCode?: Maybe<Scalars['String']>;
    storeCountryCode?: Maybe<Scalars['String']>;
    storeCountryId?: Maybe<Scalars['Int']>;
    storeId?: Maybe<Scalars['Int']>;
    storeType?: Maybe<Scalars['String']>;
    uid: Scalars['ID'];
    updatedAt: Scalars['DateTime'];
    userId: Scalars['String'];
    userType?: Maybe<Scalars['String']>;
};

export type OrderFulfillmentCollection = {
    __typename?: 'OrderFulfillmentCollection';
    rows: Array<OrderFulfillment>;
    totalCount: Scalars['Int'];
};

export type OrderFulfillmentLifecycleEvent = {
    __typename?: 'OrderFulfillmentLifecycleEvent';
    aggregationUpdate?: Maybe<Scalars['String']>;
    createdAt: Scalars['DateTime'];
    deletedAt?: Maybe<Scalars['DateTime']>;
    description?: Maybe<Scalars['String']>;
    metadata?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    orderNumber: Scalars['String'];
    sourceEntityUid?: Maybe<Scalars['ID']>;
    timestamp: Scalars['DateTime'];
    uid: Scalars['ID'];
    updatedAt: Scalars['DateTime'];
};

export enum OrderFulfillmentState {
    AllocationFulfilled = 'AllocationFulfilled',
    AllocationPartiallyFulfilled = 'AllocationPartiallyFulfilled',
    AllocationPending = 'AllocationPending',
    Initial = 'Initial',
    ShipmentsCancelled = 'ShipmentsCancelled',
    ShipmentsCreated = 'ShipmentsCreated',
    ShipmentsDelivered = 'ShipmentsDelivered',
    ShipmentsFailedToDeliver = 'ShipmentsFailedToDeliver',
    ShipmentsInTransit = 'ShipmentsInTransit',
    ShipmentsPartiallyCancelled = 'ShipmentsPartiallyCancelled',
    ShipmentsPartiallyDelivered = 'ShipmentsPartiallyDelivered',
    ShipmentsPartiallyFailedToDeliver = 'ShipmentsPartiallyFailedToDeliver',
    ShipmentsPartiallyInTransit = 'ShipmentsPartiallyInTransit',
    ShipmentsReadyForPickupByReceiver = 'ShipmentsReadyForPickupByReceiver',
    WarehouseOrderAccepted = 'WarehouseOrderAccepted',
    WarehouseOrderSent = 'WarehouseOrderSent',
}

export type OrderLineItem = {
    id: Scalars['ID'];
    quantity?: Maybe<Scalars['Int']>;
};

export enum OrderMode {
    FLEX = 'FLEX',
    MIX = 'MIX',
    SWAP = 'SWAP',
}

export type OrderOffer = {
    __typename?: 'OrderOffer';
    assetsCount?: Maybe<Scalars['Int']>;
    assetsTotal?: Maybe<Scalars['Float']>;
    companyAccount: User;
    createdAt: Scalars['DateISOString'];
    expiresIn?: Maybe<Scalars['DateISOString']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    order?: Maybe<MixCartOrder>;
    owner: User;
    rejectedBy?: Maybe<User>;
    status: OrderOfferStatus;
    updatedAt?: Maybe<Scalars['DateISOString']>;
    waitingFor?: Maybe<Scalars['Int']>;
};

export type OrderOfferAcceptInput = {
    companyId: Scalars['Int'];
    id: Scalars['Int'];
    orderPlacementInput: CartOrderSubmitInput;
};

export type OrderOfferCreateInput = {
    companyAccountId: Scalars['Int'];
    name: Scalars['String'];
    storeCode: Scalars['String'];
};

export type OrderOfferEdge = {
    __typename?: 'OrderOfferEdge';
    cursor: Scalars['String'];
    node?: Maybe<Array<Maybe<OrderOffer>>>;
};

export type OrderOfferFiltersInput = {
    companyAccountId?: Maybe<Scalars['Int']>;
    createdAt?: Maybe<Scalars['DateISOString']>;
    expiresIn?: Maybe<Scalars['DateISOString']>;
    name?: Maybe<Scalars['String']>;
    orderNumber?: Maybe<Scalars['String']>;
    ownerId?: Maybe<Scalars['Int']>;
    status?: Maybe<OrderOfferStatus>;
    updatedAt?: Maybe<Scalars['DateISOString']>;
};

export type OrderOffersConnection = {
    __typename?: 'OrderOffersConnection';
    edges?: Maybe<OrderOfferEdge>;
    matchingCount?: Maybe<Scalars['Int']>;
    nodes?: Maybe<Array<Maybe<OrderOffer>>>;
    pageInfo?: Maybe<PageInfo>;
    totalCount?: Maybe<Scalars['Int']>;
};

export enum OrderOfferStatus {
    ACCEPTED = 'ACCEPTED',
    ACTIVE = 'ACTIVE',
    DRAFT = 'DRAFT',
    EXPIRED = 'EXPIRED',
    REJECTED = 'REJECTED',
}

export type OrderOfferUpdateInput = {
    companyAccountId?: Maybe<Scalars['Int']>;
    id: Scalars['Int'];
    name?: Maybe<Scalars['String']>;
    status?: Maybe<OrderOfferStatus>;
};

export type OrderPayment = PaymentInterface & {
    __typename?: 'OrderPayment';
    basePrice: Price;
    byInvoice: Scalars['Boolean'];
    discountableLoyaltyPrice: Price;
    discountedLoyaltyPrice: Price;
    dueDate: DateUnion;
    id: Scalars['ID'];
    invoiceNumber?: Maybe<Scalars['String']>;
    invoiceUrl?: Maybe<Scalars['String']>;
    marketingOrderPaymentData: Array<HintModel>;
    order: OrderUnion;
    price: Price;
    remoteId?: Maybe<Scalars['String']>;
    state: PaymentState;
};

export type OrdersFilterInput = {
    cancellable: Scalars['Boolean'];
};

export type OrderUnion = MixCartOrder | Order;

export type OriginalAmount = {
    __typename?: 'OriginalAmount';
    currency: Scalars['String'];
    fxRate: Scalars['Float'];
    value: Scalars['Int'];
};

export enum Os {
    ANDROID = 'ANDROID',
    IOS = 'IOS',
    LINUX = 'LINUX',
    MAC_OS = 'MAC_OS',
    OTHER = 'OTHER',
    WINDOWS = 'WINDOWS',
}

export type OwnEconomicInterestSignedAtResult = {
    __typename?: 'OwnEconomicInterestSignedAtResult';
    ownEconomicInterestSignedAt: Scalars['DateTime'];
};

export type PackageItem = {
    __typename?: 'PackageItem';
    allocationUid?: Maybe<Scalars['String']>;
    assetAllocation?: Maybe<AssetAllocation>;
    assetUid?: Maybe<Scalars['String']>;
    contractId?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    orderNumber?: Maybe<Scalars['String']>;
    quantity: Scalars['Float'];
    salesforceAssetId?: Maybe<Scalars['String']>;
    serialNumber?: Maybe<Scalars['String']>;
    shipment?: Maybe<Shipment>;
    shipmentUid?: Maybe<Scalars['String']>;
    skuVariant?: Maybe<Scalars['String']>;
    uid: Scalars['ID'];
    variant?: Maybe<Variant>;
};

export type PackageItemCollection = {
    __typename?: 'PackageItemCollection';
    count: Scalars['Float'];
    rows: Array<PackageItem>;
};

export type PackageItemFilter = {
    contractId?: Maybe<Scalars['String']>;
    orderNumber?: Maybe<Scalars['String']>;
    shipmentUid?: Maybe<Scalars['String']>;
    skuVariant?: Maybe<Scalars['String']>;
    uid?: Maybe<Scalars['String']>;
};

export type PageInfo = {
    __typename?: 'PageInfo';
    endCursor?: Maybe<Scalars['String']>;
    hasNextPage: Scalars['Boolean'];
    hasPreviousPage: Scalars['Boolean'];
    startCursor?: Maybe<Scalars['String']>;
};

export type PaginationInput = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
};

export type PaginationInputType = {
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type PausedNote = TextNoteInterface & {
    __typename?: 'PausedNote';
    text?: Maybe<Scalars['String']>;
};

export type PaymentAccount = {
    __typename?: 'PaymentAccount';
    deleted?: Maybe<Scalars['Boolean']>;
    id?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    walletUuid?: Maybe<Scalars['String']>;
};

export type PaymentAmount = {
    currency: Scalars['String'];
    unit: Scalars['String'];
    value: Scalars['Float'];
};

export type PaymentDetails = {
    __typename?: 'PaymentDetails';
    account: PaymentAccount;
    gateway: Scalars['String'];
    reference: Scalars['String'];
};

export type PaymentGateway = {
    __typename?: 'PaymentGateway';
    flowType: PaymentGatewayFlowType;
    id: Scalars['ID'];
    meta?: Maybe<PaymentGatewayMeta>;
    name: Scalars['String'];
    type: PaymentGatewayType;
};

export enum PaymentGatewayFlowType {
    CREDIT_CARD = 'CREDIT_CARD',
    REDIRECT = 'REDIRECT',
}

export type PaymentGatewayMeta = {
    __typename?: 'PaymentGatewayMeta';
    provider?: Maybe<Scalars['String']>;
    publicKey?: Maybe<Scalars['String']>;
};

export enum PaymentGatewayType {
    BANKCARD = 'BANKCARD',
    PAYPAL = 'PAYPAL',
    SEPA = 'SEPA',
}

export type PaymentGroupModel = {
    __typename?: 'PaymentGroupModel';
    amountPaid: Scalars['Money'];
    billingDate: Scalars['String'];
    currency: Scalars['String'];
    dueDate: Scalars['String'];
    invoice?: Maybe<Invoice>;
    paymentModifiers: Array<PaymentModifierModel>;
    paymentOrders: Array<PaymentOrderModel>;
    scopeUuid?: Maybe<Scalars['String']>;
    status: PaymentGroupStatusTypes;
    total: Scalars['Money'];
    transactions: Array<TransactionModel>;
    uuid: Scalars['ID'];
    wallet: WalletModel;
    walletUuid: Scalars['String'];
};

export type PaymentGroupsModel = {
    __typename?: 'PaymentGroupsModel';
    group: Scalars['ID'];
    modifiers: Array<PaymentModifierModel>;
    paymentOrders: Array<PaymentOrderModel>;
    scopeUuid?: Maybe<Scalars['String']>;
    status: PaymentGroupStatusTypes;
    transactions: Array<TransactionModel>;
    wallet: WalletModel;
    walletUuid: Scalars['String'];
};

export enum PaymentGroupStatusTypes {
    cancelled = 'cancelled',
    failed = 'failed',
    new = 'new',
    paid = 'paid',
    partialPaid = 'partialPaid',
    partialRefund = 'partialRefund',
    pending = 'pending',
    refund = 'refund',
}

export type PaymentInterface = {
    basePrice: Price;
    discountableLoyaltyPrice: Price;
    discountedLoyaltyPrice: Price;
    invoiceUrl?: Maybe<Scalars['String']>;
    price: Price;
    remoteId?: Maybe<Scalars['String']>;
    state: PaymentState;
};

export type PaymentMethod = ByInvoice | Card | Paypal | Sepa;

export type PaymentMethodInterface = {
    billingAccountId?: Maybe<Scalars['String']>;
};

export type PaymentMethodPresenter = {
    __typename?: 'PaymentMethodPresenter';
    /** @deprecated Use ChangePaymentMethod instead */
    action: Scalars['String'];
    /** @deprecated Use ChangePaymentMethod instead */
    email?: Maybe<Scalars['String']>;
    /** @deprecated Use subscription payment method instead */
    ibanFirstDigits?: Maybe<Scalars['String']>;
    /** @deprecated Use subscription payment method instead */
    ibanLastDigits?: Maybe<Scalars['String']>;
    /** @deprecated Use ChangePaymentMethod instead */
    last4Digits?: Maybe<Scalars['String']>;
    /** @deprecated Use ChangePaymentMethod instead */
    type?: Maybe<Scalars['String']>;
};

export type PaymentMethodStub = {
    __typename?: 'PaymentMethodStub';
    billingAccountId?: Maybe<Scalars['ID']>;
    paymentMethodId?: Maybe<Scalars['ID']>;
};

export type PaymentModifierModel = {
    __typename?: 'PaymentModifierModel';
    amount: Scalars['Money'];
    currency: Scalars['String'];
    description?: Maybe<Scalars['String']>;
    group: Scalars['String'];
    type: Scalars['String'];
    unit: Scalars['String'];
    uuid: Scalars['ID'];
};

export type PaymentOrderActionResponseItem = {
    __typename?: 'PaymentOrderActionResponseItem';
    accountFrom?: Maybe<Scalars['String']>;
    accountTo?: Maybe<Scalars['String']>;
    amount: Scalars['Money'];
    createdAt: Scalars['DateTime'];
    currency: Scalars['String'];
    failedReason?: Maybe<Scalars['String']>;
    gatewayResponse?: Maybe<Scalars['JSON']>;
    parent?: Maybe<Scalars['String']>;
    paymentOrderUuid: Scalars['String'];
    status: Scalars['String'];
    type: Scalars['String'];
    uuid: Scalars['ID'];
};

export type PaymentOrderHistoryResponse = {
    __typename?: 'PaymentOrderHistoryResponse';
    count: Scalars['Int'];
    history: Array<PaymentOrderModel>;
};

export type PaymentOrderModel = {
    __typename?: 'PaymentOrderModel';
    additionalData?: Maybe<Scalars['JSON']>;
    amount: Scalars['Money'];
    attempts?: Maybe<Array<Scalars['DateTime']>>;
    billingDate: Scalars['DateTime'];
    contractId?: Maybe<Scalars['String']>;
    contractType: Scalars['String'];
    countryCode: Scalars['String'];
    currency: Scalars['String'];
    description?: Maybe<Scalars['String']>;
    dueDate: Scalars['DateTime'];
    group: Scalars['String'];
    groupStrategy: Scalars['String'];
    lineItems?: Maybe<Array<Scalars['JSON']>>;
    orderNumber?: Maybe<Scalars['String']>;
    paymentDetails: PaymentDetails;
    paymentGroup: PaymentGroupModel;
    paymentPurpose?: Maybe<Scalars['String']>;
    paymentType: PaymentOrderPaymentTypes;
    period?: Maybe<Scalars['Float']>;
    price: Scalars['Money'];
    quantity: Scalars['Float'];
    scopeUuid?: Maybe<Scalars['String']>;
    shippingCost: Scalars['Money'];
    status: PaymentGroupStatusTypes;
    taxIncluded: Scalars['Boolean'];
    uuid: Scalars['ID'];
    walletUuid: Scalars['String'];
};

export enum PaymentOrderPaymentTypes {
    purchase = 'purchase',
    shipping = 'shipping',
    subscription = 'subscription',
}

export type PaymentOrderRefundRequest = {
    amount: Scalars['Float'];
    currency: Scalars['String'];
    id: Scalars['String'];
    reason: Scalars['String'];
    transactionUuid: Scalars['String'];
};

export type PaymentOrderRetryRequest = {
    currency: Scalars['String'];
    id: Scalars['String'];
    reason: Scalars['String'];
    retryDate: Scalars['String'];
};

export type PaymentOrdersRequest = {
    currency: Scalars['String'];
    id: Scalars['String'];
    reason: Scalars['String'];
};

export type PaymentOrderTotals = {
    __typename?: 'PaymentOrderTotals';
    totalAmountDue: Array<PaymentOrderTotalStat>;
    totalAmountPaid: Array<PaymentOrderTotalStat>;
    totalAmountPlan: Array<PaymentOrderTotalStat>;
};

export type PaymentOrderTotalStat = {
    __typename?: 'PaymentOrderTotalStat';
    amount: Scalars['String'];
    currency: Scalars['String'];
};

export type PaymentsFilterInput = {
    groupPaymentId?: Maybe<Scalars['ID']>;
    state?: Maybe<Array<PaymentState>>;
    subscriptionId?: Maybe<Scalars['ID']>;
};

export enum PaymentState {
    DUE = 'DUE',
    FAILED = 'FAILED',
    PAID = 'PAID',
    SCHEDULED = 'SCHEDULED',
}

export type PaymentsUnion = GroupPayment | OrderPayment | PurchasePayment | SubscriptionPayment;

/** The connection type for PaymentsUnion. */
export type PaymentsUnionConnection = {
    __typename?: 'PaymentsUnionConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<PaymentsUnionEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<PaymentsUnion>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PaymentsUnionEdge = {
    __typename?: 'PaymentsUnionEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<PaymentsUnion>;
};

export type PayoutReferenceAccountInfo = {
    amount: PaymentAmount;
    description: Scalars['String'];
};

export type Paypal = PaymentMethodInterface & {
    __typename?: 'Paypal';
    billingAccountId?: Maybe<Scalars['String']>;
    email: Scalars['String'];
};

export type Period = {
    ends: Scalars['ISO8601DateTime'];
    number: Scalars['Int'];
    starts: Scalars['ISO8601DateTime'];
};

export type Person = {
    __typename?: 'Person';
    accountBalance?: Maybe<PersonAccountBalance>;
    accountDetails?: Maybe<PersonAccountDetails>;
    address: PersonAddress;
    birthdate?: Maybe<Scalars['DateTime']>;
    bookings: Array<CardBooking>;
    cards: Array<GroverCard>;
    email?: Maybe<Scalars['String']>;
    employmentStatus?: Maybe<Scalars['String']>;
    firstName: Scalars['String'];
    identification?: Maybe<PersonIdentification>;
    lastName: Scalars['String'];
    loyaltyBalance: LoyaltyBalanceResult;
    mobilePhone: PersonMobilePhone;
    nationality?: Maybe<Scalars['String']>;
    ownEconomicInterestSignedAt?: Maybe<Scalars['DateTime']>;
    postBoxItems: Array<PostBoxItem>;
    referenceAccount?: Maybe<ReferenceAccountResult>;
    reservations: Array<AccountReservation>;
    sddAcceptedAt?: Maybe<Scalars['DateTime']>;
    sddMandates: Array<SddMandate>;
    statements: Array<Statement>;
    taxInfo?: Maybe<TaxInfoResult>;
    userId: Scalars['String'];
};

export type PersonBookingsArgs = {
    info: BookingsInfo;
};

export type PersonPostBoxItemsArgs = {
    info: PostBoxItemsInfo;
};

export type PersonReservationsArgs = {
    info: BookingsInfo;
};

export type PersonAccountBalance = {
    __typename?: 'PersonAccountBalance';
    availableBalance: Scalars['Float'];
    currency: Scalars['String'];
    unit: Scalars['String'];
};

export type PersonAccountDetails = {
    __typename?: 'PersonAccountDetails';
    bic: Scalars['String'];
    closureReasons?: Maybe<Array<Scalars['String']>>;
    iban: Scalars['String'];
    lockingReasons?: Maybe<Array<Scalars['String']>>;
    lockingStatus?: Maybe<Scalars['String']>;
    status: Scalars['String'];
};

export type PersonAddress = {
    __typename?: 'PersonAddress';
    city: Scalars['String'];
    country?: Maybe<Scalars['String']>;
    line1: Scalars['String'];
    line2?: Maybe<Scalars['String']>;
    postalCode: Scalars['String'];
    state?: Maybe<Scalars['String']>;
};

export type PersonalIdentification = {
    __typename?: 'PersonalIdentification';
    identificationNumber: Scalars['String'];
    identificationSubType?: Maybe<PersonalIdentificationSubType>;
    identificationType: PersonalIdentificationType;
    user: User;
};

export enum PersonalIdentificationSubType {
    DNI = 'DNI',
    NIE = 'NIE',
}

export enum PersonalIdentificationType {
    NATIONAL_ID = 'NATIONAL_ID',
}

export type PersonIdentification = {
    __typename?: 'PersonIdentification';
    completedAt: Scalars['String'];
    id: Scalars['String'];
    language: Scalars['String'];
    reference: Scalars['String'];
    status: Scalars['String'];
    url: Scalars['String'];
};

export type PersonIdentificationInfo = {
    acceptedTncAt: Scalars['DateTime'];
};

export type PersonMobilePhone = {
    __typename?: 'PersonMobilePhone';
    id?: Maybe<Scalars['String']>;
    number?: Maybe<Scalars['String']>;
    verified?: Maybe<Scalars['Boolean']>;
};

export type PersonSettings = {
    __typename?: 'PersonSettings';
    language: Scalars['String'];
};

export type PersonSettingsInfo = {
    language: Scalars['String'];
};

export type PlanVisibilityTest = {
    name: Scalars['String'];
    visibility: Array<Scalars['Int']>;
};

export enum Platform {
    CHROME = 'CHROME',
    EDGE = 'EDGE',
    FIREFOX = 'FIREFOX',
    GROVER_APP = 'GROVER_APP',
    OTHER = 'OTHER',
    SAFARI = 'SAFARI',
}

export enum PlatformTypes {
    app = 'app',
    web = 'web',
}

export type Poll = {
    __typename?: 'Poll';
    activeVersion?: Maybe<PollVersion>;
    description: Scalars['String'];
    id: Scalars['ID'];
    mode: PollMode;
    name: Scalars['String'];
    pollVersions?: Maybe<Array<PollVersion>>;
    slug: Scalars['String'];
    version?: Maybe<PollVersion>;
};

export type PollVersionArgs = {
    version: Scalars['Int'];
};

export type PollCardCommentStepModel = {
    __typename?: 'PollCardCommentStepModel';
    body: Scalars['String'];
    buttonLabel: Scalars['String'];
    title: Scalars['String'];
};

export type PollCardContentModel = {
    __typename?: 'PollCardContentModel';
    actions?: Maybe<Array<ActionUnionModel>>;
    copy: PollCardCopyModel;
    pollSlug: Scalars['String'];
    uuid: Scalars['ID'];
};

export type PollCardCopyModel = {
    __typename?: 'PollCardCopyModel';
    commentStep: PollCardCommentStepModel;
    negativeOutcome: PollCardItemModel;
    positiveOutcome: PollCardItemModel;
    voteStep: PollCardItemModel;
};

export type PollCardItemModel = {
    __typename?: 'PollCardItemModel';
    body: Scalars['String'];
    title: Scalars['String'];
};

export type PollCardModel = {
    __typename?: 'PollCardModel';
    actions?: Maybe<Array<ActionUnionModel>>;
    copy: PollCardCopyModel;
    pollSlug: Scalars['String'];
    uuid: Scalars['ID'];
};

export enum PollMode {
    mood = 'mood',
    singleChoice = 'singleChoice',
    thumbs = 'thumbs',
}

export type PollOptions = MoodOptions | SingleChoiceOptions | ThumbsOptions;

export type PollResults = MoodResults | SingleChoiceResults | ThumbsResults;

export type PollsFilterInput = {
    mode?: Maybe<Scalars['String']>;
};

export type PollVersion = {
    __typename?: 'PollVersion';
    createdAt: Scalars['DateTime'];
    description: Scalars['String'];
    id: Scalars['ID'];
    options: PollOptions;
    poll: Poll;
    results?: Maybe<PollResults>;
    version: Scalars['Int'];
};

export type PollVersionResultsArgs = {
    groupByDate?: Maybe<VoteGroupByDate>;
    where?: Maybe<VoteWhereInput>;
};

export enum PosEntryModeTypes {
    cardNotPresent = 'cardNotPresent',
    chip = 'chip',
    contactless = 'contactless',
    credentialOnFile = 'credentialOnFile',
    eCommerce = 'eCommerce',
    magStripe = 'magStripe',
    manualPanEntry = 'manualPanEntry',
    unknown = 'unknown',
}

export type PostBoxDocument = {
    __typename?: 'PostBoxDocument';
    contentType: Scalars['String'];
    date: Scalars['DateTime'];
    id: Scalars['String'];
    size: Scalars['Float'];
    type: PostBoxDocumentType;
};

export type PostBoxDocumentDownloadInfo = {
    id: Scalars['String'];
};

export type PostBoxDocumentDownloadResult = {
    __typename?: 'PostBoxDocumentDownloadResult';
    contentType: Scalars['String'];
    encodedContent: Scalars['String'];
};

export enum PostBoxDocumentType {
    accountStatement = 'accountStatement',
    assetsAcquisition = 'assetsAcquisition',
    assetsAcquisitionCost = 'assetsAcquisitionCost',
    balanceConfirmation = 'balanceConfirmation',
    customerInformation = 'customerInformation',
    depotStatement = 'depotStatement',
    depotStatementMIFID = 'depotStatementMIFID',
    dunningInformation = 'dunningInformation',
    exPostCostInformation = 'exPostCostInformation',
    loanSchedule = 'loanSchedule',
    profitTaxStatement = 'profitTaxStatement',
    securitiesEvent = 'securitiesEvent',
    securitiesEventNotification = 'securitiesEventNotification',
    securitiesInvoice = 'securitiesInvoice',
    taxSettlementCalculation = 'taxSettlementCalculation',
    yearlyTaxStatement = 'yearlyTaxStatement',
}

export type PostBoxItem = {
    __typename?: 'PostBoxItem';
    createdAt: Scalars['DateTime'];
    customerConfirmation: Scalars['Boolean'];
    customerNotification: Scalars['Boolean'];
    description?: Maybe<Scalars['String']>;
    document: PostBoxDocument;
    id: Scalars['String'];
    name?: Maybe<Scalars['String']>;
};

export type PostBoxItemsCreatedAtFilter = {
    gte?: Maybe<Scalars['DateTime']>;
    lte?: Maybe<Scalars['DateTime']>;
};

export type PostBoxItemsFilter = {
    createdAt?: Maybe<PostBoxItemsCreatedAtFilter>;
};

export type PostBoxItemsInfo = {
    filter?: Maybe<PostBoxItemsFilter>;
    page: Scalars['Float'];
    perPage?: Maybe<Scalars['Float']>;
};

export type PreContractualInformationResult = {
    __typename?: 'PreContractualInformationResult';
    preContractualInfoSentAt: Scalars['DateTime'];
};

export enum PredicateType {
    date = 'date',
    number = 'number',
    string = 'string',
}

export type Preorder = {
    __typename?: 'Preorder';
    endDate: Scalars['DateTime'];
    id: Scalars['ID'];
    startDate: Scalars['DateTime'];
    storeCodes: Array<Scalars['String']>;
    variantSkus: Array<Scalars['String']>;
    variants: Array<Variant>;
};

export type Price = {
    __typename?: 'Price';
    currency: Scalars['String'];
    inCents: Scalars['Int'];
};

export type PriceInput = {
    currency: Scalars['String'];
    inCents: Scalars['Int'];
};

export type PricingDetails = {
    __typename?: 'PricingDetails';
    discountAmount: Price;
    itemsTotal: Price;
    shippingPrice: Price;
    voucherCode?: Maybe<Scalars['String']>;
};

export type PrintReturnLabel = {
    __typename?: 'PrintReturnLabel';
    /** @deprecated Use grapql __typename instead */
    action: Scalars['String'];
    remainingMonths?: Maybe<Scalars['String']>;
    unavailableReason?: Maybe<Scalars['String']>;
};

export type ProcessingNote = TextNoteInterface & {
    __typename?: 'ProcessingNote';
    text?: Maybe<Scalars['String']>;
};

export type Product = {
    __typename?: 'Product';
    accessories?: Maybe<Array<Scalars['String']>>;
    available: Scalars['Boolean'];
    brandName: Scalars['String'];
    bundle?: Maybe<Bundle>;
    buyoutCalculation: BuyoutCalculation;
    category: Category;
    cloudinaryId: Scalars['String'];
    coreAttribute?: Maybe<Scalars['String']>;
    countdownTimers?: Maybe<Array<CountdownTimer>>;
    energyLabel?: Maybe<EnergyLabel>;
    highlight?: Maybe<ProductHighlight>;
    id: Scalars['ID'];
    imageUrl: Scalars['String'];
    isNew: Scalars['Boolean'];
    marketPrice: Price;
    name: Scalars['String'];
    originalImageUrl: Scalars['String'];
    originalPictures: Array<Scalars['String']>;
    productCampaigns?: Maybe<Array<ProductCampaign>>;
    promotionalLabel?: Maybe<Scalars['String']>;
    rentalPlans: Array<RentalPlan>;
    returnSteps: Array<ReturnSteps>;
    sku: Scalars['ID'];
    slug: Scalars['String'];
    specifications?: Maybe<Scalars['JSON']>;
    variants: Array<Variant>;
};

export type ProductBuyoutCalculationArgs = {
    monthlyPriceInCents: Scalars['Int'];
    oneTimeDiscountInCents: Scalars['Int'];
    recurrentDiscountInCents: Scalars['Int'];
};

export type ProductCampaign = {
    __typename?: 'ProductCampaign';
    createdAt: Scalars['DateTime'];
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    isActive: Scalars['Boolean'];
    name: Scalars['String'];
    products?: Maybe<Array<Product>>;
    storeCodes: Array<Scalars['String']>;
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductCampaignCreateInput = {
    description?: Maybe<Scalars['String']>;
    isActive: Scalars['Boolean'];
    name: Scalars['String'];
    products?: Maybe<Array<AssociateProductInput>>;
    storeCodes: Array<Scalars['String']>;
};

export type ProductCampaignOrderByInput = {
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
};

export type ProductCampaignPaginationOutput = {
    __typename?: 'ProductCampaignPaginationOutput';
    rows: Array<ProductCampaign>;
    totalCount: Scalars['Int'];
};

export type ProductCampaignUpdateInput = {
    description?: Maybe<Scalars['String']>;
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    storeCodes?: Maybe<Array<Scalars['String']>>;
};

export type ProductCampaignWhereInput = {
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    storeCodes?: Maybe<Array<Scalars['String']>>;
};

export type ProductFilter = KeywordFilter | RangeFilter;

export type ProductFilterError = GenericError & {
    __typename?: 'ProductFilterError';
    code: Scalars['String'];
    message: Scalars['String'];
};

export type ProductFilterKeywordCreateInput = {
    categoryId: Scalars['String'];
    label?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    position?: Maybe<Scalars['Int']>;
    storeCodes: Array<Scalars['String']>;
};

export type ProductFilterKeywordUpdateInput = {
    categoryId?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    position?: Maybe<Scalars['Int']>;
    storeCodes?: Maybe<Array<Scalars['String']>>;
};

export type ProductFilterOrderByInput = {
    id?: Maybe<SortOrder>;
    position?: Maybe<SortOrder>;
};

export type ProductFilterRangeConfigCreateInput = {
    bucketMax?: Maybe<Scalars['Float']>;
    bucketMin?: Maybe<Scalars['Float']>;
    bucketSize?: Maybe<Scalars['Float']>;
    unit?: Maybe<Scalars['String']>;
};

export type ProductFilterRangeCreateInput = {
    categoryId: Scalars['String'];
    label?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    position?: Maybe<Scalars['Int']>;
    rangeFilterConfig: ProductFilterRangeConfigCreateInput;
    storeCodes: Array<Scalars['String']>;
};

export type ProductFilterRangeUpdateInput = {
    categoryId?: Maybe<Scalars['String']>;
    label?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    position?: Maybe<Scalars['Int']>;
    rangeFilterConfig?: Maybe<ProductFilterRangeConfigCreateInput>;
    storeCodes?: Maybe<Array<Scalars['String']>>;
};

export enum ProductFilterType {
    KEYWORD = 'KEYWORD',
    RANGE = 'RANGE',
}

export type ProductFilterWhereInput = {
    categoryId?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['Int']>;
    label?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    storeCodes?: Maybe<Array<Scalars['String']>>;
    type?: Maybe<ProductFilterType>;
};

export type ProductHighlight = {
    __typename?: 'ProductHighlight';
    categoryId?: Maybe<Scalars['Int']>;
    id: Scalars['ID'];
    storeCode: Scalars['String'];
    trial?: Maybe<Scalars['Boolean']>;
};

export type ProductsWhereInput = {
    slugs?: Maybe<Array<Scalars['String']>>;
};

export type ProductsWidget = {
    __typename?: 'ProductsWidget';
    active: Scalars['Boolean'];
    countdown?: Maybe<CountdownTimer>;
    createdAt?: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    position: Scalars['Float'];
    productSkus: Array<Scalars['String']>;
    products?: Maybe<Array<Product>>;
    properties?: Maybe<Scalars['JSON']>;
    storeCodes: Array<Scalars['String']>;
    type: WidgetType;
    updatedAt?: Maybe<Scalars['DateTime']>;
    url?: Maybe<Scalars['String']>;
};

export type ProductsWidgetProductsArgs = {
    storeCode?: Maybe<Scalars['String']>;
};

export type ProductsWidgetCreateInput = {
    active?: Maybe<Scalars['Boolean']>;
    name: Scalars['String'];
    position?: Maybe<Scalars['Float']>;
    productSkus?: Maybe<Array<Scalars['String']>>;
    properties?: Maybe<WidgetProperties>;
    storeCodes: Array<Scalars['String']>;
    type: Scalars['String'];
    url?: Maybe<Scalars['String']>;
};

export type ProductsWidgetError = GenericError & {
    __typename?: 'ProductsWidgetError';
    code: Scalars['String'];
    message: Scalars['String'];
};

export type ProductsWidgetOrderByInput = {
    id?: Maybe<SortOrder>;
    name?: Maybe<SortOrder>;
    position?: Maybe<SortOrder>;
};

export type ProductsWidgetOrError = ProductsWidget | ProductsWidgetError;

export type ProductsWidgetPaginationOutput = {
    __typename?: 'ProductsWidgetPaginationOutput';
    rows: Array<ProductsWidget>;
    totalCount: Scalars['Int'];
};

export type ProductsWidgetUpdateInput = {
    active?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    position?: Maybe<Scalars['Float']>;
    productSkus?: Maybe<Array<Scalars['String']>>;
    properties?: Maybe<WidgetProperties>;
    storeCodes?: Maybe<Array<Scalars['String']>>;
    type?: Maybe<Scalars['String']>;
    url?: Maybe<Scalars['String']>;
};

export type ProductsWidgetWhereInput = {
    active?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    storeCode?: Maybe<Scalars['String']>;
    type?: Maybe<WidgetType>;
};

export type ProductVariantInput = {
    categoryId: Scalars['ID'];
    productSku: Scalars['ID'];
    subCategoryId: Scalars['ID'];
    variantSku: Scalars['ID'];
};

export type ProductWhereInput = {
    id?: Maybe<IntegerComparisonInput>;
    sku?: Maybe<StringComparisonInput>;
    slug?: Maybe<StringComparisonInput>;
};

export enum ProviderCheckResult {
    CLEAR = 'CLEAR',
    CONSIDER = 'CONSIDER',
}

export type Purchase = Operation & {
    __typename?: 'Purchase';
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    startedAt: Scalars['ISO8601DateTime'];
    startedBy: User;
    state: PurchaseState;
};

export type PurchasePayment = PaymentInterface & {
    __typename?: 'PurchasePayment';
    basePrice: Price;
    contract?: Maybe<Contract>;
    datePaid?: Maybe<Scalars['ISO8601DateTime']>;
    discountableLoyaltyPrice: Price;
    discountedLoyaltyPrice: Price;
    dueDate: DateUnion;
    id: Scalars['ID'];
    invoiceUrl?: Maybe<Scalars['String']>;
    price: Price;
    remoteId?: Maybe<Scalars['String']>;
    state: PaymentState;
    /** @deprecated Use Contract field */
    subscriptionDetails?: Maybe<SubscriptionDetails>;
};

export type PurchaseRequest = {
    __typename?: 'PurchaseRequest';
    name?: Maybe<Scalars['String']>;
    purchaseOrderNumber?: Maybe<Scalars['String']>;
    salesforceId?: Maybe<Scalars['String']>;
};

export type PurchaseRequestItem = {
    __typename?: 'PurchaseRequestItem';
    name?: Maybe<Scalars['String']>;
    salesforceId?: Maybe<Scalars['String']>;
};

export enum PurchaseState {
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    STARTED = 'STARTED',
}

export type PurchaseTerm = {
    __typename?: 'PurchaseTerm';
    currentPrice: Price;
    monthsRequired: Scalars['Int'];
    remainingMonths: Scalars['Int'];
};

export type Query = {
    __typename?: 'Query';
    /** Returns marketing data for the user level */
    MarketingContent: Array<CardTypeUnionModel>;
    assetAllocationCollection: AssetAllocationCollection;
    assetAllocations: Array<AssetAllocation>;
    assetCapitalSources: Array<Scalars['String']>;
    assetSuppliers: Array<Scalars['String']>;
    assets: AssetCollection;
    availabilityCampaigns: AvailabilityCampaignCollection;
    bundle?: Maybe<Bundle>;
    bundles: BundlePaginationOutput;
    /** Returns a campaign by uuid */
    campaign: CampaignModel;
    /** Returns all campaigns, can be filtered and paginated (default limit 100) */
    campaignList: Array<CampaignModel>;
    cart?: Maybe<MixCartOrder>;
    categories?: Maybe<Array<Category>>;
    category?: Maybe<Category>;
    checkoutAttempt?: Maybe<NethoneOrder>;
    companies?: Maybe<CompanyConnection>;
    company?: Maybe<Company>;
    companyTypes: Array<CompanyType>;
    contract: Contract;
    contractPaymentGroups: Array<ContractPaymentGroupModel>;
    contractRecurrentPayment: ContractServiceRecurrentModel;
    contracts?: Maybe<ContractConnection>;
    dashboardGroupPayment?: Maybe<GroupPayment>;
    dashboardMixSubscription?: Maybe<DashboardMixSubscription>;
    discount: DiscountVoucher;
    distributionRules: DistributionRuleCollection;
    energyLabel?: Maybe<EnergyLabel>;
    energyLabels: EnergyLabelPaginationOutput;
    findAllCountdownTimers: CountdownTimerPaginationOutput;
    /** Returns last 100 campaign dismisses */
    findAllDismisses: Array<DismissModel>;
    /** Returns last 100 finished campaigns */
    findAllFinished: Array<FinishedModel>;
    findAllProductCampaigns: ProductCampaignPaginationOutput;
    findAllVariantFlags: VariantFlagPaginationOutput;
    findCountdownTimerById?: Maybe<CountdownTimer>;
    findProductCampaignById?: Maybe<ProductCampaign>;
    findVariantFlagById?: Maybe<VariantFlag>;
    getAllPaymentStats: PaymentOrderTotals;
    getAllPayments: GetPaymentOrdersResponse;
    getPaymentById: PaymentOrderModel;
    getPaymentOrderCancelReasons: Array<Reason>;
    getPaymentOrderHistory: PaymentOrderHistoryResponse;
    getPaymentOrderHoldReasons: Array<Reason>;
    getPaymentOrderRefundReasons: Array<Reason>;
    getPaymentOrderRetryReasons: Array<Reason>;
    getVote: Vote;
    loyaltyActionList: Array<LoyaltyActionResultBooking>;
    loyaltyBalance: LoyaltyBalanceResult;
    loyaltyCreditTransactionList: Array<LoyaltyCreditTransactionResult>;
    loyaltyPredictedActionAmount: LoyaltyPredictedActionAmountResult;
    loyaltyShopProductList: Array<LoyaltyShopProductResult>;
    loyaltyShopPurchaseList: Array<LoyaltyShopPurchaseResult>;
    /** Returns additional person data, not bound to Solaris Bank person */
    metaPerson: MetaPersonResult;
    notificationSendResult?: Maybe<NotificationSendResult>;
    notificationSendResults: SendResultConnection;
    /** Returns notification trigger filter by uuid */
    notificationTriggerFilter: NotificationTriggerFilter;
    /** Returns all notification trigger filters */
    notificationTriggerFilters: Array<NotificationTriggerFilter>;
    offer: Offer;
    onboardingStatus: OnboardingStatusResult;
    order?: Maybe<CartOrder>;
    orderFulfillmentCollection: OrderFulfillmentCollection;
    orderOffer?: Maybe<OrderOffer>;
    orderOfferByOrder?: Maybe<OrderOffer>;
    orderOffers?: Maybe<Array<Maybe<OrderOffer>>>;
    orderOffersPaginated?: Maybe<OrderOffersConnection>;
    packageItems: PackageItemCollection;
    paymentGateways: Array<PaymentGateway>;
    paymentGroup: PaymentGroupModel;
    paymentGroups: Array<PaymentGroupsModel>;
    payments?: Maybe<PaymentsUnionConnection>;
    pendingSCAChallenges: Array<ScaChallengesResult>;
    person: Person;
    poll: Poll;
    polls: Array<Poll>;
    postBoxDocumentDownload: PostBoxDocumentDownloadResult;
    product?: Maybe<Product>;
    productFilter?: Maybe<ProductFilter>;
    productFilters: Array<ProductFilter>;
    products?: Maybe<Array<Product>>;
    productsWidget?: Maybe<ProductsWidget>;
    productsWidgets: ProductsWidgetPaginationOutput;
    /** Recommendations associated with a SKU */
    recommendations: RecommendationResponse;
    recurrentPayment: RecurrentPaymentModel;
    recurrentPayments: Array<RecurrentPaymentModel>;
    rentalPlanTest?: Maybe<RentalPlanTest>;
    rentalPlanTests: RentalPlanTestPaginationOutput;
    reservations: ReservationCollection;
    sddMandate: SddMandateResult;
    sddMandateDownload: SddMandateDownloadResult;
    seizures: Array<SeizureResult>;
    /** Returns list of settlements where Grover Card is available */
    settlements: Array<Settlement>;
    shipments: ShipmentCollection;
    shippingAddresses: ShippingAddressCollection;
    shippingRequests: ShippingRequestCollection;
    smartAgentCases: Array<SmartAgentCasesResult>;
    stockCollection: StockCollection;
    stockVariantAvailability: StockVariantAvailabilityCollection;
    stocks: Array<Stock>;
    store?: Maybe<Store>;
    storeCollection?: Maybe<StoreOffsetCollection>;
    storeStockConfiguration: StoreStockConfigurationGraphql;
    storeVariantAvailability: StoreVariantAvailabilityCollection;
    stores?: Maybe<StoreConnection>;
    subscriptionCollection?: Maybe<SubscriptionListEntryConnection>;
    subscriptionDetails?: Maybe<FlexDetails>;
    subscriptionSummary: Array<SubscriptionSummary>;
    teams: Array<Team>;
    user?: Maybe<User>;
    userExists: Scalars['Boolean'];
    users?: Maybe<UserConnection>;
    validateMixProductSelection: ContractValidationResult;
    verification?: Maybe<Verification>;
    verifications?: Maybe<VerificationConnection>;
    votes: VotesConnection;
    voucher: Voucher;
    wallet: WalletModel;
    wallets: Array<WalletModel>;
    workAsset?: Maybe<WorkAsset>;
    workAssets: WorkAssetsConnection;
    workEmployee?: Maybe<WorkEmployee>;
    workEmployees: WorkEmployeeConnection;
};

export type QueryMarketingContentArgs = {
    page?: Maybe<Scalars['String']>;
    platform?: Maybe<PlatformTypes>;
};

export type QueryAssetAllocationCollectionArgs = {
    filter?: Maybe<AssetAllocationFilterInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryAssetAllocationsArgs = {
    filter?: Maybe<AssetAllocationFilterInput>;
    limit?: Maybe<Scalars['Float']>;
};

export type QueryAssetsArgs = {
    filter?: Maybe<AssetFilterInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
    search?: Maybe<Scalars['String']>;
};

export type QueryAvailabilityCampaignsArgs = {
    filter?: Maybe<AvailabilityCampaignFilterInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryBundleArgs = {
    where: BundleWhereUniqueInput;
};

export type QueryBundlesArgs = {
    cursor?: Maybe<BundleWhereUniqueInput>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    orderBy?: Maybe<BundleOrderByInput>;
    where?: Maybe<BundleWhereInput>;
};

export type QueryCampaignArgs = {
    campaignUuid: Scalars['String'];
};

export type QueryCampaignListArgs = {
    filter?: Maybe<CampaignFilterInputType>;
    pagination?: Maybe<PaginationInputType>;
};

export type QueryCartArgs = {
    orderNumber?: Maybe<Scalars['ID']>;
};

export type QueryCategoriesArgs = {
    parentId?: Maybe<Scalars['ID']>;
};

export type QueryCategoryArgs = {
    id?: Maybe<Scalars['ID']>;
    permalink?: Maybe<Scalars['String']>;
};

export type QueryCheckoutAttemptArgs = {
    reference: Scalars['String'];
};

export type QueryCompaniesArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    where?: Maybe<CompaniesWhereInput>;
};

export type QueryCompanyArgs = {
    id?: Maybe<Scalars['ID']>;
    viban?: Maybe<Scalars['String']>;
};

export type QueryCompanyTypesArgs = {
    country: Scalars['String'];
};

export type QueryContractArgs = {
    id: Scalars['ID'];
};

export type QueryContractPaymentGroupsArgs = {
    filter: ContractPaymentGroupFilterInput;
};

export type QueryContractRecurrentPaymentArgs = {
    externalContract: Scalars['String'];
};

export type QueryContractsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    filter?: Maybe<ContractFilterInput>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type QueryDashboardGroupPaymentArgs = {
    id: Scalars['ID'];
};

export type QueryDiscountArgs = {
    code: Scalars['String'];
};

export type QueryDistributionRulesArgs = {
    filter?: Maybe<DistributionRuleFilterInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryEnergyLabelArgs = {
    id: Scalars['Int'];
};

export type QueryEnergyLabelsArgs = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    orderBy?: Maybe<EnergyLabelOrderByInput>;
    where?: Maybe<EnergyLabelWhereInput>;
};

export type QueryFindAllCountdownTimersArgs = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    orderBy?: Maybe<CountdownTimerOrderByInput>;
    where?: Maybe<CountdownTimerWhereInput>;
};

export type QueryFindAllProductCampaignsArgs = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    orderBy?: Maybe<ProductCampaignOrderByInput>;
    where?: Maybe<ProductCampaignWhereInput>;
};

export type QueryFindAllVariantFlagsArgs = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    orderBy?: Maybe<VariantFlagOrderByInput>;
    where?: Maybe<VariantFlagWhereInput>;
};

export type QueryFindCountdownTimerByIdArgs = {
    id: Scalars['ID'];
};

export type QueryFindProductCampaignByIdArgs = {
    id: Scalars['ID'];
};

export type QueryFindVariantFlagByIdArgs = {
    id: Scalars['ID'];
};

export type QueryGetAllPaymentStatsArgs = {
    filter: GetPaymentOrdersFilters;
};

export type QueryGetAllPaymentsArgs = {
    filter: GetPaymentOrdersFilters;
    limit: Scalars['Int'];
    offset: Scalars['Int'];
};

export type QueryGetPaymentByIdArgs = {
    id: Scalars['String'];
};

export type QueryGetPaymentOrderHistoryArgs = {
    contractId: Scalars['String'];
};

export type QueryGetVoteArgs = {
    ticket: Scalars['String'];
};

export type QueryLoyaltyPredictedActionAmountArgs = {
    reservation: LoyaltyReservationInfo;
};

export type QueryNotificationSendResultArgs = {
    id: Scalars['ID'];
};

export type QueryNotificationSendResultsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    where?: Maybe<SendResultWhereInput>;
};

export type QueryNotificationTriggerFilterArgs = {
    uuid: Scalars['ID'];
};

export type QueryNotificationTriggerFiltersArgs = {
    filter?: Maybe<NotificationTriggerFilterListInput>;
};

export type QueryOfferArgs = {
    campaignName: Scalars['String'];
};

export type QueryOrderArgs = {
    orderNumber: Scalars['String'];
};

export type QueryOrderFulfillmentCollectionArgs = {
    filter?: Maybe<FindAndCountInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryOrderOfferArgs = {
    id?: Maybe<Scalars['Int']>;
};

export type QueryOrderOfferByOrderArgs = {
    orderNumber?: Maybe<Scalars['ID']>;
};

export type QueryOrderOffersArgs = {
    filters?: Maybe<OrderOfferFiltersInput>;
};

export type QueryOrderOffersPaginatedArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    filters?: Maybe<OrderOfferFiltersInput>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type QueryPackageItemsArgs = {
    filter?: Maybe<PackageItemFilter>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryPaymentGroupArgs = {
    uuid: Scalars['String'];
};

export type QueryPaymentGroupsArgs = {
    filter: GraphQlFilterPaymentGroups;
};

export type QueryPaymentsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    subscriptionId?: Maybe<Scalars['ID']>;
};

export type QueryPendingScaChallengesArgs = {
    info: GetPendingScaChallengesInfo;
};

export type QueryPollArgs = {
    slug: Scalars['String'];
};

export type QueryPollsArgs = {
    filter?: Maybe<PollsFilterInput>;
    pagination?: Maybe<PaginationInput>;
};

export type QueryPostBoxDocumentDownloadArgs = {
    info: PostBoxDocumentDownloadInfo;
};

export type QueryProductArgs = {
    id?: Maybe<Scalars['ID']>;
    where?: Maybe<ProductWhereInput>;
};

export type QueryProductFilterArgs = {
    id: Scalars['Int'];
};

export type QueryProductFiltersArgs = {
    orderBy?: Maybe<ProductFilterOrderByInput>;
    where?: Maybe<ProductFilterWhereInput>;
};

export type QueryProductsArgs = {
    skus?: Maybe<Array<Scalars['String']>>;
    where?: Maybe<ProductsWhereInput>;
};

export type QueryProductsWidgetArgs = {
    id: Scalars['Int'];
};

export type QueryProductsWidgetsArgs = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    orderBy?: Maybe<ProductsWidgetOrderByInput>;
    where?: Maybe<ProductsWidgetWhereInput>;
};

export type QueryRecommendationsArgs = {
    sku: Scalars['String'];
};

export type QueryRecurrentPaymentArgs = {
    uuid: Scalars['String'];
};

export type QueryRecurrentPaymentsArgs = {
    filter: GraphQlFilter;
};

export type QueryRentalPlanTestArgs = {
    id: Scalars['Int'];
};

export type QueryRentalPlanTestsArgs = {
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
    orderBy?: Maybe<RentalPlanTestOrderByInput>;
    where?: Maybe<RentalPlanTestWhereInput>;
};

export type QueryReservationsArgs = {
    filter?: Maybe<ReservationFilterInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QuerySddMandateArgs = {
    store: Scalars['String'];
};

export type QuerySddMandateDownloadArgs = {
    info: SddMandateDownloadInfo;
};

export type QuerySettlementsArgs = {
    country: Scalars['String'];
};

export type QueryShipmentsArgs = {
    filter?: Maybe<Array<ShipmentFilterType>>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
    search?: Maybe<Scalars['String']>;
    sort?: Maybe<Array<ColumnOrderType>>;
};

export type QueryShippingAddressesArgs = {
    filter?: Maybe<ShippingAddressFilterType>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryShippingRequestsArgs = {
    filter?: Maybe<ShippingRequestFilterType>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
    search?: Maybe<Scalars['String']>;
};

export type QuerySmartAgentCasesArgs = {
    info: GetSmartAgentCasesInfo;
};

export type QueryStockCollectionArgs = {
    filter?: Maybe<StockFilterInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryStockVariantAvailabilityArgs = {
    filter?: Maybe<StockVariantAvailabilityFilterInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryStocksArgs = {
    limit?: Maybe<Scalars['Float']>;
    name?: Maybe<Scalars['String']>;
    offset?: Maybe<Scalars['Float']>;
    uid?: Maybe<Scalars['String']>;
};

export type QueryStoreArgs = {
    id?: Maybe<Scalars['ID']>;
    storeCode?: Maybe<Scalars['String']>;
};

export type QueryStoreCollectionArgs = {
    filter?: Maybe<StoresFilterInput>;
    pagination?: Maybe<OffsetPaginationInput>;
};

export type QueryStoreVariantAvailabilityArgs = {
    filter?: Maybe<StoreVariantAvailabilityFilterInput>;
    limit?: Maybe<Scalars['Float']>;
    offset?: Maybe<Scalars['Float']>;
};

export type QueryStoresArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    enabledOnFooter?: Maybe<Scalars['Boolean']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    storeType?: Maybe<StoreTypes>;
};

export type QuerySubscriptionCollectionArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    filter: SubscriptionListFilterInput;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    searchTerm?: Maybe<Scalars['String']>;
    userId?: Maybe<Scalars['Int']>;
};

export type QuerySubscriptionDetailsArgs = {
    id?: Maybe<Scalars['ID']>;
    number?: Maybe<Scalars['String']>;
};

export type QueryUserArgs = {
    id?: Maybe<Scalars['ID']>;
};

export type QueryUserExistsArgs = {
    email: Scalars['String'];
};

export type QueryUsersArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    where?: Maybe<UsersWhereInput>;
};

export type QueryValidateMixProductSelectionArgs = {
    products: Array<ProductVariantInput>;
};

export type QueryVerificationArgs = {
    id: Scalars['ID'];
};

export type QueryVerificationsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    filter?: Maybe<VerificationsFilterInput>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type QueryVotesArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    order?: Maybe<VoteOrderInput>;
    where?: Maybe<VoteWhereInput>;
};

export type QueryVoucherArgs = {
    code: Scalars['String'];
};

export type QueryWalletArgs = {
    uuid: Scalars['String'];
};

export type QueryWalletsArgs = {
    filter: GraphQlFilter;
};

export type QueryWorkAssetArgs = {
    uuid: Scalars['String'];
};

export type QueryWorkAssetsArgs = {
    filterInput?: Maybe<WorkAssetsFilterInput>;
    paginationInput: WorkPaginationInput;
    sortInput?: Maybe<WorkAssetSortInput>;
};

export type QueryWorkEmployeeArgs = {
    uuid: Scalars['String'];
};

export type QueryWorkEmployeesArgs = {
    filterInput?: Maybe<WorkEmployeesFilterInput>;
    paginationInput: WorkPaginationInput;
    sortInput?: Maybe<WorkEmployeeSortInput>;
};

export type RangeFilter = {
    __typename?: 'RangeFilter';
    category?: Maybe<Category>;
    id: Scalars['ID'];
    label?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    position?: Maybe<Scalars['Int']>;
    rangeFilterConfig: RangeFilterConfig;
    storeCodes: Array<Scalars['String']>;
    type: ProductFilterType;
};

export type RangeFilterConfig = {
    __typename?: 'RangeFilterConfig';
    bucketMax?: Maybe<Scalars['Float']>;
    bucketMin?: Maybe<Scalars['Float']>;
    bucketSize?: Maybe<Scalars['Float']>;
    unit?: Maybe<Scalars['String']>;
};

export type RangeFilterOrError = ProductFilterError | RangeFilter;

export type Reason = {
    __typename?: 'Reason';
    name: Scalars['String'];
    value: Scalars['String'];
};

export type Recommendation = {
    __typename?: 'Recommendation';
    categoryName: Scalars['String'];
    modelProbability: Scalars['Float'];
    modelRank: Scalars['Int'];
    productSku: Scalars['String'];
    rank: Scalars['Int'];
    subcategoryName: Scalars['String'];
};

export type RecommendationResponse = {
    __typename?: 'RecommendationResponse';
    modelType: Scalars['String'];
    modelVersion: Scalars['String'];
    recommendations: Array<Recommendation>;
    tracingId: Scalars['String'];
};

export type RecurrentPaymentModel = {
    __typename?: 'RecurrentPaymentModel';
    additionalData: RecurrentType;
    externalCustomer: Scalars['String'];
    paymentGroups: Array<PaymentGroupModel>;
    scopeUuid?: Maybe<Scalars['String']>;
    status: RecurrentPaymentStatusTypes;
    type: Scalars['String'];
    uuid: Scalars['ID'];
};

export enum RecurrentPaymentStatusTypes {
    active = 'active',
    cancelled = 'cancelled',
    failed = 'failed',
    finished = 'finished',
    paused = 'paused',
}

export type RecurrentType = LoopSimulatorModel | SimpleSubscriptionModel;

export type ReferenceAccountInfo = {
    iban: Scalars['String'];
};

export type ReferenceAccountResult = {
    __typename?: 'ReferenceAccountResult';
    iban: Scalars['String'];
    id: Scalars['String'];
    name: Scalars['String'];
};

export type RegisterCardPersonInfo = {
    acceptedTncAt: Scalars['DateTime'];
    addressAdditionalInfo?: Maybe<Scalars['String']>;
    addressLine1?: Maybe<Scalars['String']>;
    birthCountry: Scalars['String'];
    birthSettlement: Scalars['String'];
    birthdate: Scalars['DateTime'];
    city: Scalars['String'];
    email: Scalars['String'];
    employmentStatus: EmploymentStatus;
    firstName: Scalars['String'];
    lastName: Scalars['String'];
    nationality: Scalars['String'];
    postalCode: Scalars['String'];
    street?: Maybe<Scalars['String']>;
    streetNumber?: Maybe<Scalars['String']>;
};

export type RegisterCardPersonResult = {
    __typename?: 'RegisterCardPersonResult';
    id: Scalars['String'];
};

export type RegisterIncomingAssetsResult = {
    __typename?: 'RegisterIncomingAssetsResult';
    error: Scalars['Boolean'];
    message: Scalars['String'];
};

export type RegisterMobilePhoneInfo = {
    /** Country code of mobile number */
    countryCode?: Maybe<Scalars['String']>;
    /** Label of the device i.e. `My iPhone 12` */
    deviceName: Scalars['String'];
    /** Public part of ECDSA-P256 keypair that will be used for signature verification of CRPs later on */
    devicePublicKey: Scalars['String'];
    /** Body of mobile number */
    number?: Maybe<Scalars['String']>;
};

export type RegisterMobilePhoneResult = {
    __typename?: 'RegisterMobilePhoneResult';
    deviceId: Scalars['String'];
};

export type RentalPlan = {
    __typename?: 'RentalPlan';
    discount?: Maybe<RentalPlanDiscount>;
    id: Scalars['ID'];
    length: Duration;
    oldPrice?: Maybe<Price>;
    price: Price;
};

export type RentalPlanDiscount = {
    __typename?: 'RentalPlanDiscount';
    percentage: Scalars['Float'];
    rentalPlan?: Maybe<RentalPlan>;
    rentalPlanId: Scalars['Int'];
};

export type RentalPlanTest = {
    __typename?: 'RentalPlanTest';
    category?: Maybe<Category>;
    createdAt: Scalars['DateTime'];
    description?: Maybe<Scalars['String']>;
    endedOn?: Maybe<Scalars['DateTime']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    planVisibilityTests: Scalars['JSON'];
    status: RentalPlanTestStatus;
    store?: Maybe<Store>;
    updatedAt: Scalars['DateTime'];
};

export type RentalPlanTestCreateInput = {
    categoryId: Scalars['String'];
    description?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    planVisibilityTests: Array<PlanVisibilityTest>;
    storeCode: Scalars['String'];
};

export type RentalPlanTestError = GenericError & {
    __typename?: 'RentalPlanTestError';
    code: Scalars['String'];
    message: Scalars['String'];
};

export type RentalPlanTestOrderByInput = {
    id?: Maybe<SortOrder>;
    name?: Maybe<SortOrder>;
    status?: Maybe<SortOrder>;
};

export type RentalPlanTestOrError = RentalPlanTest | RentalPlanTestError;

export type RentalPlanTestPaginationOutput = {
    __typename?: 'RentalPlanTestPaginationOutput';
    rows: Array<RentalPlanTest>;
    totalCount: Scalars['Int'];
};

/** Supported statuses for a rental plan test */
export enum RentalPlanTestStatus {
    /** Rental plan test is active and being applied throughout the associated category. */
    ACTIVE = 'ACTIVE',
    /** Rental plan test is drafted and not yet enabled for customers.  */
    DRAFT = 'DRAFT',
    /** Rental plan test has been ended and is not being applied to the associated category anymore. */
    ENDED = 'ENDED',
}

export type RentalPlanTestUpdateInput = {
    categoryId?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    planVisibilityTests?: Maybe<Array<PlanVisibilityTest>>;
    storeCode?: Maybe<Scalars['String']>;
};

export type RentalPlanTestWhereInput = {
    categoryId?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
    id?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    status?: Maybe<RentalPlanTestStatus>;
    storeCode?: Maybe<Scalars['String']>;
};

export type ReplacedLineItemInput = {
    deviceId: Scalars['String'];
    meta: ItemMetaInput;
};

export type ReplacedLineItemMeta = LineItemMeta & {
    __typename?: 'ReplacedLineItemMeta';
    category?: Maybe<LineItemCategory>;
    deviceId?: Maybe<Scalars['ID']>;
    product?: Maybe<Product>;
    replacedItem?: Maybe<LineItemCatalogMeta>;
    variant: LineItemVariant;
};

export type Replacement = Operation & {
    __typename?: 'Replacement';
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    startedAt: Scalars['ISO8601DateTime'];
    startedBy: User;
    state: ReplacementState;
};

export type ReplacementModel = {
    __typename?: 'ReplacementModel';
    allocationUid?: Maybe<Scalars['String']>;
    assetUid?: Maybe<Scalars['String']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    createdBy?: Maybe<Scalars['String']>;
    customerId?: Maybe<Scalars['Float']>;
    deletedAt?: Maybe<Scalars['DateTime']>;
    orderNumber?: Maybe<Scalars['String']>;
    reason?: Maybe<ReplacementReason>;
    replacedAllocationUid: Scalars['String'];
    replacedOrderNumber?: Maybe<Scalars['String']>;
    reservationUid?: Maybe<Scalars['String']>;
    skuVariantCode?: Maybe<Scalars['String']>;
    status?: Maybe<ReplacementStatus>;
    statusUpdatedAt?: Maybe<Scalars['DateTime']>;
    storeId?: Maybe<Scalars['Float']>;
    storeUid?: Maybe<Scalars['String']>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
    updatedBy?: Maybe<Scalars['String']>;
};

export enum ReplacementReason {
    CosmeticWear = 'CosmeticWear',
    Doa = 'Doa',
    Incomplete = 'Incomplete',
    LimitedFunction = 'LimitedFunction',
    LockedAsset = 'LockedAsset',
    Lost = 'Lost',
    NotRefurbished = 'NotRefurbished',
    SoftwareIssue = 'SoftwareIssue',
    WrongAsset = 'WrongAsset',
}

export enum ReplacementState {
    COMPLETED = 'COMPLETED',
    NEW_DELIVERED = 'NEW_DELIVERED',
    OLD_RETURNED = 'OLD_RETURNED',
    STARTED = 'STARTED',
}

export enum ReplacementStatus {
    Allocated = 'Allocated',
    Cancelled = 'Cancelled',
    Created = 'Created',
    Delivered = 'Delivered',
    FailedDelivery = 'FailedDelivery',
    PendingAllocation = 'PendingAllocation',
    Shipped = 'Shipped',
    WmsProcessing = 'WmsProcessing',
}

export type ReportDamage = {
    __typename?: 'ReportDamage';
    /** @deprecated Use grapql __typename instead */
    action: Scalars['String'];
    claimFormUrl?: Maybe<Scalars['String']>;
    unavailableReason?: Maybe<Scalars['String']>;
};

export type Reservation = {
    __typename?: 'Reservation';
    attemptUid?: Maybe<Scalars['String']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    customerId?: Maybe<Scalars['Int']>;
    /** number of days in pending allocation */
    daysPending?: Maybe<Scalars['Float']>;
    deletedAt?: Maybe<Scalars['DateTime']>;
    expirationDate?: Maybe<Scalars['DateTime']>;
    isActive?: Maybe<Scalars['Boolean']>;
    orderId?: Maybe<Scalars['Int']>;
    orderMode?: Maybe<JunoOrderMode>;
    orderNumber?: Maybe<Scalars['String']>;
    priority?: Maybe<Scalars['Float']>;
    quantity?: Maybe<Scalars['Int']>;
    skuUid?: Maybe<Scalars['String']>;
    skuVariantCode?: Maybe<Scalars['String']>;
    status?: Maybe<ReservationStatus>;
    statusUpdatedAt?: Maybe<Scalars['DateTime']>;
    stock?: Maybe<Stock>;
    stockUid?: Maybe<Scalars['String']>;
    store?: Maybe<Store>;
    storeId?: Maybe<Scalars['Int']>;
    storeUid?: Maybe<Scalars['String']>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
    variant: Variant;
};

export type ReservationCollection = {
    __typename?: 'ReservationCollection';
    count: Scalars['Float'];
    rows: Array<Reservation>;
};

export type ReservationFilterInput = {
    isActive?: Maybe<Scalars['Boolean']>;
    orderMode?: Maybe<JunoOrderMode>;
    orderNumber?: Maybe<Scalars['String']>;
    skuVariantCode?: Maybe<Scalars['String']>;
    status?: Maybe<ReservationStatus>;
    stockUid?: Maybe<Scalars['ID']>;
    storeId?: Maybe<Scalars['Float']>;
    uid?: Maybe<Scalars['ID']>;
};

export enum ReservationStatus {
    Approved = 'Approved',
    Cancelled = 'Cancelled',
    Confirmed = 'Confirmed',
    Declined = 'Declined',
    Deleted = 'Deleted',
    Expired = 'Expired',
    Fulfilled = 'Fulfilled',
    Paid = 'Paid',
    Pending = 'Pending',
}

export enum ReservationType {
    CARD_AUTHORIZATION = 'CARD_AUTHORIZATION',
    CLEARING_TRANSACTION = 'CLEARING_TRANSACTION',
    INTRA_CUSTOMER_TRANSFER = 'INTRA_CUSTOMER_TRANSFER',
    SEIZURE = 'SEIZURE',
    SEPA_CREDIT_BATCH = 'SEPA_CREDIT_BATCH',
    SEPA_CREDIT_TRANSFER = 'SEPA_CREDIT_TRANSFER',
}

/** Autogenerated input type of ResetVerification */
export type ResetVerificationInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    userId: Scalars['ID'];
};

/** Autogenerated return type of ResetVerification */
export type ResetVerificationPayload = {
    __typename?: 'ResetVerificationPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    user: User;
};

export type ReturnSteps = AccessoriesReturnStep | ConfirmableReturnStep | ReturnStepsOutcome;

export type ReturnStepsOutcome = {
    __typename?: 'ReturnStepsOutcome';
    name: Scalars['String'];
};

export type Revocation = Operation & {
    __typename?: 'Revocation';
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    startedAt: Scalars['ISO8601DateTime'];
    startedBy: User;
    state: InboundShipmentStates;
};

export type RevocationTerms = {
    __typename?: 'RevocationTerms';
    availabilityPeriod: Duration;
    available: Scalars['Boolean'];
    availableUntil?: Maybe<Scalars['ISO8601DateTime']>;
    unavailabilityReason?: Maybe<RevocationUnavailabilityReason>;
};

export enum RevocationUnavailabilityReason {
    ALREADY_IN_PROGRESS = 'ALREADY_IN_PROGRESS',
    ANOTHER_FLOW_IN_PROGRESS = 'ANOTHER_FLOW_IN_PROGRESS',
    AVAILABILITY_PERIOD_ENDED = 'AVAILABILITY_PERIOD_ENDED',
    BEFORE_ALLOCATION = 'BEFORE_ALLOCATION',
    REVOCATION_DISABLED = 'REVOCATION_DISABLED',
}

/** Autogenerated input type of RevokeContract */
export type RevokeContractInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contractId: Scalars['ID'];
};

/** Autogenerated return type of RevokeContract */
export type RevokeContractPayload = {
    __typename?: 'RevokeContractPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contract: Contract;
};

export type ScaChallengesResult = {
    __typename?: 'SCAChallengesResult';
    amount: BasicAmount;
    authoriseChangeRequestId: Scalars['String'];
    challengedAt: Scalars['DateTime'];
    declineChangeRequestId: Scalars['String'];
    expiresAt: Scalars['DateTime'];
    id: Scalars['String'];
    merchantName: Scalars['String'];
};

export type SddAcceptedAtResult = {
    __typename?: 'SddAcceptedAtResult';
    sddAcceptedAt: Scalars['DateTime'];
};

export type SddAddress = {
    __typename?: 'SddAddress';
    city: Scalars['String'];
    country: Scalars['String'];
    countryIso: Scalars['String'];
    line1: Scalars['String'];
    line2?: Maybe<Scalars['String']>;
    zip: Scalars['String'];
};

export type SddMandate = {
    __typename?: 'SDDMandate';
    createdAt: Scalars['DateTime'];
    isActive: Scalars['Boolean'];
    reference: Scalars['String'];
};

export type SddMandateDownloadInfo = {
    lang: Scalars['String'];
    store: Scalars['String'];
};

export type SddMandateDownloadResult = {
    __typename?: 'SDDMandateDownloadResult';
    encodedContent: Scalars['String'];
    mimeType: Scalars['String'];
};

export type SddMandateResult = {
    __typename?: 'SddMandateResult';
    commercialRegisterNumber: Scalars['String'];
    commercialRegisteredDistrictCourt: Scalars['String'];
    companyName: Scalars['String'];
    creditInstitution: Scalars['String'];
    creditorId: Scalars['String'];
    sddAddress: SddAddress;
};

export type Section = {
    __typename?: 'Section';
    filter?: Maybe<SubscriptionListFilter>;
    items: Array<SubscriptionListEntry>;
    quantity: Scalars['Int'];
    title: Scalars['String'];
};

export type SecureCardDetailsInfo = {
    cardId: Scalars['String'];
    deviceId: Scalars['String'];
    jwe: Jwe;
    jwk: Jwk;
    signature: Scalars['String'];
};

export type SecureCardDetailsResult = {
    __typename?: 'SecureCardDetailsResult';
    data: Scalars['String'];
};

export type SeizurePaymentInfo = {
    amount: PaymentAmount;
    deviceId: Scalars['String'];
    id: Scalars['String'];
};

export type SeizureResult = {
    __typename?: 'SeizureResult';
    additionalCost?: Maybe<CardAmount>;
    amount: CardAmount;
    authorityName?: Maybe<Scalars['String']>;
    creditor?: Maybe<CreditorInfo>;
    creditorRepresentative?: Maybe<CreditorRepresentativeInfo>;
    debtor?: Maybe<DebtorInfo>;
    deliveryDate?: Maybe<Scalars['DateTime']>;
    enactmentDate?: Maybe<Scalars['DateTime']>;
    id: Scalars['String'];
    resolutionCaseNumber?: Maybe<Scalars['String']>;
    seizureType: SeizureTypeEnum;
    status: SeizureStatusEnum;
};

export enum SeizureStatusEnum {
    ACTIVE = 'ACTIVE',
    FULFILLED = 'FULFILLED',
    WAITING_FOR_AUTHORITY = 'WAITING_FOR_AUTHORITY',
}

export enum SeizureTypeEnum {
    ATTACHMENT = 'ATTACHMENT',
    AUTHORITY_SEIZURE = 'AUTHORITY_SEIZURE',
    COURT_SEIZURE = 'COURT_SEIZURE',
    PRE_ATTACHMENT = 'PRE_ATTACHMENT',
}

export type SendResultChannelComparisonInput = {
    _eq?: Maybe<NotificationChannel>;
};

export type SendResultConnection = {
    __typename?: 'SendResultConnection';
    edges: Array<SendResultEdge>;
    nodes: Array<NotificationSendResult>;
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

export type SendResultEdge = {
    __typename?: 'SendResultEdge';
    cursor: Scalars['String'];
    node: NotificationSendResult;
};

export type SendResultStatusComparisonInput = {
    _eq?: Maybe<NotificationSendResultStatus>;
};

export type SendResultWhereInput = {
    and?: Maybe<Array<SendResultWhereInput>>;
    channel?: Maybe<SendResultChannelComparisonInput>;
    status?: Maybe<SendResultStatusComparisonInput>;
    triggerName?: Maybe<StringComparisonInput>;
    userId?: Maybe<IdComparisonInput>;
};

export type Sepa = PaymentMethodInterface & {
    __typename?: 'Sepa';
    bankName?: Maybe<Scalars['String']>;
    billingAccountId?: Maybe<Scalars['String']>;
    ibanFirstDigits?: Maybe<Scalars['String']>;
    ibanLastDigits?: Maybe<Scalars['String']>;
    mandateId?: Maybe<Scalars['String']>;
};

export type Settlement = {
    __typename?: 'Settlement';
    name: Scalars['String'];
};

export type Shipment = {
    __typename?: 'Shipment';
    carrier?: Maybe<Scalars['String']>;
    company?: Maybe<Scalars['String']>;
    contractId?: Maybe<Scalars['String']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    /** senderAddress for inbound & recipientAddress for outbound */
    customerAddress?: Maybe<ShippingAddress>;
    customerType?: Maybe<Scalars['String']>;
    daysSinceOpened?: Maybe<Scalars['Float']>;
    deletedAt?: Maybe<Scalars['DateTime']>;
    description?: Maybe<Scalars['String']>;
    height?: Maybe<Scalars['Float']>;
    length?: Maybe<Scalars['Float']>;
    numberOfAssets?: Maybe<Scalars['Int']>;
    orderItemId?: Maybe<Scalars['Float']>;
    packages?: Maybe<Array<PackageItem>>;
    pickupAddress?: Maybe<ShippingAddress>;
    pickupAddressUid?: Maybe<Scalars['String']>;
    proofOfDeliveryUrls?: Maybe<Array<Scalars['String']>>;
    recipientAddress?: Maybe<ShippingAddress>;
    recipientAddressUid?: Maybe<Scalars['String']>;
    senderAddress?: Maybe<ShippingAddress>;
    senderAddressUid?: Maybe<Scalars['String']>;
    service?: Maybe<Scalars['String']>;
    shipmentHistory: Array<ShipmentHistoryItem>;
    shippingLabelUrl?: Maybe<Scalars['String']>;
    shippingProfile?: Maybe<Scalars['String']>;
    shippingRequest: ShippingRequest;
    shippingRequestUid: Scalars['String'];
    status?: Maybe<ShipmentLifecycleStatus>;
    statusUpdatedAt?: Maybe<Scalars['DateTime']>;
    trackingEvents?: Maybe<Array<ShipmentLifecycleEvent>>;
    trackingNumber?: Maybe<Scalars['String']>;
    trackingUrl?: Maybe<Scalars['String']>;
    type?: Maybe<Scalars['String']>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
    weight?: Maybe<Scalars['Float']>;
    width?: Maybe<Scalars['Float']>;
};

export type ShipmentCollection = {
    __typename?: 'ShipmentCollection';
    count: Scalars['Float'];
    rows: Array<Shipment>;
};

export type ShipmentFilterType = {
    carrier?: Maybe<StringComparatorInput>;
    countryCode?: Maybe<StringComparatorInput>;
    createdAt?: Maybe<TimestampComparatorInput>;
    customerType?: Maybe<StringComparatorInput>;
    orderMode?: Maybe<ShippingRequestModeComparatorInput>;
    orderNumber?: Maybe<StringComparatorInput>;
    service?: Maybe<StringComparatorInput>;
    status?: Maybe<ShippingStatusComparatorInput>;
    uid?: Maybe<StringComparatorInput>;
    userId?: Maybe<StringComparatorInput>;
};

export type ShipmentHistoryItem = {
    __typename?: 'ShipmentHistoryItem';
    description?: Maybe<Scalars['String']>;
    status?: Maybe<Scalars['String']>;
    timestamp?: Maybe<Scalars['DateTime']>;
    type?: Maybe<ShipmentHistoryItemType>;
    uid?: Maybe<Scalars['String']>;
};

export enum ShipmentHistoryItemType {
    delivery_exception = 'delivery_exception',
    status_change = 'status_change',
}

export type ShipmentLabel = {
    __typename?: 'ShipmentLabel';
    assetUid: Scalars['String'];
    shippingLabelUrl?: Maybe<Scalars['String']>;
    trackingStatus?: Maybe<ShipmentTrackingStatus>;
    trackingUrl?: Maybe<Scalars['String']>;
    type?: Maybe<ShipmentServiceType>;
};

export type ShipmentLifecycleEvent = {
    __typename?: 'ShipmentLifecycleEvent';
    carrier?: Maybe<Scalars['String']>;
    description?: Maybe<Scalars['String']>;
    location?: Maybe<Scalars['String']>;
    metadata?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    shipmentUid?: Maybe<Scalars['String']>;
    timestamp?: Maybe<Scalars['String']>;
    uid?: Maybe<Scalars['String']>;
};

export enum ShipmentLifecycleStatus {
    ArrivedAtCarrierFacility = 'ArrivedAtCarrierFacility',
    Cancelled = 'Cancelled',
    Created = 'Created',
    Delivered = 'Delivered',
    DeliveryRefused = 'DeliveryRefused',
    DepartedFromCarrierFacility = 'DepartedFromCarrierFacility',
    FailedDeliveryCandidate = 'FailedDeliveryCandidate',
    FailedToDeliver = 'FailedToDeliver',
    InTransit = 'InTransit',
    LabelCreated = 'LabelCreated',
    OutForDelivery = 'OutForDelivery',
    Packed = 'Packed',
    PickAndPacking = 'PickAndPacking',
    PickedUpByCarrier = 'PickedUpByCarrier',
    ProcessingAtCarrierFacility = 'ProcessingAtCarrierFacility',
    ReadyForPickupByReceiver = 'ReadyForPickupByReceiver',
    ScannedAtCarrierFacility = 'ScannedAtCarrierFacility',
}

export enum ShipmentServiceType {
    INBOUND = 'INBOUND',
    INTERNAL = 'INTERNAL',
    OUTBOUND = 'OUTBOUND',
}

export enum ShipmentTrackingStatus {
    Delivered = 'Delivered',
    FailedToDeliver = 'FailedToDeliver',
    InTransit = 'InTransit',
    ReadyForPickupByReceiver = 'ReadyForPickupByReceiver',
}

export type ShippingAddress = {
    __typename?: 'ShippingAddress';
    city?: Maybe<Scalars['String']>;
    company?: Maybe<Scalars['String']>;
    country?: Maybe<Scalars['String']>;
    countryCode?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    firstName?: Maybe<Scalars['String']>;
    lastName?: Maybe<Scalars['String']>;
    phone?: Maybe<Scalars['String']>;
    shipment?: Maybe<Shipment>;
    shipmentUid: Scalars['String'];
    state?: Maybe<Scalars['String']>;
    street1?: Maybe<Scalars['String']>;
    street2?: Maybe<Scalars['String']>;
    uid: Scalars['ID'];
    zipCode?: Maybe<Scalars['String']>;
};

export type ShippingAddressCollection = {
    __typename?: 'ShippingAddressCollection';
    count: Scalars['Float'];
    rows: Array<ShippingAddress>;
};

export type ShippingAddressFilterType = {
    shipmentUid?: Maybe<Scalars['String']>;
    uid?: Maybe<Scalars['String']>;
};

export type ShippingDetails = {
    country_code?: Maybe<Scalars['String']>;
    shippingCost?: Maybe<Scalars['Float']>;
    state?: Maybe<Scalars['String']>;
    zipcode?: Maybe<Scalars['String']>;
};

export enum ShippingOrderEnum {
    ASC = 'ASC',
    DESC = 'DESC',
}

export type ShippingProgress = {
    __typename?: 'ShippingProgress';
    actions?: Maybe<Array<Action>>;
    description?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    slug: Scalars['String'];
    state: Scalars['String'];
    subSteps?: Maybe<Array<SubStep>>;
};

export type ShippingRequest = {
    __typename?: 'ShippingRequest';
    additionalInfo?: Maybe<Scalars['String']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    daysSinceOpened?: Maybe<Scalars['Float']>;
    deletedAt?: Maybe<Scalars['DateTime']>;
    numberOfShipments?: Maybe<Scalars['Float']>;
    orderId?: Maybe<Scalars['String']>;
    orderMode?: Maybe<ShippingRequestMode>;
    orderNumber?: Maybe<Scalars['String']>;
    shipments?: Maybe<Array<Shipment>>;
    status?: Maybe<ShippingRequestStatus>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
    userId?: Maybe<Scalars['String']>;
};

export type ShippingRequestCollection = {
    __typename?: 'ShippingRequestCollection';
    count: Scalars['Float'];
    rows: Array<ShippingRequest>;
};

export type ShippingRequestFilterType = {
    orderMode?: Maybe<ShippingRequestMode>;
    orderNumber?: Maybe<Scalars['String']>;
    status?: Maybe<ShippingRequestStatus>;
    uid?: Maybe<Scalars['String']>;
};

export enum ShippingRequestMode {
    FLEX = 'FLEX',
    FLEX_LEGACY = 'FLEX_LEGACY',
    MIX = 'MIX',
    SWAP = 'SWAP',
}

export type ShippingRequestModeComparatorInput = {
    _eq?: Maybe<ShippingRequestMode>;
    _neq?: Maybe<ShippingRequestMode>;
};

export enum ShippingRequestStatus {
    CANCELLED = 'CANCELLED',
    CLOSED = 'CLOSED',
    EXCEPTION = 'EXCEPTION',
    OPEN = 'OPEN',
}

export type ShippingStatusComparatorInput = {
    _eq?: Maybe<ShipmentLifecycleStatus>;
    _in?: Maybe<Array<ShipmentLifecycleStatus>>;
    _neq?: Maybe<ShipmentLifecycleStatus>;
    _nin?: Maybe<Array<ShipmentLifecycleStatus>>;
};

export type SimpleSubscriptionModel = {
    __typename?: 'SimpleSubscriptionModel';
    amount: Scalars['Money'];
    billingPeriod: Scalars['String'];
    currency: Scalars['String'];
    description: Scalars['String'];
    externalCustomer: Scalars['String'];
    recurrentPaymentUuid: Scalars['String'];
};

export type SingleChoiceOption = {
    __typename?: 'SingleChoiceOption';
    label: Scalars['String'];
    slug: Scalars['String'];
};

export type SingleChoiceOptions = {
    __typename?: 'SingleChoiceOptions';
    options: Array<SingleChoiceOption>;
};

export type SingleChoiceResult = {
    __typename?: 'SingleChoiceResult';
    slug: Scalars['String'];
    votes: Scalars['Int'];
};

export type SingleChoiceResults = {
    __typename?: 'SingleChoiceResults';
    resultsPerOption: Array<SingleChoiceResult>;
    total: TotalResults;
};

export enum SmartAgentCaseResolutionEnum {
    confirmed = 'confirmed',
    pending = 'pending',
    timeout = 'timeout',
    viewed = 'viewed',
    whitelisted = 'whitelisted',
}

export type SmartAgentCasesInfo = {
    id: Scalars['String'];
    resolution: SmartAgentCaseResolutionEnum;
};

export type SmartAgentCasesResult = {
    __typename?: 'SmartAgentCasesResult';
    amount: BasicAmount;
    attemptedAt: Scalars['DateTime'];
    id: Scalars['String'];
    merchantName: Scalars['String'];
    respondUntil: Scalars['DateTime'];
};

/** represents the sorting order: asc, or desc */
export enum SortOrder {
    asc = 'asc',
    desc = 'desc',
}

/** Autogenerated input type of StartPurchase */
export type StartPurchaseInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contractId: Scalars['ID'];
};

/** Autogenerated return type of StartPurchase */
export type StartPurchasePayload = {
    __typename?: 'StartPurchasePayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contract: Flex;
};

/** Autogenerated input type of StartReplacement */
export type StartReplacementInput = {
    assetId: Scalars['String'];
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of StartReplacement */
export type StartReplacementPayload = {
    __typename?: 'StartReplacementPayload';
    assetId?: Maybe<Scalars['String']>;
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    contract?: Maybe<Contract>;
};

export type Statement = {
    __typename?: 'Statement';
    month: Scalars['String'];
    period: Scalars['Int'];
    year: Scalars['Int'];
};

export enum StatusTypes {
    active = 'active',
    paused = 'paused',
}

export type Stock = {
    __typename?: 'Stock';
    assets?: Maybe<Array<AssetModel>>;
    createdAt?: Maybe<Scalars['DateTime']>;
    description?: Maybe<Scalars['String']>;
    isRecirculated?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    priority?: Maybe<Scalars['Float']>;
    props?: Maybe<Scalars['Object']>;
    rules?: Maybe<Array<DistributionRule>>;
    storeIds?: Maybe<Array<Scalars['ID']>>;
    /** takes storeId and returns priority from corresponding store-stock-link */
    storePriority?: Maybe<Scalars['Float']>;
    stores?: Maybe<Array<Maybe<Store>>>;
    type?: Maybe<StockType>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StockStorePriorityArgs = {
    storeId?: Maybe<Scalars['ID']>;
};

export type StockCollection = {
    __typename?: 'StockCollection';
    count: Scalars['Float'];
    rows: Array<Stock>;
};

export type StockFilterInput = {
    isRecirculated?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    searchString?: Maybe<Scalars['String']>;
    type?: Maybe<Array<StockType>>;
    uid?: Maybe<Scalars['ID']>;
};

export enum StockType {
    Main = 'Main',
    Miscellaneous = 'Miscellaneous',
    Partner = 'Partner',
}

export type StockVariantAvailability = {
    __typename?: 'StockVariantAvailability';
    availableCount: Scalars['Int'];
    createdAt?: Maybe<Scalars['DateTime']>;
    inStockCount: Scalars['Int'];
    onLoanCount: Scalars['Int'];
    reservedCount: Scalars['Int'];
    sku: Scalars['String'];
    skuUid: Scalars['String'];
    skuVariantCode?: Maybe<Scalars['String']>;
    stockUid: Scalars['String'];
    stockVariantAvailability: StockVariantAvailability;
    totalCount: Scalars['Int'];
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StockVariantAvailabilityCollection = {
    __typename?: 'StockVariantAvailabilityCollection';
    count: Scalars['Float'];
    rows: Array<StockVariantAvailability>;
};

export type StockVariantAvailabilityFilterInput = {
    skuUid?: Maybe<Scalars['String']>;
    skuVariantCode?: Maybe<Scalars['String']>;
    stockUid?: Maybe<Scalars['String']>;
};

export type Store = {
    __typename?: 'Store';
    alternativeLocales?: Maybe<Array<Scalars['String']>>;
    code: Scalars['ID'];
    defaultCurrency: Scalars['String'];
    defaultLocale: Scalars['String'];
    deliveryTimeFromDays?: Maybe<Scalars['Int']>;
    deliveryTimeToDays?: Maybe<Scalars['Int']>;
    enabledOnFooter: Scalars['Boolean'];
    id: Scalars['ID'];
    name: Scalars['String'];
    offline: Scalars['Boolean'];
    stocks?: Maybe<Array<Stock>>;
    storeType?: Maybe<StoreTypes>;
    url: Scalars['String'];
    widgets?: Maybe<Widgets>;
};

/** The connection type for Store. */
export type StoreConnection = {
    __typename?: 'StoreConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<StoreEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<Store>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type StoreEdge = {
    __typename?: 'StoreEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<Store>;
};

export type StoreOffsetCollection = {
    __typename?: 'StoreOffsetCollection';
    nodes: Array<Store>;
    totalCount: Scalars['Int'];
};

export type StoresFilterInput = {
    code?: Maybe<Array<Scalars['String']>>;
    id?: Maybe<Array<Scalars['ID']>>;
    storeType?: Maybe<Array<StoreTypes>>;
};

export type StoreStockConfigurationGraphql = {
    __typename?: 'StoreStockConfigurationGraphql';
    stocks?: Maybe<Array<Stock>>;
    storeStockLinks?: Maybe<Array<StoreStockLink>>;
};

export type StoreStockConfigurationGraphqlStocksArgs = {
    name?: Maybe<Scalars['String']>;
};

export type StoreStockLink = {
    __typename?: 'StoreStockLink';
    createdAt?: Maybe<Scalars['DateTime']>;
    priority?: Maybe<Scalars['Float']>;
    stockUid?: Maybe<Scalars['String']>;
    storeId?: Maybe<Scalars['ID']>;
    storeUid?: Maybe<Scalars['String']>;
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum StoreTypes {
    BUSINESS = 'BUSINESS',
    GROVER_PAY = 'GROVER_PAY',
    LEGACY = 'LEGACY',
    MAIN = 'MAIN',
    RETAIL = 'RETAIL',
}

export type StoreVariantAvailability = {
    __typename?: 'StoreVariantAvailability';
    availabilityMode?: Maybe<AvailabilityMode>;
    availableCount: Scalars['Int'];
    createdAt?: Maybe<Scalars['DateTime']>;
    inStockCount: Scalars['Int'];
    mixVariantUid?: Maybe<Scalars['String']>;
    orderMode?: Maybe<JunoOrderMode>;
    reservedCount: Scalars['Int'];
    sku?: Maybe<Scalars['String']>;
    skuUid: Scalars['String'];
    skuVariantCode?: Maybe<Scalars['String']>;
    storeId?: Maybe<Scalars['Float']>;
    storeUid: Scalars['String'];
    uid: Scalars['ID'];
    updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StoreVariantAvailabilityCollection = {
    __typename?: 'StoreVariantAvailabilityCollection';
    count: Scalars['Float'];
    rows: Array<StoreVariantAvailability>;
};

export type StoreVariantAvailabilityFilterInput = {
    availabilityMode?: Maybe<AvailabilityMode>;
    skuUid?: Maybe<Scalars['String']>;
    skuVariantCode?: Maybe<Scalars['String']>;
    stockUid?: Maybe<Scalars['String']>;
    storeId?: Maybe<Scalars['Float']>;
};

export type StringComparatorInput = {
    _eq?: Maybe<Scalars['String']>;
    _neq?: Maybe<Scalars['String']>;
    _substr?: Maybe<Scalars['String']>;
};

export type StringComparisonInput = {
    _eq?: Maybe<Scalars['String']>;
    _ew?: Maybe<Scalars['String']>;
    _neq?: Maybe<Scalars['String']>;
    _substr?: Maybe<Scalars['String']>;
    _sw?: Maybe<Scalars['String']>;
};

export type StringFilter = {
    contains?: Maybe<Scalars['String']>;
    endsWith?: Maybe<Scalars['String']>;
    equals?: Maybe<Scalars['String']>;
    gt?: Maybe<Scalars['String']>;
    gte?: Maybe<Scalars['String']>;
    in?: Maybe<Array<Scalars['String']>>;
    lt?: Maybe<Scalars['String']>;
    lte?: Maybe<Scalars['String']>;
    not?: Maybe<NestedStringFilter>;
    notIn?: Maybe<Array<Scalars['String']>>;
    startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableFilter = {
    contains?: Maybe<Scalars['String']>;
    endsWith?: Maybe<Scalars['String']>;
    equals?: Maybe<Scalars['String']>;
    gt?: Maybe<Scalars['String']>;
    gte?: Maybe<Scalars['String']>;
    in?: Maybe<Array<Scalars['String']>>;
    lt?: Maybe<Scalars['String']>;
    lte?: Maybe<Scalars['String']>;
    not?: Maybe<NestedStringNullableFilter>;
    notIn?: Maybe<Array<Scalars['String']>>;
    startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableListFilter = {
    equals?: Maybe<Array<Scalars['String']>>;
    has?: Maybe<Scalars['String']>;
    hasEvery?: Maybe<Array<Scalars['String']>>;
    hasSome?: Maybe<Array<Scalars['String']>>;
    isEmpty?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of SubmitVerificationDecision */
export type SubmitVerificationDecisionInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    verificationDecision: VerificationDecisionInput;
};

/** Autogenerated return type of SubmitVerificationDecision */
export type SubmitVerificationDecisionPayload = {
    __typename?: 'SubmitVerificationDecisionPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    errors: Array<Scalars['String']>;
    verification: Verification;
};

export type SubscriptionAction =
    | Buyout
    | CancelSubscription
    | ChangePaymentMethod
    | PaymentMethodPresenter
    | PrintReturnLabel
    | ReportDamage
    | SupportRequest
    | UpgradeRentalPlan;

export type SubscriptionBadgeContentModel = {
    __typename?: 'SubscriptionBadgeContentModel';
    actions?: Maybe<Array<ActionUnionModel>>;
    /** Markdown template. Commonly a placeholder for translations. Example: {{thankyou}}. thankyou is a translate placeholder */
    bodyTemplate: Scalars['String'];
    svgPath: Scalars['String'];
    uuid: Scalars['ID'];
};

export type SubscriptionBadgeModel = {
    __typename?: 'SubscriptionBadgeModel';
    actions?: Maybe<Array<ActionUnionModel>>;
    /** Markdown template. Commonly a placeholder for translations. Example: {{thankyou}}. thankyou is a translate placeholder */
    bodyTemplate: Scalars['String'];
    svgPath: Scalars['String'];
    uuid: Scalars['ID'];
};

export type SubscriptionCard = {
    __typename?: 'SubscriptionCard';
    id: Scalars['ID'];
    /** Returns marketing data for the subscription level */
    marketingSubscriptionData: Array<CardTypeUnionModel>;
    name?: Maybe<Scalars['String']>;
    note?: Maybe<SubscriptionNote>;
    product: Product;
    state: SubscriptionState;
    variant: Variant;
};

/** The connection type for SubscriptionCard. */
export type SubscriptionCardConnection = {
    __typename?: 'SubscriptionCardConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<SubscriptionCardEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<SubscriptionCard>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SubscriptionCardEdge = {
    __typename?: 'SubscriptionCardEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<SubscriptionCard>;
};

export type SubscriptionDetails = {
    __typename?: 'SubscriptionDetails';
    asset?: Maybe<Asset>;
    basePrice: Price;
    contractNumber?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    minimumDuration?: Maybe<Duration>;
    name?: Maybe<Scalars['String']>;
    note?: Maybe<SubscriptionNote>;
    /** @deprecated Legacy id, will be removed */
    number: Scalars['String'];
    order: Order;
    paymentMethod: PaymentMethod;
    payments: PaymentsUnionConnection;
    price: Price;
    product?: Maybe<Product>;
    /** @deprecated Legacy id, will be removed */
    sfId?: Maybe<Scalars['ID']>;
    /** @deprecated Legacy id, will be removed */
    sfOrderId?: Maybe<Scalars['ID']>;
    shippingAddress?: Maybe<Address>;
    shippingProgress?: Maybe<Array<ShippingProgress>>;
    state: SubscriptionState;
    subscriptionActions: Array<SubscriptionAction>;
    surpriseDiscount?: Maybe<SurpriseDiscount>;
    user: User;
    variant?: Maybe<Variant>;
};

export type SubscriptionDetailsPaymentsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type SubscriptionListEntry = SubscriptionCard | SubscriptionStack;

/** The connection type for SubscriptionListEntry. */
export type SubscriptionListEntryConnection = {
    __typename?: 'SubscriptionListEntryConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<SubscriptionListEntryEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<SubscriptionListEntry>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SubscriptionListEntryEdge = {
    __typename?: 'SubscriptionListEntryEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<SubscriptionListEntry>;
};

export type SubscriptionListFilter = {
    __typename?: 'SubscriptionListFilter';
    orderId?: Maybe<Scalars['ID']>;
    productId?: Maybe<Scalars['ID']>;
    state: Array<SubscriptionState>;
};

export type SubscriptionListFilterInput = {
    orderId?: Maybe<Scalars['ID']>;
    productId?: Maybe<Scalars['ID']>;
    state?: Maybe<Array<SubscriptionState>>;
};

export type SubscriptionNote =
    | AttentionNote
    | EndedNote
    | NextPaymentNote
    | PausedNote
    | ProcessingNote;

export type SubscriptionPayment = PaymentInterface & {
    __typename?: 'SubscriptionPayment';
    basePrice: Price;
    contract?: Maybe<Contract>;
    discountableLoyaltyPrice: Price;
    discountedLoyaltyPrice: Price;
    dueDate: DateUnion;
    id: Scalars['ID'];
    invoiceUrl?: Maybe<Scalars['String']>;
    marketingSubscriptionPaymentData: Array<HintModel>;
    price: Price;
    remoteId?: Maybe<Scalars['String']>;
    state: PaymentState;
    /** @deprecated Use Contract field */
    subscriptionDetails?: Maybe<SubscriptionDetails>;
};

export type SubscriptionStack = {
    __typename?: 'SubscriptionStack';
    filter: SubscriptionListFilter;
    product: Product;
    quantity: Scalars['Int'];
};

export enum SubscriptionState {
    active = 'active',
    cancelled = 'cancelled',
    declined = 'declined',
    ended = 'ended',
    paused = 'paused',
    processing = 'processing',
}

export type SubscriptionSummary = FilterButton | Section;

export type SubStep = {
    __typename?: 'SubStep';
    description?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    slug: Scalars['String'];
    state: Scalars['String'];
};

export type SupportRequest = {
    __typename?: 'SupportRequest';
    /** @deprecated Use grapql __typename instead */
    action: Scalars['String'];
    orderNumber?: Maybe<Scalars['String']>;
};

export type SurpriseDiscount = {
    __typename?: 'SurpriseDiscount';
    newBuyoutTerms?: Maybe<MonthsToOwn>;
    percentage?: Maybe<Scalars['Int']>;
};

export type Swap = {
    __typename?: 'Swap';
    cancelledAt?: Maybe<Scalars['ISO8601DateTime']>;
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    contractId: Scalars['ID'];
    createdAt: Scalars['ISO8601DateTime'];
    expiresAt: Scalars['ISO8601DateTime'];
    id: Scalars['ID'];
    mixSubscription: Mix;
    newDevice: MixDevice;
    oldDevice: MixDevice;
    orderNumber: Scalars['ID'];
    shipmentLabels?: Maybe<Array<ShipmentLabel>>;
    shippingLabelUrl?: Maybe<Scalars['String']>;
    shippingProgress?: Maybe<MixSwapShippingProgress>;
    state: SwapState;
    trackingUrl?: Maybe<Scalars['String']>;
    user: User;
    userId: Scalars['ID'];
};

export enum SwapCancellationError {
    DEVICE_IS_NOT_AWAITING_RETURN = 'DEVICE_IS_NOT_AWAITING_RETURN',
    SWAP_IS_NOT_ONGOING = 'SWAP_IS_NOT_ONGOING',
    SWAP_NOT_FOUND = 'SWAP_NOT_FOUND',
}

export type SwappingTerms = {
    __typename?: 'SwappingTerms';
    available: Scalars['Boolean'];
    availableAfter?: Maybe<Scalars['ISO8601DateTime']>;
    timeUntilAvailable?: Maybe<Duration>;
    unavailabilityReason?: Maybe<SwapUnavailabilityReason>;
};

export type SwapReturnResult = {
    __typename?: 'SwapReturnResult';
    shipmentId: Scalars['String'];
    success: Scalars['Boolean'];
};

export enum SwapState {
    CANCELLED = 'CANCELLED',
    COMPLETED = 'COMPLETED',
    CREATED = 'CREATED',
    EXPIRED = 'EXPIRED',
    ONGOING = 'ONGOING',
}

export enum SwapUnavailabilityReason {
    CONTRACT_NOT_ACTIVE = 'CONTRACT_NOT_ACTIVE',
    FLAG_DISABLED = 'FLAG_DISABLED',
    NOT_ALLOWED = 'NOT_ALLOWED',
    SWAP_ALREADY_ONGOING = 'SWAP_ALREADY_ONGOING',
    TOO_EARLY = 'TOO_EARLY',
}

/** Autogenerated input type of SyncUserPaymentMethods */
export type SyncUserPaymentMethodsInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SyncUserPaymentMethods */
export type SyncUserPaymentMethodsPayload = {
    __typename?: 'SyncUserPaymentMethodsPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    errors?: Maybe<Array<Scalars['String']>>;
    paymentMethods?: Maybe<Array<PaymentMethod>>;
};

export type TaxInfoResult = {
    __typename?: 'TaxInfoResult';
    countryCode: Scalars['String'];
    taxId: Scalars['String'];
};

export type Team = {
    __typename?: 'Team';
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    title: Scalars['String'];
};

export type TextNoteInterface = {
    text?: Maybe<Scalars['String']>;
};

export enum ThumbsDirection {
    down = 'down',
    up = 'up',
}

export type ThumbsOption = {
    __typename?: 'ThumbsOption';
    direction: ThumbsDirection;
};

export type ThumbsOptions = {
    __typename?: 'ThumbsOptions';
    options: Array<ThumbsOption>;
};

export type ThumbsResult = {
    __typename?: 'ThumbsResult';
    downVotes: Scalars['Int'];
    upVotes: Scalars['Int'];
};

export type ThumbsResults = {
    __typename?: 'ThumbsResults';
    thumbsResults: Array<ThumbsResult>;
    total: TotalResults;
};

export type Ticket = {
    __typename?: 'Ticket';
    entityId: Scalars['String'];
    entityType: EntityType;
    payload: PollOptions;
    pollMode: PollMode;
    ticket: Scalars['String'];
};

export type TimeEstimate = {
    __typename?: 'TimeEstimate';
    atLeast: Duration;
    atMost?: Maybe<Duration>;
};

export type TimestampComparatorInput = {
    _gte?: Maybe<Scalars['DateTime']>;
    _lte?: Maybe<Scalars['DateTime']>;
};

export enum TimeUnit {
    DAYS = 'DAYS',
    HOURS = 'HOURS',
    MINUTES = 'MINUTES',
    MONTHS = 'MONTHS',
    YEARS = 'YEARS',
}

export type TotalResults = {
    __typename?: 'TotalResults';
    userCount: Scalars['Int'];
    voteCount: Scalars['Int'];
};

export type TransactionModel = {
    __typename?: 'TransactionModel';
    accountFrom?: Maybe<Scalars['String']>;
    accountTo?: Maybe<Scalars['String']>;
    amount: Scalars['Money'];
    createdAt: Scalars['DateTime'];
    currency: Scalars['String'];
    failedReason?: Maybe<Scalars['String']>;
    gatewayResponse?: Maybe<Scalars['JSON']>;
    parent?: Maybe<Scalars['String']>;
    status: Scalars['String'];
    type: Scalars['String'];
    uuid: Scalars['ID'];
};

export type TranslateInputType = {
    de: Scalars['String'];
    en: Scalars['String'];
    es: Scalars['String'];
    nl: Scalars['String'];
    placeholder: Scalars['String'];
};

export type TranslateUpdateInputType = {
    de?: Maybe<Scalars['String']>;
    en?: Maybe<Scalars['String']>;
    es?: Maybe<Scalars['String']>;
    nl?: Maybe<Scalars['String']>;
    placeholder?: Maybe<Scalars['String']>;
};

export type TriggerEventMetadata = {
    __typename?: 'TriggerEventMetadata';
    name: Scalars['String'];
    rawPayload: Scalars['JSON'];
    topic: Scalars['String'];
};

export type UnBlockCardInfo = {
    cardId: Scalars['String'];
};

/** Autogenerated input type of UnlockUser */
export type UnlockUserInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    userId: Scalars['ID'];
};

/** Autogenerated return type of UnlockUser */
export type UnlockUserPayload = {
    __typename?: 'UnlockUserPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    user: User;
};

/** Autogenerated input type of UpdateAddress */
export type UpdateAddressInput = {
    additionalInfo?: Maybe<Scalars['String']>;
    billingAddress?: Maybe<Scalars['Boolean']>;
    city?: Maybe<Scalars['String']>;
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    countryIso?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    line1?: Maybe<Scalars['String']>;
    line2?: Maybe<Scalars['String']>;
    shippingAddress?: Maybe<Scalars['Boolean']>;
    stateAbbr?: Maybe<Scalars['String']>;
    zip?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateAddress */
export type UpdateAddressPayload = {
    __typename?: 'UpdateAddressPayload';
    address: Address;
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateAssetInput = {
    activatedAt?: Maybe<Scalars['DateTime']>;
    assetStatus?: Maybe<Scalars['String']>;
    brandName?: Maybe<Scalars['String']>;
    categoryId?: Maybe<Scalars['String']>;
    companyId?: Maybe<Scalars['Int']>;
    contractId?: Maybe<Scalars['String']>;
    employeeId?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    orderNumber?: Maybe<Scalars['String']>;
    price?: Maybe<Scalars['String']>;
    serialNumber?: Maybe<Scalars['String']>;
    terminatedAt?: Maybe<Scalars['DateTime']>;
    uuid: Scalars['String'];
};

export type UpdateCompanyDataInput = {
    companyTypeId?: Maybe<Scalars['Int']>;
    hrv?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
    size?: Maybe<CompanySize>;
    status?: Maybe<Scalars['String']>;
    ust?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCompany */
export type UpdateCompanyInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    data: UpdateCompanyDataInput;
    id: Scalars['ID'];
};

/** Autogenerated return type of UpdateCompany */
export type UpdateCompanyPayload = {
    __typename?: 'UpdateCompanyPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    company: Company;
};

export type UpdateEmployeeInput = {
    address?: Maybe<WorkUpdateAddressInput>;
    email: Scalars['String'];
    externalId?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    phone?: Maybe<Scalars['String']>;
    uuid: Scalars['String'];
};

export type UpdateModel = {
    __typename?: 'UpdateModel';
    /** Number of rows affected */
    affected: Scalars['Float'];
};

/** Input type for updating an account for a contract in the Billing system */
export type UpdatePaymentMethodForContractInput = {
    billingAccountId: Scalars['ID'];
    contractId: Scalars['ID'];
};

export type UpdatePaymentMethodForContractPayload = {
    __typename?: 'UpdatePaymentMethodForContractPayload';
    success: Scalars['Boolean'];
};

export type UpdateScaChallengesInfo = {
    changeRequestId: Scalars['String'];
    deviceId: Scalars['String'];
    scaChallengeId: Scalars['String'];
    /**
     * Follow these steps to generate the signature ->
     * https://docs.solarisbank.com/core/api/v1/#Rsj2t2Uk-put-verify-device-challenge
     */
    signature: Scalars['String'];
};

/** Autogenerated input type of UpdateSubscription */
export type UpdateSubscriptionInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    name: Scalars['String'];
    subscriptionId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSubscription */
export type UpdateSubscriptionPayload = {
    __typename?: 'UpdateSubscriptionPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    subscriptionDetails: SubscriptionDetails;
};

export type UpdateUserDataInput = {
    birthdate?: Maybe<Scalars['ISO8601Date']>;
    email?: Maybe<Scalars['String']>;
    firstName?: Maybe<Scalars['String']>;
    lastName?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    data: UpdateUserDataInput;
    userId: Scalars['ID'];
};

/** Autogenerated input type of UpdateUserNewsletterOptInState */
export type UpdateUserNewsletterOptInStateInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    newState: Scalars['Boolean'];
};

/** Autogenerated return type of UpdateUserNewsletterOptInState */
export type UpdateUserNewsletterOptInStatePayload = {
    __typename?: 'UpdateUserNewsletterOptInStatePayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    user: User;
};

/** Autogenerated return type of UpdateUser */
export type UpdateUserPayload = {
    __typename?: 'UpdateUserPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    user: User;
};

/** Autogenerated input type of UpdateUserTeams */
export type UpdateUserTeamsInput = {
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    teamIds: Array<Scalars['ID']>;
    userId: Scalars['ID'];
};

/** Autogenerated return type of UpdateUserTeams */
export type UpdateUserTeamsPayload = {
    __typename?: 'UpdateUserTeamsPayload';
    /** A unique identifier for the client performing the mutation. */
    clientMutationId?: Maybe<Scalars['String']>;
    user: User;
};

export type UpgradeRentalPlan = {
    __typename?: 'UpgradeRentalPlan';
    availablePlans?: Maybe<Array<RentalPlan>>;
};

export type User = {
    __typename?: 'User';
    activeSubscriptionValue: Price;
    addresses?: Maybe<Array<Address>>;
    billingAddress?: Maybe<Address>;
    birthdate: Scalars['String'];
    company?: Maybe<Company>;
    contracts: ContractConnection;
    country?: Maybe<Country>;
    createdAt: Scalars['ISO8601DateTime'];
    defaultStore: Store;
    devices?: Maybe<AuthDeviceConnection>;
    email: Scalars['String'];
    emailVerified: Scalars['Boolean'];
    failedLoginAttempts: Scalars['Int'];
    firstName: Scalars['String'];
    groupBilling?: Maybe<GroupBilling>;
    id: Scalars['ID'];
    idCheckAvailable: Scalars['Boolean'];
    idCheckRequired: Scalars['Boolean'];
    lastName: Scalars['String'];
    locked: Scalars['Boolean'];
    mixSummary?: Maybe<MixSummary>;
    monthlyTotal: Price;
    newsletterOptInState: Scalars['Boolean'];
    notifications: SendResultConnection;
    /** when filter is cancellable US orders are excluded */
    orders?: Maybe<CartOrderConnection>;
    passwordResetForced?: Maybe<Scalars['Boolean']>;
    paymentMethods: Array<PaymentMethod>;
    payments?: Maybe<PaymentsUnionConnection>;
    pendingSubscriptionValue: Price;
    permissions: Scalars['String'];
    personalIdentifications?: Maybe<Array<PersonalIdentification>>;
    phone?: Maybe<Scalars['String']>;
    phoneVerified: Scalars['Boolean'];
    resetPasswordSentAt?: Maybe<Scalars['ISO8601DateTime']>;
    shippingAddress?: Maybe<Address>;
    signupLanguage: Scalars['String'];
    subscriptionAllowance?: Maybe<Scalars['Int']>;
    subscriptionLimit?: Maybe<Scalars['Int']>;
    subscriptionSummary: Array<SubscriptionSummary>;
    subscriptionsTotal?: Maybe<Scalars['Int']>;
    teams?: Maybe<Array<Team>>;
    type: UserType;
    verificationState: UserVerificationState;
    verifications?: Maybe<VerificationConnection>;
    votes?: Maybe<VotesConnection>;
    waitingListTickets?: Maybe<Array<WaitingListTicket>>;
    xs2a: Xs2a;
};

export type UserContractsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    filter?: Maybe<ContractFilterInput>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type UserDevicesArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    clientDeviceId?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type UserNotificationsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type UserOrdersArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    filter?: Maybe<OrdersFilterInput>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type UserPaymentsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    filter?: Maybe<PaymentsFilterInput>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type UserVerificationsArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type UserVotesArgs = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
    order?: Maybe<VoteOrderInput>;
    where?: Maybe<VoteWhereInput>;
};

export type UserActionMetadata = {
    __typename?: 'UserActionMetadata';
    cancellationReason?: Maybe<ContractCancellationReason>;
    user: User;
};

/** The connection type for User. */
export type UserConnection = {
    __typename?: 'UserConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<UserEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<User>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserEdge = {
    __typename?: 'UserEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<User>;
};

export type UsersWhereInput = {
    and?: Maybe<Array<UsersWhereInput>>;
    companyName?: Maybe<StringComparisonInput>;
    email?: Maybe<StringComparisonInput>;
    id?: Maybe<IntegerComparisonInput>;
    name?: Maybe<StringComparisonInput>;
    phoneNumber?: Maybe<StringComparisonInput>;
    type?: Maybe<UserTypeComparisonInput>;
};

export enum UserType {
    BUSINESS = 'BUSINESS',
    PERSONAL = 'PERSONAL',
}

export type UserTypeComparisonInput = {
    _eq?: Maybe<UserType>;
    _neq?: Maybe<UserType>;
};

export enum UserTypes {
    business = 'business',
    private = 'private',
}

export enum UserVerificationState {
    FAILED = 'FAILED',
    IN_PROGRESS = 'IN_PROGRESS',
    NOT_STARTED = 'NOT_STARTED',
    VERIFIED = 'VERIFIED',
}

export type UuidModel = {
    __typename?: 'UuidModel';
    uuid: Scalars['ID'];
};

export type ValidationResult = {
    valid: Scalars['Boolean'];
};

export type Variant = {
    __typename?: 'Variant';
    available?: Maybe<Scalars['Boolean']>;
    colorCodes?: Maybe<Array<Scalars['String']>>;
    colorTitle?: Maybe<Scalars['String']>;
    coreAttribute?: Maybe<Scalars['String']>;
    deliveryEstimates?: Maybe<DeliveryEstimates>;
    flags?: Maybe<Array<VariantFlag>>;
    id: Scalars['ID'];
    imageUrl: Scalars['String'];
    mixable: Scalars['Boolean'];
    originalImageUrl: Scalars['String'];
    originalPictures: Array<Scalars['String']>;
    preorder?: Maybe<Preorder>;
    product?: Maybe<Product>;
    sku: Scalars['ID'];
};

export type VariantFlag = {
    __typename?: 'VariantFlag';
    createdAt: Scalars['DateTime'];
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    isActive: Scalars['Boolean'];
    name: Scalars['String'];
    store: Scalars['String'];
    updatedAt?: Maybe<Scalars['DateTime']>;
    variant: Variant;
    variantSku: Scalars['String'];
};

export type VariantFlagCreateInput = {
    description?: Maybe<Scalars['String']>;
    isActive: Scalars['Boolean'];
    name: Scalars['String'];
    store: Scalars['String'];
    variantSku: Scalars['String'];
};

export type VariantFlagCreateManyOutput = {
    __typename?: 'VariantFlagCreateManyOutput';
    numberOfCreatedRecords: Scalars['Int'];
};

export type VariantFlagOrderByInput = {
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    store?: Maybe<Scalars['String']>;
    variantSku?: Maybe<Scalars['String']>;
};

export type VariantFlagPaginationOutput = {
    __typename?: 'VariantFlagPaginationOutput';
    rows: Array<VariantFlag>;
    totalCount: Scalars['Int'];
};

export type VariantFlagUpdateInput = {
    description?: Maybe<Scalars['String']>;
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    store?: Maybe<Scalars['String']>;
};

export type VariantFlagWhereInput = {
    isActive?: Maybe<Scalars['Boolean']>;
    name?: Maybe<Scalars['String']>;
    store?: Maybe<Scalars['String']>;
    variantSku?: Maybe<Scalars['String']>;
};

export type Verification = {
    __typename?: 'Verification';
    checkProviderReport: CheckProviderReport;
    completedAt?: Maybe<Scalars['ISO8601DateTime']>;
    createdAt: Scalars['ISO8601DateTime'];
    id: Scalars['ID'];
    processedBy?: Maybe<User>;
    reviewReasons: Array<Scalars['String']>;
    reviews: Array<VerificationReview>;
    state: VerificationState;
    user: User;
    waitingForDays: Scalars['Int'];
};

/** The connection type for Verification. */
export type VerificationConnection = {
    __typename?: 'VerificationConnection';
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<VerificationEdge>>>;
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<Verification>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    totalCount: Scalars['Int'];
};

export enum VerificationDecision {
    APPROVE = 'APPROVE',
    DECLINE = 'DECLINE',
}

export type VerificationDecisionInput = {
    decision: VerificationDecision;
    fieldsForCorrection?: Maybe<Array<Scalars['String']>>;
    verificationId: Scalars['ID'];
};

/** An edge in a connection. */
export type VerificationEdge = {
    __typename?: 'VerificationEdge';
    /** A cursor for use in pagination. */
    cursor: Scalars['String'];
    /** The item at the end of the edge. */
    node?: Maybe<Verification>;
};

export type VerificationReview = FieldReview;

export type VerificationsFilterInput = {
    state?: Maybe<VerificationState>;
    userId?: Maybe<Scalars['ID']>;
};

export enum VerificationState {
    FAILED = 'FAILED',
    PASSED = 'PASSED',
    PENDING = 'PENDING',
}

export type VerifyChangePinInfo = {
    cardId: Scalars['String'];
    changeRequestId: Scalars['String'];
    deviceId: Scalars['String'];
    /**
     * Follow these steps to generate the signature ->
     * https://docs.solarisbank.com/core/api/v1/#Rsj2t2Uk-put-verify-device-challenge
     */
    signature: Scalars['String'];
};

export type VerifyChangeRequestInfo = {
    changeRequestId: Scalars['String'];
    deviceId: Scalars['String'];
    /**
     * Follow these steps to generate the signature ->
     * https://docs.solarisbank.com/core/api/v1/#Rsj2t2Uk-put-verify-device-challenge
     */
    signature: Scalars['String'];
};

export type VerifyChangeRequestResult = {
    __typename?: 'VerifyChangeRequestResult';
    status: Scalars['String'];
};

export type VerifyDeviceAuthInfo = {
    challengeId: Scalars['String'];
    /**
     * Follow these steps to verify the created challenge for the given device ->
     * https://docs.solarisbank.com/core/api/v1/#Rsj2t2Uk-put-verify-device-challenge
     */
    signature: Scalars['String'];
};

export type VerifyDeviceAuthResult = {
    __typename?: 'VerifyDeviceAuthResult';
    status: Scalars['String'];
};

export type VerifyDeviceInfo = {
    deviceId: Scalars['String'];
    /** Follow these steps to generate the signature -> https://docs.solarisbank.com/core/api/v1/#2EGVRkd1-put-verify-device */
    signature: Scalars['String'];
};

export type VerifyDeviceResult = {
    __typename?: 'VerifyDeviceResult';
    status: Scalars['String'];
};

export type Vote = Node & {
    __typename?: 'Vote';
    comment?: Maybe<Scalars['String']>;
    createdAt: Scalars['DateTime'];
    entityId?: Maybe<Scalars['String']>;
    entityType?: Maybe<EntityType>;
    id: Scalars['ID'];
    pollVersion?: Maybe<PollVersion>;
    user?: Maybe<User>;
    userId: Scalars['String'];
    voteSlug: Scalars['String'];
};

export type VoteDateFilterInput = {
    equal?: Maybe<Scalars['DateTime']>;
    greatThan?: Maybe<Scalars['DateTime']>;
};

export enum VoteGroupByDate {
    DAY = 'DAY',
    MONTH = 'MONTH',
    WEEK = 'WEEK',
    YEAR = 'YEAR',
}

export type VoteOrderInput = {
    createdAt?: Maybe<OrderByDirection>;
    updatedAt?: Maybe<OrderByDirection>;
};

export type VotesConnection = {
    __typename?: 'VotesConnection';
    edges: Array<VotesEdge>;
    pageInfo: PageInfo;
};

export type VotesEdge = {
    __typename?: 'VotesEdge';
    cursor: Scalars['String'];
    node: Vote;
};

export type VoteWhereInput = {
    createdAt?: Maybe<VoteDateFilterInput>;
    entityId?: Maybe<Scalars['String']>;
    entityType?: Maybe<EntityType>;
    pollSlug?: Maybe<Scalars['String']>;
    updatedAt?: Maybe<VoteDateFilterInput>;
    userId?: Maybe<Scalars['String']>;
    voteSlug?: Maybe<Scalars['String']>;
    withComments?: Maybe<Scalars['Boolean']>;
};

export type Voucher = {
    __typename?: 'Voucher';
    code: Scalars['String'];
    discount: VoucherDiscount;
};

export type VoucherDiscount = {
    __typename?: 'VoucherDiscount';
    amountOff?: Maybe<Scalars['Int']>;
    percentOff?: Maybe<Scalars['Float']>;
    type: Scalars['String'];
    unitOff?: Maybe<Scalars['Float']>;
    unitType?: Maybe<Scalars['String']>;
};

export type VoucherRedemptionInput = {
    code: Scalars['String'];
    userEmail?: Maybe<Scalars['String']>;
};

export type WaitingList = {
    __typename?: 'WaitingList';
    description?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    slug: Scalars['String'];
    store: Store;
};

export type WaitingListTicket = {
    __typename?: 'WaitingListTicket';
    id: Scalars['ID'];
    state: WaitingListTicketState;
    waitingList: WaitingList;
};

export enum WaitingListTicketState {
    INVITED = 'INVITED',
    WAITING = 'WAITING',
}

export type WalletModel = {
    __typename?: 'WalletModel';
    accounts: Array<AccountType>;
    chosenBillingDay?: Maybe<Scalars['Float']>;
    externalCustomer: Scalars['String'];
    strategy: Scalars['String'];
    uuid: Scalars['ID'];
};

export type WidgetProperties = {
    countdownId?: Maybe<Scalars['String']>;
    excludedCategories?: Maybe<Array<Scalars['String']>>;
};

export type Widgets = {
    __typename?: 'Widgets';
    dealProducts: Array<Scalars['String']>;
    newProducts: Array<Scalars['String']>;
    randomCategoryTopProducts: Array<Scalars['String']>;
    topOrderedProducts: Array<Scalars['String']>;
    topProducts: Array<Scalars['String']>;
};

export type WidgetsRandomCategoryTopProductsArgs = {
    excludedCategories?: Maybe<Array<Scalars['String']>>;
};

export enum WidgetType {
    COUNTDOWN = 'COUNTDOWN',
    DEAL_PRODUCTS = 'DEAL_PRODUCTS',
    HANDPICKED_PRODUCT = 'HANDPICKED_PRODUCT',
    NEW_PRODUCTS = 'NEW_PRODUCTS',
    RANDOM_CATEGORY_TOP_PRODUCTS = 'RANDOM_CATEGORY_TOP_PRODUCTS',
    TOP_ORDERED_PRODUCTS = 'TOP_ORDERED_PRODUCTS',
    TOP_PRODUCTS = 'TOP_PRODUCTS',
}

export type WorkAddress = {
    __typename?: 'WorkAddress';
    additionalInfo?: Maybe<Scalars['String']>;
    address1: Scalars['String'];
    address2: Scalars['String'];
    city: Scalars['String'];
    country: Scalars['String'];
    createdAt: Scalars['DateTime'];
    employeeUuid: Scalars['ID'];
    stateName?: Maybe<Scalars['String']>;
    updatedAt: Scalars['DateTime'];
    updatedBy: Scalars['ID'];
    uuid: Scalars['ID'];
    zipcode: Scalars['String'];
};

/** Union of Work assets */
export type WorkAsset = GroverAsset;

export type WorkAssetEdge = {
    __typename?: 'WorkAssetEdge';
    cursor: Scalars['String'];
    node: WorkAsset;
};

export type WorkAssetsConnection = {
    __typename?: 'WorkAssetsConnection';
    edges?: Maybe<Array<WorkAssetEdge>>;
    matchingCount?: Maybe<Scalars['Float']>;
    nodes?: Maybe<Array<WorkAsset>>;
    pageInfo?: Maybe<WorkPageInfo>;
    totalCount?: Maybe<Scalars['Float']>;
};

export type WorkAssetsFilterInput = {
    joinType?: Maybe<JoinType>;
    predicates: Array<WorkAssetsFilterPredicateJointInput>;
};

export enum WorkAssetsFilterPredicateAttributeType {
    assetStatus = 'assetStatus',
    assignedTo = 'assignedTo',
    brandName = 'brandName',
    categoryId = 'categoryId',
    contractId = 'contractId',
    name = 'name',
    orderNumber = 'orderNumber',
    priceInCents = 'priceInCents',
    serialNumber = 'serialNumber',
}

export type WorkAssetsFilterPredicateInput = {
    attribute: WorkAssetsFilterPredicateAttributeType;
    comparison: ComparisonType;
    type: PredicateType;
    value: Scalars['String'];
};

export type WorkAssetsFilterPredicateJointInput = {
    joinType?: Maybe<JoinType>;
    predicates: Array<WorkAssetsFilterPredicateInput>;
};

export type WorkAssetSortInput = {
    activatedAt?: Maybe<SortOrder>;
    assetStatus?: Maybe<SortOrder>;
    createdAt?: Maybe<SortOrder>;
    name?: Maybe<SortOrder>;
    price?: Maybe<SortOrder>;
    serialNumber?: Maybe<SortOrder>;
    terminatedAt?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
    uuid?: Maybe<SortOrder>;
};

export enum WorkAssetStatus {
    awaiting_return = 'awaiting_return',
    failed_delivery = 'failed_delivery',
    no_status = 'no_status',
    on_rent = 'on_rent',
    preparing_asset = 'preparing_asset',
    preparing_to_ship = 'preparing_to_ship',
    processing_return = 'processing_return',
    purchased = 'purchased',
    rental_declined = 'rental_declined',
    returned = 'returned',
    shipping = 'shipping',
}

export type WorkCreateAddressInput = {
    additionalInfo?: Maybe<Scalars['String']>;
    address1: Scalars['String'];
    address2: Scalars['String'];
    city: Scalars['String'];
    country: Scalars['String'];
    stateName?: Maybe<Scalars['String']>;
    zipcode: Scalars['String'];
};

/** Union of Work employees */
export type WorkEmployee = GroverEmployee;

export type WorkEmployeeConnection = {
    __typename?: 'WorkEmployeeConnection';
    edges?: Maybe<Array<WorkEmployeeEdge>>;
    matchingCount?: Maybe<Scalars['Float']>;
    nodes?: Maybe<Array<WorkEmployee>>;
    pageInfo?: Maybe<WorkPageInfo>;
    totalCount?: Maybe<Scalars['Float']>;
};

export type WorkEmployeeEdge = {
    __typename?: 'WorkEmployeeEdge';
    cursor: Scalars['String'];
    node: WorkEmployee;
};

export type WorkEmployeesFilterInput = {
    joinType?: Maybe<JoinType>;
    predicates: Array<WorkEmployeesFilterPredicateJointInput>;
};

export enum WorkEmployeesFilterPredicateAttributeType {
    city = 'city',
    companyId = 'companyId',
    country = 'country',
    email = 'email',
    externalId = 'externalId',
    name = 'name',
}

export type WorkEmployeesFilterPredicateInput = {
    attribute: WorkEmployeesFilterPredicateAttributeType;
    comparison: ComparisonType;
    type: PredicateType;
    value: Scalars['String'];
};

export type WorkEmployeesFilterPredicateJointInput = {
    joinType?: Maybe<JoinType>;
    predicates: Array<WorkEmployeesFilterPredicateInput>;
};

export type WorkEmployeeSortInput = {
    createdAt?: Maybe<SortOrder>;
    employeeId?: Maybe<SortOrder>;
    name?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
    uuid?: Maybe<SortOrder>;
};

export type WorkPageInfo = {
    __typename?: 'WorkPageInfo';
    endCursor?: Maybe<Scalars['String']>;
    hasNextPage: Scalars['Boolean'];
    hasPreviousPage: Scalars['Boolean'];
    startCursor?: Maybe<Scalars['String']>;
};

export type WorkPaginationInput = {
    after?: Maybe<Scalars['String']>;
    before?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
    last?: Maybe<Scalars['Int']>;
};

export type WorkUpdateAddressInput = {
    additionalInfo?: Maybe<Scalars['String']>;
    address1: Scalars['String'];
    address2: Scalars['String'];
    city: Scalars['String'];
    country: Scalars['String'];
    stateName?: Maybe<Scalars['String']>;
    zipcode: Scalars['String'];
};

export type Xs2a = {
    __typename?: 'Xs2a';
    tracingId: Scalars['String'];
    xs2aSessionKey: Scalars['String'];
    xs2aTransactionId: Scalars['String'];
};

export type CreateSwapOrderMutationMutationVariables = Exact<{
    order?: Maybe<CreateSwapOrderInput>;
}>;

export type CreateSwapOrderMutationMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<
        { __typename?: 'MixCartOrder' } & Pick<
            MixCartOrder,
            'orderNumber' | 'contractId' | 'orderMode' | 'shippingAddressId'
        > & {
                lineItems: Array<
                    Maybe<
                        { __typename?: 'MixLineItem' } & Pick<MixLineItem, 'id' | 'quantity'> & {
                                meta:
                                    | ({ __typename?: 'FlexCartLineItemMeta' } & {
                                          product?: Maybe<
                                              { __typename?: 'Product' } & Pick<
                                                  Product,
                                                  'id' | 'sku' | 'name' | 'slug' | 'coreAttribute'
                                              >
                                          >;
                                          variant: { __typename?: 'LineItemVariant' } & Pick<
                                              LineItemVariant,
                                              | 'id'
                                              | 'sku'
                                              | 'colorCodes'
                                              | 'colorTitle'
                                              | 'imageUrl'
                                              | 'mixable'
                                          >;
                                      })
                                    | ({ __typename?: 'LineItemCatalogMeta' } & {
                                          product?: Maybe<
                                              { __typename?: 'Product' } & Pick<
                                                  Product,
                                                  'id' | 'sku' | 'name' | 'slug' | 'coreAttribute'
                                              >
                                          >;
                                          variant: { __typename?: 'LineItemVariant' } & Pick<
                                              LineItemVariant,
                                              | 'id'
                                              | 'sku'
                                              | 'colorCodes'
                                              | 'colorTitle'
                                              | 'imageUrl'
                                              | 'mixable'
                                          >;
                                      })
                                    | ({ __typename?: 'ReplacedLineItemMeta' } & Pick<
                                          ReplacedLineItemMeta,
                                          'deviceId'
                                      > & {
                                              category?: Maybe<
                                                  { __typename?: 'LineItemCategory' } & Pick<
                                                      LineItemCategory,
                                                      'categoryId' | 'subCategoryId'
                                                  >
                                              >;
                                              replacedItem?: Maybe<
                                                  { __typename?: 'LineItemCatalogMeta' } & {
                                                      variant: {
                                                          __typename?: 'LineItemVariant';
                                                      } & Pick<LineItemVariant, 'sku'>;
                                                      product?: Maybe<
                                                          { __typename?: 'Product' } & Pick<
                                                              Product,
                                                              'sku'
                                                          >
                                                      >;
                                                      category?: Maybe<
                                                          {
                                                              __typename?: 'LineItemCategory';
                                                          } & Pick<
                                                              LineItemCategory,
                                                              'categoryId' | 'subCategoryId'
                                                          >
                                                      >;
                                                  }
                                              >;
                                              product?: Maybe<
                                                  { __typename?: 'Product' } & Pick<
                                                      Product,
                                                      | 'id'
                                                      | 'sku'
                                                      | 'name'
                                                      | 'slug'
                                                      | 'coreAttribute'
                                                  >
                                              >;
                                              variant: { __typename?: 'LineItemVariant' } & Pick<
                                                  LineItemVariant,
                                                  | 'id'
                                                  | 'sku'
                                                  | 'colorCodes'
                                                  | 'colorTitle'
                                                  | 'imageUrl'
                                                  | 'mixable'
                                              >;
                                          });
                            }
                    >
                >;
                itemTotal: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
            }
    >;
};

export type SubmitSwapOrderMutationMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    input?: Maybe<CartOrderSubmitInput>;
}>;

export type SubmitSwapOrderMutationMutation = { __typename?: 'Mutation' } & {
    swapSubmit?: Maybe<
        { __typename?: 'MixCartOrder' } & Pick<
            MixCartOrder,
            'orderNumber' | 'contractId' | 'orderMode' | 'shippingAddressId'
        > & {
                lineItems: Array<
                    Maybe<
                        { __typename?: 'MixLineItem' } & Pick<MixLineItem, 'id' | 'quantity'> & {
                                meta:
                                    | ({ __typename?: 'FlexCartLineItemMeta' } & {
                                          product?: Maybe<
                                              { __typename?: 'Product' } & Pick<
                                                  Product,
                                                  'id' | 'sku' | 'name' | 'slug' | 'coreAttribute'
                                              >
                                          >;
                                          variant: { __typename?: 'LineItemVariant' } & Pick<
                                              LineItemVariant,
                                              | 'id'
                                              | 'sku'
                                              | 'colorCodes'
                                              | 'colorTitle'
                                              | 'imageUrl'
                                              | 'mixable'
                                          >;
                                      })
                                    | ({ __typename?: 'LineItemCatalogMeta' } & {
                                          product?: Maybe<
                                              { __typename?: 'Product' } & Pick<
                                                  Product,
                                                  'id' | 'sku' | 'name' | 'slug' | 'coreAttribute'
                                              >
                                          >;
                                          variant: { __typename?: 'LineItemVariant' } & Pick<
                                              LineItemVariant,
                                              | 'id'
                                              | 'sku'
                                              | 'colorCodes'
                                              | 'colorTitle'
                                              | 'imageUrl'
                                              | 'mixable'
                                          >;
                                      })
                                    | ({ __typename?: 'ReplacedLineItemMeta' } & Pick<
                                          ReplacedLineItemMeta,
                                          'deviceId'
                                      > & {
                                              category?: Maybe<
                                                  { __typename?: 'LineItemCategory' } & Pick<
                                                      LineItemCategory,
                                                      'categoryId' | 'subCategoryId'
                                                  >
                                              >;
                                              replacedItem?: Maybe<
                                                  { __typename?: 'LineItemCatalogMeta' } & {
                                                      variant: {
                                                          __typename?: 'LineItemVariant';
                                                      } & Pick<LineItemVariant, 'sku'>;
                                                      product?: Maybe<
                                                          { __typename?: 'Product' } & Pick<
                                                              Product,
                                                              'sku'
                                                          >
                                                      >;
                                                      category?: Maybe<
                                                          {
                                                              __typename?: 'LineItemCategory';
                                                          } & Pick<
                                                              LineItemCategory,
                                                              'categoryId' | 'subCategoryId'
                                                          >
                                                      >;
                                                  }
                                              >;
                                              product?: Maybe<
                                                  { __typename?: 'Product' } & Pick<
                                                      Product,
                                                      | 'id'
                                                      | 'sku'
                                                      | 'name'
                                                      | 'slug'
                                                      | 'coreAttribute'
                                                  >
                                              >;
                                              variant: { __typename?: 'LineItemVariant' } & Pick<
                                                  LineItemVariant,
                                                  | 'id'
                                                  | 'sku'
                                                  | 'colorCodes'
                                                  | 'colorTitle'
                                                  | 'imageUrl'
                                                  | 'mixable'
                                              >;
                                          });
                            }
                    >
                >;
            }
    >;
};

export type Xsa2SessionKeyQueryVariables = Exact<{ [key: string]: never }>;

export type Xsa2SessionKeyQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & {
            xs2a: { __typename?: 'Xs2a' } & Pick<
                Xs2a,
                'tracingId' | 'xs2aSessionKey' | 'xs2aTransactionId'
            >;
        }
    >;
};

export type CompanyQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyQuery = { __typename?: 'Query' } & {
    company?: Maybe<
        { __typename?: 'Company' } & Pick<
            Company,
            'authorizedByLegalRepresentative' | 'hrv' | 'id' | 'name' | 'status' | 'ust'
        > & {
                user: { __typename?: 'User' } & Pick<
                    User,
                    'id' | 'email' | 'firstName' | 'lastName'
                >;
            }
    >;
};

export type CompanyTypesQueryVariables = Exact<{
    country: Scalars['String'];
}>;

export type CompanyTypesQuery = { __typename?: 'Query' } & {
    companyTypes: Array<
        { __typename?: 'CompanyType' } & Pick<
            CompanyType,
            'id' | 'individual' | 'name' | 'ustIdRequired'
        >
    >;
};

export type UserQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type UserQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<
            User,
            'id' | 'firstName' | 'lastName' | 'birthdate' | 'email' | 'phone' | 'phoneVerified'
        >
    >;
};

export type MutationMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['String']>;
    sessionId?: Maybe<Scalars['String']>;
}>;

export type MutationMutation = { __typename?: 'Mutation' } & {
    createCheckoutAttempt?: Maybe<
        { __typename?: 'CreateCheckoutAttempt' } & Pick<CreateCheckoutAttempt, 'reference'>
    >;
};

export type GetProductFiltersQueryVariables = Exact<{
    permalink?: Maybe<Scalars['String']>;
}>;

export type GetProductFiltersQuery = { __typename?: 'Query' } & {
    category?: Maybe<
        { __typename?: 'Category' } & {
            productFilters?: Maybe<
                Array<
                    | ({ __typename?: 'KeywordFilter' } & Pick<
                          KeywordFilter,
                          'id' | 'name' | 'label' | 'type'
                      >)
                    | ({ __typename?: 'RangeFilter' } & Pick<
                          RangeFilter,
                          'id' | 'name' | 'label' | 'type'
                      > & {
                              rangeFilterConfig: { __typename?: 'RangeFilterConfig' } & Pick<
                                  RangeFilterConfig,
                                  'unit' | 'bucketMin' | 'bucketMax' | 'bucketSize'
                              >;
                          })
                >
            >;
        }
    >;
};

export type CreateWaitingListTicketMutationVariables = Exact<{
    input: CreateWaitingListTicketInput;
}>;

export type CreateWaitingListTicketMutation = { __typename?: 'Mutation' } & {
    createWaitingListTicket?: Maybe<
        { __typename?: 'CreateWaitingListTicketPayload' } & Pick<
            CreateWaitingListTicketPayload,
            'clientMutationId'
        > & {
                waitingListTicket: { __typename?: 'WaitingListTicket' } & Pick<
                    WaitingListTicket,
                    'id' | 'state'
                > & {
                        waitingList: { __typename?: 'WaitingList' } & Pick<
                            WaitingList,
                            'id' | 'slug'
                        >;
                    };
            }
    >;
};

export type CancelOrderEarlyMutationVariables = Exact<{
    input: CancelOrderEarlyInput;
}>;

export type CancelOrderEarlyMutation = { __typename?: 'Mutation' } & {
    cancelOrderEarly?: Maybe<
        { __typename?: 'CancelOrderEarlyPayload' } & Pick<
            CancelOrderEarlyPayload,
            'clientMutationId'
        > & {
                contracts: Array<
                    | ({ __typename?: 'Flex' } & Pick<Flex, 'id'> & {
                              contractState: Flex['state'];
                          })
                    | ({ __typename?: 'Mix' } & Pick<Mix, 'id' | 'state'>)
                >;
            }
    >;
};

export type CastVoteMutationMutationVariables = Exact<{
    voteSlug: Scalars['String'];
    ticket: Scalars['String'];
    comment?: Maybe<Scalars['String']>;
}>;

export type CastVoteMutationMutation = { __typename?: 'Mutation' } & {
    castVote: { __typename?: 'Vote' } & Pick<
        Vote,
        'voteSlug' | 'comment' | 'userId' | 'entityId' | 'entityType'
    >;
};

export type GetVotingTicketMutationMutationVariables = Exact<{
    entityId: Scalars['String'];
    slug: Scalars['String'];
}>;

export type GetVotingTicketMutationMutation = { __typename?: 'Mutation' } & {
    getVotingTicket: { __typename?: 'Ticket' } & Pick<
        Ticket,
        'ticket' | 'entityId' | 'entityType' | 'pollMode'
    > & {
            payload:
                | { __typename?: 'MoodOptions' }
                | ({ __typename?: 'SingleChoiceOptions' } & {
                      options: Array<
                          { __typename?: 'SingleChoiceOption' } & Pick<
                              SingleChoiceOption,
                              'slug' | 'label'
                          >
                      >;
                  })
                | { __typename?: 'ThumbsOptions' };
        };
};

export type OrderSubscriptionsQueryVariables = Exact<{
    first?: Maybe<Scalars['Int']>;
    filter: SubscriptionListFilterInput;
}>;

export type OrderSubscriptionsQuery = { __typename?: 'Query' } & {
    subscriptionCollection?: Maybe<
        { __typename?: 'SubscriptionListEntryConnection' } & Pick<
            SubscriptionListEntryConnection,
            'totalCount'
        > & {
                nodes?: Maybe<
                    Array<
                        Maybe<
                            | ({ __typename?: 'SubscriptionCard' } & Pick<
                                  SubscriptionCard,
                                  'id' | 'name' | 'state'
                              > & {
                                      note?: Maybe<
                                          | ({ __typename?: 'AttentionNote' } & Pick<
                                                AttentionNote,
                                                'text'
                                            >)
                                          | ({ __typename?: 'EndedNote' } & Pick<EndedNote, 'text'>)
                                          | ({ __typename?: 'NextPaymentNote' } & Pick<
                                                NextPaymentNote,
                                                'date'
                                            > & {
                                                    paymentMethod?: Maybe<
                                                        | { __typename: 'ByInvoice' }
                                                        | { __typename: 'Card' }
                                                        | { __typename: 'Paypal' }
                                                        | { __typename: 'Sepa' }
                                                    >;
                                                })
                                          | ({ __typename?: 'PausedNote' } & Pick<
                                                PausedNote,
                                                'text'
                                            >)
                                          | ({ __typename?: 'ProcessingNote' } & Pick<
                                                ProcessingNote,
                                                'text'
                                            >)
                                      >;
                                      variant: { __typename?: 'Variant' } & Pick<
                                          Variant,
                                          'id' | 'colorCodes' | 'colorTitle' | 'imageUrl'
                                      >;
                                  })
                            | ({ __typename?: 'SubscriptionStack' } & Pick<
                                  SubscriptionStack,
                                  'quantity'
                              > & {
                                      filter: { __typename?: 'SubscriptionListFilter' } & Pick<
                                          SubscriptionListFilter,
                                          'state' | 'orderId' | 'productId'
                                      >;
                                      product: { __typename?: 'Product' } & Pick<
                                          Product,
                                          'id' | 'name' | 'imageUrl'
                                      >;
                                  })
                        >
                    >
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<PageInfo, 'hasNextPage'>;
            }
    >;
};

export type GetProductsPromotionsQueryVariables = Exact<{
    skus: Array<Scalars['String']> | Scalars['String'];
    productCustomizationServiceDataFetchingEnabled: Scalars['Boolean'];
    showProductEnergyLabelEnabled: Scalars['Boolean'];
}>;

export type GetProductsPromotionsQuery = { __typename?: 'Query' } & {
    products?: Maybe<
        Array<
            { __typename?: 'Product' } & Pick<Product, 'id' | 'sku'> & {
                    rentalPlans?: Maybe<
                        { __typename?: 'RentalPlan' } & Pick<RentalPlan, 'id'> & {
                                length: { __typename?: 'Duration' } & Pick<Duration, 'value'>;
                                discount?: Maybe<
                                    { __typename?: 'RentalPlanDiscount' } & Pick<
                                        RentalPlanDiscount,
                                        'percentage'
                                    >
                                >;
                            }
                    >;
                    energyLabel?: Maybe<
                        { __typename?: 'EnergyLabel' } & Pick<EnergyLabel, 'energyRating'>
                    >;
                    variants?: Maybe<
                        { __typename?: 'Variant' } & Pick<Variant, 'id'> & {
                                flags?: Maybe<
                                    Array<
                                        { __typename?: 'VariantFlag' } & Pick<
                                            VariantFlag,
                                            'name' | 'isActive'
                                        >
                                    >
                                >;
                            }
                    >;
                    countdownTimers?: Maybe<
                        { __typename?: 'CountdownTimer' } & Pick<
                            CountdownTimer,
                            'id' | 'startAt' | 'endAt' | 'isActive' | 'storeCodes'
                        >
                    >;
                }
        >
    >;
};

export type GetProductsWidgetsQueryVariables = Exact<{
    where?: Maybe<ProductsWidgetWhereInput>;
    limit?: Maybe<Scalars['Int']>;
    offset?: Maybe<Scalars['Int']>;
}>;

export type GetProductsWidgetsQuery = { __typename?: 'Query' } & {
    productsWidgets: { __typename?: 'ProductsWidgetPaginationOutput' } & Pick<
        ProductsWidgetPaginationOutput,
        'totalCount'
    > & {
            rows: Array<
                { __typename?: 'ProductsWidget' } & Pick<
                    ProductsWidget,
                    'type' | 'name' | 'properties'
                > & {
                        products?: Maybe<
                            Array<
                                { __typename?: 'Product' } & Pick<
                                    Product,
                                    | 'id'
                                    | 'sku'
                                    | 'slug'
                                    | 'name'
                                    | 'promotionalLabel'
                                    | 'isNew'
                                    | 'coreAttribute'
                                    | 'originalImageUrl'
                                    | 'brandName'
                                > & {
                                        variants: Array<
                                            { __typename?: 'Variant' } & Pick<
                                                Variant,
                                                'id' | 'mixable'
                                            > & {
                                                    flags?: Maybe<
                                                        Array<
                                                            { __typename?: 'VariantFlag' } & Pick<
                                                                VariantFlag,
                                                                'name' | 'isActive'
                                                            >
                                                        >
                                                    >;
                                                }
                                        >;
                                        rentalPlans: Array<
                                            { __typename?: 'RentalPlan' } & Pick<
                                                RentalPlan,
                                                'id'
                                            > & {
                                                    discount?: Maybe<
                                                        {
                                                            __typename?: 'RentalPlanDiscount';
                                                        } & Pick<RentalPlanDiscount, 'percentage'>
                                                    >;
                                                    price: { __typename?: 'Price' } & Pick<
                                                        Price,
                                                        'inCents'
                                                    >;
                                                    length: { __typename?: 'Duration' } & Pick<
                                                        Duration,
                                                        'unit' | 'value'
                                                    >;
                                                    oldPrice?: Maybe<
                                                        { __typename?: 'Price' } & Pick<
                                                            Price,
                                                            'inCents'
                                                        >
                                                    >;
                                                }
                                        >;
                                        category: { __typename?: 'Category' } & Pick<
                                            Category,
                                            'iconSvgPath' | 'id' | 'title' | 'permalink'
                                        > & {
                                                parent?: Maybe<
                                                    { __typename?: 'Category' } & Pick<
                                                        Category,
                                                        'iconSvgPath' | 'id' | 'title' | 'permalink'
                                                    >
                                                >;
                                            };
                                    }
                            >
                        >;
                    }
            >;
        };
};

export type ContractPurchaseDetailsQueryVariables = Exact<{
    contractId: Scalars['ID'];
}>;

export type ContractPurchaseDetailsQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id'> & {
                  goods: Array<
                      { __typename?: 'FlexDevice' } & Pick<FlexDevice, 'id'> & {
                              product: { __typename?: 'Product' } & Pick<Product, 'id' | 'name'> & {
                                      category: { __typename?: 'Category' } & Pick<
                                          Category,
                                          'id' | 'name'
                                      >;
                                  };
                              variant: { __typename?: 'Variant' } & Pick<
                                  Variant,
                                  'id' | 'imageUrl'
                              >;
                          }
                  >;
                  billingTerms: { __typename?: 'BillingTerms' } & {
                      price: { __typename?: 'Price' } & Pick<Price, 'inCents' | 'currency'>;
                  };
                  purchaseTerm?: Maybe<
                      { __typename?: 'PurchaseTerm' } & Pick<
                          PurchaseTerm,
                          'monthsRequired' | 'remainingMonths'
                      > & {
                              currentPrice: { __typename?: 'Price' } & Pick<
                                  Price,
                                  'inCents' | 'currency'
                              >;
                          }
                  >;
                  flow?: Maybe<
                      | { __typename?: 'Completion' }
                      | ({ __typename?: 'Purchase' } & Pick<Purchase, 'state'>)
                      | { __typename?: 'Replacement' }
                      | { __typename?: 'Revocation' }
                  >;
                  contractPaymentMethod?: Maybe<
                      | { __typename?: 'ByInvoice' }
                      | ({ __typename?: 'Card' } & Pick<Card, 'lastDigits'>)
                      | ({ __typename?: 'Paypal' } & Pick<Paypal, 'email'>)
                      | ({ __typename?: 'Sepa' } & Pick<Sepa, 'ibanLastDigits'>)
                  >;
              })
        | { __typename?: 'SubscriptionDetails' }
    >;
};

export type StartPurchaseMutationVariables = Exact<{
    input: StartPurchaseInput;
}>;

export type StartPurchaseMutation = { __typename?: 'Mutation' } & {
    startPurchase?: Maybe<
        { __typename?: 'StartPurchasePayload' } & {
            contract: { __typename?: 'Flex' } & StartedPurchaseContractFragment;
        }
    >;
};

export type StartedPurchaseContractFragment = { __typename?: 'Flex' } & Pick<Flex, 'id'> & {
        contractState: Flex['state'];
    } & {
        note?: Maybe<
            | ({ __typename?: 'AttentionNote' } & Pick<AttentionNote, 'text'>)
            | ({ __typename?: 'EndedNote' } & Pick<EndedNote, 'text'>)
            | ({ __typename?: 'NextPaymentNote' } & Pick<NextPaymentNote, 'date'> & {
                      paymentMethod?: Maybe<
                          | { __typename: 'ByInvoice' }
                          | { __typename: 'Card' }
                          | { __typename: 'Paypal' }
                          | { __typename: 'Sepa' }
                      >;
                  })
            | ({ __typename?: 'PausedNote' } & Pick<PausedNote, 'text'>)
            | ({ __typename?: 'ProcessingNote' } & Pick<ProcessingNote, 'text'>)
        >;
        flow?: Maybe<
            | { __typename?: 'Completion' }
            | ({ __typename?: 'Purchase' } & Pick<Purchase, 'state'>)
            | { __typename?: 'Replacement' }
            | { __typename?: 'Revocation' }
        >;
    };

export type SubscriptionNoteQueryVariables = Exact<{
    subscriptionId: Scalars['ID'];
}>;

export type SubscriptionNoteQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | { __typename?: 'Flex' }
        | ({ __typename?: 'SubscriptionDetails' } & Pick<SubscriptionDetails, 'id' | 'state'> & {
                  note?: Maybe<
                      | ({ __typename?: 'AttentionNote' } & Pick<AttentionNote, 'text'>)
                      | ({ __typename?: 'EndedNote' } & Pick<EndedNote, 'text'>)
                      | ({ __typename?: 'NextPaymentNote' } & Pick<NextPaymentNote, 'date'> & {
                                paymentMethod?: Maybe<
                                    | { __typename: 'ByInvoice' }
                                    | { __typename: 'Card' }
                                    | { __typename: 'Paypal' }
                                    | { __typename: 'Sepa' }
                                >;
                            })
                      | ({ __typename?: 'PausedNote' } & Pick<PausedNote, 'text'>)
                      | ({ __typename?: 'ProcessingNote' } & Pick<ProcessingNote, 'text'>)
                  >;
              })
    >;
};

export type SubscriptionPurchaseDetailsQueryVariables = Exact<{
    subscriptionId: Scalars['ID'];
}>;

export type SubscriptionPurchaseDetailsQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | { __typename?: 'Flex' }
        | ({ __typename?: 'SubscriptionDetails' } & Pick<SubscriptionDetails, 'id' | 'sfId'> & {
                  price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                  product?: Maybe<
                      { __typename?: 'Product' } & Pick<Product, 'id' | 'name'> & {
                              category: { __typename?: 'Category' } & Pick<Category, 'id' | 'name'>;
                          }
                  >;
                  variant?: Maybe<{ __typename?: 'Variant' } & Pick<Variant, 'id' | 'imageUrl'>>;
                  paymentMethod:
                      | { __typename?: 'ByInvoice' }
                      | ({ __typename?: 'Card' } & Pick<Card, 'lastDigits'>)
                      | ({ __typename?: 'Paypal' } & Pick<Paypal, 'email'>)
                      | ({ __typename?: 'Sepa' } & Pick<Sepa, 'ibanLastDigits'>);
              })
    >;
};

export type GetRentalPlanTestsQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type GetRentalPlanTestsQuery = { __typename?: 'Query' } & {
    category?: Maybe<
        { __typename?: 'Category' } & Pick<Category, 'id' | 'name'> & {
                rentalPlanTests?: Maybe<
                    Array<
                        { __typename?: 'RentalPlanTest' } & Pick<
                            RentalPlanTest,
                            'status' | 'planVisibilityTests'
                        > & { store?: Maybe<{ __typename?: 'Store' } & Pick<Store, 'code'>> }
                    >
                >;
            }
    >;
};

export type CastReturnReasonMutationVariables = Exact<{
    voteSlug: Scalars['String'];
    ticket: Scalars['String'];
}>;

export type CastReturnReasonMutation = { __typename?: 'Mutation' } & {
    castVote: { __typename?: 'Vote' } & Pick<Vote, 'voteSlug'>;
};

export type GetDeviceLockStatusQueryVariables = Exact<{
    contractId?: Maybe<Scalars['ID']>;
}>;

export type GetDeviceLockStatusQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | { __typename?: 'Flex' }
        | ({ __typename?: 'SubscriptionDetails' } & {
              asset?: Maybe<{ __typename?: 'Asset' } & Pick<Asset, 'isDeviceLocked'>>;
          })
    >;
};

export type GetReturnReasonOptionsMutationVariables = Exact<{
    slug: Scalars['String'];
    subscriptionId: Scalars['String'];
}>;

export type GetReturnReasonOptionsMutation = { __typename?: 'Mutation' } & {
    getVotingTicket: { __typename?: 'Ticket' } & Pick<Ticket, 'ticket'> & {
            payload:
                | { __typename?: 'MoodOptions' }
                | ({ __typename?: 'SingleChoiceOptions' } & {
                      options: Array<
                          { __typename?: 'SingleChoiceOption' } & Pick<
                              SingleChoiceOption,
                              'label' | 'slug'
                          >
                      >;
                  })
                | { __typename?: 'ThumbsOptions' };
        };
};

export type YourOptionsQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type YourOptionsQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | { __typename?: 'Flex' }
        | ({ __typename: 'SubscriptionDetails' } & Pick<SubscriptionDetails, 'id'> & {
                  basePrice: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                  minimumDuration?: Maybe<
                      { __typename?: 'Duration' } & Pick<Duration, 'unit' | 'value'>
                  >;
                  payments: { __typename?: 'PaymentsUnionConnection' } & {
                      nodes?: Maybe<
                          Array<
                              Maybe<
                                  | { __typename?: 'GroupPayment' }
                                  | ({ __typename?: 'OrderPayment' } & Pick<OrderPayment, 'state'>)
                                  | { __typename?: 'PurchasePayment' }
                                  | ({ __typename?: 'SubscriptionPayment' } & Pick<
                                        SubscriptionPayment,
                                        'state'
                                    >)
                              >
                          >
                      >;
                  };
                  subscriptionActions: Array<
                      | { __typename?: 'Buyout' }
                      | { __typename?: 'CancelSubscription' }
                      | { __typename?: 'ChangePaymentMethod' }
                      | { __typename?: 'PaymentMethodPresenter' }
                      | { __typename?: 'PrintReturnLabel' }
                      | { __typename?: 'ReportDamage' }
                      | { __typename?: 'SupportRequest' }
                      | ({ __typename?: 'UpgradeRentalPlan' } & {
                            availablePlans?: Maybe<
                                Array<
                                    { __typename?: 'RentalPlan' } & Pick<RentalPlan, 'id'> & {
                                            price: { __typename?: 'Price' } & Pick<
                                                Price,
                                                'currency' | 'inCents'
                                            >;
                                        }
                                >
                            >;
                        })
                  >;
              })
    >;
};

export type ApplySurpriseDiscountMutationVariables = Exact<{
    input: ApplySurpriseDiscountInput;
}>;

export type ApplySurpriseDiscountMutation = { __typename?: 'Mutation' } & {
    applySurpriseDiscount?: Maybe<
        { __typename?: 'ApplySurpriseDiscountPayload' } & Pick<
            ApplySurpriseDiscountPayload,
            'errors'
        >
    >;
};

export type CompleteContractMutationVariables = Exact<{
    input: CompleteContractInput;
}>;

export type CompleteContractMutation = { __typename?: 'Mutation' } & {
    completeContract?: Maybe<
        { __typename?: 'CompleteContractPayload' } & Pick<
            CompleteContractPayload,
            'clientMutationId'
        > & {
                contract?: Maybe<
                    | ({ __typename?: 'Flex' } & Pick<Flex, 'id'>)
                    | ({ __typename?: 'Mix' } & Pick<Mix, 'id'>)
                >;
            }
    >;
};

export type ContractReturnStepsQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type ContractReturnStepsQuery = { __typename?: 'Query' } & {
    contract:
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id'> & {
                  goods: Array<
                      { __typename?: 'FlexDevice' } & Pick<FlexDevice, 'id'> & {
                              product: { __typename?: 'Product' } & Pick<Product, 'id'> & {
                                      returnSteps: Array<
                                          | ({ __typename?: 'AccessoriesReturnStep' } & Pick<
                                                AccessoriesReturnStep,
                                                | 'name'
                                                | 'accessories'
                                                | 'description'
                                                | 'headline'
                                                | 'warning'
                                            >)
                                          | ({ __typename?: 'ConfirmableReturnStep' } & Pick<
                                                ConfirmableReturnStep,
                                                | 'name'
                                                | 'checkbox'
                                                | 'description'
                                                | 'headline'
                                                | 'warning'
                                            >)
                                          | ({ __typename?: 'ReturnStepsOutcome' } & Pick<
                                                ReturnStepsOutcome,
                                                'name'
                                            >)
                                      >;
                                  };
                          }
                  >;
              })
        | ({ __typename?: 'Mix' } & Pick<Mix, 'id'> & {
                  goods: Array<
                      { __typename?: 'MixDevice' } & Pick<MixDevice, 'id'> & {
                              product: { __typename?: 'Product' } & Pick<Product, 'id'> & {
                                      returnSteps: Array<
                                          | ({ __typename?: 'AccessoriesReturnStep' } & Pick<
                                                AccessoriesReturnStep,
                                                | 'name'
                                                | 'accessories'
                                                | 'description'
                                                | 'headline'
                                                | 'warning'
                                            >)
                                          | ({ __typename?: 'ConfirmableReturnStep' } & Pick<
                                                ConfirmableReturnStep,
                                                | 'name'
                                                | 'checkbox'
                                                | 'description'
                                                | 'headline'
                                                | 'warning'
                                            >)
                                          | ({ __typename?: 'ReturnStepsOutcome' } & Pick<
                                                ReturnStepsOutcome,
                                                'name'
                                            >)
                                      >;
                                  };
                          }
                  >;
              });
};

export type CreateSwapReturnShipmentMutationVariables = Exact<{
    sync?: Maybe<Scalars['Boolean']>;
    orderNumber: Scalars['String'];
}>;

export type CreateSwapReturnShipmentMutation = { __typename?: 'Mutation' } & {
    createSwapReturnShipment: { __typename?: 'SwapReturnResult' } & Pick<
        SwapReturnResult,
        'success'
    >;
};

export type CurrentMixSwapQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentMixSwapQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                mixSummary?: Maybe<
                    { __typename?: 'MixSummary' } & Pick<MixSummary, 'contractId'> & {
                            swap?: Maybe<
                                { __typename?: 'Swap' } & Pick<
                                    Swap,
                                    'id' | 'shippingLabelUrl' | 'orderNumber'
                                > & {
                                        oldDevice: { __typename?: 'MixDevice' } & Pick<
                                            MixDevice,
                                            'id'
                                        > & {
                                                product: { __typename?: 'Product' } & Pick<
                                                    Product,
                                                    'id' | 'name'
                                                > & {
                                                        returnSteps: Array<
                                                            | ({
                                                                  __typename?: 'AccessoriesReturnStep';
                                                              } & Pick<
                                                                  AccessoriesReturnStep,
                                                                  | 'name'
                                                                  | 'accessories'
                                                                  | 'description'
                                                                  | 'headline'
                                                                  | 'warning'
                                                              >)
                                                            | ({
                                                                  __typename?: 'ConfirmableReturnStep';
                                                              } & Pick<
                                                                  ConfirmableReturnStep,
                                                                  | 'name'
                                                                  | 'checkbox'
                                                                  | 'description'
                                                                  | 'headline'
                                                                  | 'warning'
                                                              >)
                                                            | ({
                                                                  __typename?: 'ReturnStepsOutcome';
                                                              } & Pick<ReturnStepsOutcome, 'name'>)
                                                        >;
                                                    };
                                                variant: { __typename?: 'Variant' } & Pick<
                                                    Variant,
                                                    'id' | 'imageUrl'
                                                >;
                                            };
                                    }
                            >;
                        }
                >;
            }
    >;
};

export type FlexReturnLabelUrlQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type FlexReturnLabelUrlQuery = { __typename?: 'Query' } & {
    contract:
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id'> & {
                  shipmentLabels?: Maybe<
                      Array<
                          { __typename?: 'ShipmentLabel' } & Pick<
                              ShipmentLabel,
                              'shippingLabelUrl'
                          > & { id: ShipmentLabel['assetUid'] }
                      >
                  >;
              })
        | { __typename?: 'Mix' };
};

export type MixSwapReturnLabelQueryVariables = Exact<{ [key: string]: never }>;

export type MixSwapReturnLabelQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                mixSummary?: Maybe<
                    { __typename?: 'MixSummary' } & Pick<MixSummary, 'contractId'> & {
                            swap?: Maybe<
                                { __typename?: 'Swap' } & Pick<Swap, 'id' | 'shippingLabelUrl'>
                            >;
                        }
                >;
            }
    >;
};

export type SurpriseDiscountQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type SurpriseDiscountQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | { __typename?: 'Flex' }
        | ({ __typename?: 'SubscriptionDetails' } & Pick<SubscriptionDetails, 'id'> & {
                  surpriseDiscount?: Maybe<
                      { __typename?: 'SurpriseDiscount' } & Pick<SurpriseDiscount, 'percentage'> & {
                              newBuyoutTerms?: Maybe<
                                  { __typename?: 'MonthsToOwn' } & Pick<
                                      MonthsToOwn,
                                      'availableSince' | 'monthsRequired' | 'monthsToCoverRemaining'
                                  >
                              >;
                          }
                  >;
              })
    >;
};

export type ContractPaymentMethodQueryVariables = Exact<{
    contractId: Scalars['ID'];
}>;

export type ContractPaymentMethodQuery = { __typename?: 'Query' } & {
    contract:
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id'> & {
                  paymentMethod?: Maybe<
                      | ({ __typename?: 'ByInvoice' } & Pick<ByInvoice, 'billingAccountId'> & {
                                id: ByInvoice['billingAccountId'];
                            })
                      | ({ __typename?: 'Card' } & Pick<
                            Card,
                            'billingAccountId' | 'brand' | 'lastDigits'
                        > & { id: Card['billingAccountId'] })
                      | ({ __typename?: 'Paypal' } & Pick<Paypal, 'billingAccountId' | 'email'> & {
                                id: Paypal['billingAccountId'];
                            })
                      | ({ __typename?: 'Sepa' } & Pick<
                            Sepa,
                            'billingAccountId' | 'ibanLastDigits'
                        > & { id: Sepa['billingAccountId'] })
                  >;
              })
        | ({ __typename?: 'Mix' } & Pick<Mix, 'id'> & {
                  paymentMethod?: Maybe<
                      | ({ __typename?: 'ByInvoice' } & Pick<ByInvoice, 'billingAccountId'> & {
                                id: ByInvoice['billingAccountId'];
                            })
                      | ({ __typename?: 'Card' } & Pick<
                            Card,
                            'billingAccountId' | 'brand' | 'lastDigits'
                        > & { id: Card['billingAccountId'] })
                      | ({ __typename?: 'Paypal' } & Pick<Paypal, 'billingAccountId' | 'email'> & {
                                id: Paypal['billingAccountId'];
                            })
                      | ({ __typename?: 'Sepa' } & Pick<
                            Sepa,
                            'billingAccountId' | 'ibanLastDigits'
                        > & { id: Sepa['billingAccountId'] })
                  >;
              });
};

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type PaymentMethodsQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                paymentMethods: Array<
                    | ({ __typename?: 'ByInvoice' } & Pick<ByInvoice, 'billingAccountId'> & {
                              id: ByInvoice['billingAccountId'];
                          })
                    | ({ __typename?: 'Card' } & Pick<
                          Card,
                          'billingAccountId' | 'brand' | 'lastDigits'
                      > & { id: Card['billingAccountId'] })
                    | ({ __typename?: 'Paypal' } & Pick<Paypal, 'billingAccountId' | 'email'> & {
                              id: Paypal['billingAccountId'];
                          })
                    | ({ __typename?: 'Sepa' } & Pick<
                          Sepa,
                          'billingAccountId' | 'ibanLastDigits'
                      > & { id: Sepa['billingAccountId'] })
                >;
            }
    >;
};

export type SubscriptionPaymentMethodQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type SubscriptionPaymentMethodQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | { __typename?: 'Flex' }
        | ({ __typename?: 'SubscriptionDetails' } & Pick<SubscriptionDetails, 'id' | 'sfId'> & {
                  paymentMethod:
                      | { __typename?: 'ByInvoice' }
                      | ({ __typename?: 'Card' } & Pick<Card, 'lastDigits'>)
                      | ({ __typename?: 'Paypal' } & Pick<Paypal, 'email'>)
                      | ({ __typename?: 'Sepa' } & Pick<Sepa, 'ibanLastDigits'>);
              })
    >;
};

export type UpdatePaymentMethodForContractMutationVariables = Exact<{
    input: UpdatePaymentMethodForContractInput;
}>;

export type UpdatePaymentMethodForContractMutation = { __typename?: 'Mutation' } & {
    updatePaymentMethodForContract: { __typename?: 'UpdatePaymentMethodForContractPayload' } & Pick<
        UpdatePaymentMethodForContractPayload,
        'success'
    >;
};

export type CancelSwapMutationVariables = Exact<{
    input: CancelSwapInput;
}>;

export type CancelSwapMutation = { __typename?: 'Mutation' } & {
    cancelSwap?: Maybe<
        { __typename?: 'CancelSwapPayload' } & Pick<
            CancelSwapPayload,
            'clientMutationId' | 'error'
        > & {
                swap?: Maybe<
                    { __typename?: 'Swap' } & Pick<
                        Swap,
                        'cancelledAt' | 'createdAt' | 'id' | 'orderNumber' | 'state'
                    > & {
                            newDevice: { __typename?: 'MixDevice' } & Pick<MixDevice, 'state'>;
                            oldDevice: { __typename?: 'MixDevice' } & Pick<MixDevice, 'state'>;
                        }
                >;
            }
    >;
};

export type DismissCampaignMutationVariables = Exact<{
    externalEntity: Scalars['String'];
    entity: Scalars['String'];
    campaignUuid: Scalars['String'];
}>;

export type DismissCampaignMutation = { __typename?: 'Mutation' } & {
    dismissCampaign: { __typename?: 'DismissModel' } & Pick<
        DismissModel,
        'entity' | 'externalEntity' | 'campaignUuid'
    >;
};

export type DismissMarketingContentMutationVariables = Exact<{
    campaignUuid: Scalars['String'];
}>;

export type DismissMarketingContentMutation = { __typename?: 'Mutation' } & {
    dismiss: { __typename?: 'DismissModel' } & Pick<DismissModel, 'campaignUuid'>;
};

export type FlexShipmentDataQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type FlexShipmentDataQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id' | 'orderNumber'> & {
                  contractState: Flex['state'];
                  contractName: Flex['name'];
              } & {
                  goods: Array<
                      { __typename?: 'FlexDevice' } & Pick<
                          FlexDevice,
                          'id' | 'assetId' | 'state'
                      > & {
                              outboundShipmentLabel?: Maybe<
                                  { __typename?: 'ShipmentLabel' } & Pick<
                                      ShipmentLabel,
                                      'shippingLabelUrl' | 'trackingUrl' | 'trackingStatus' | 'type'
                                  >
                              >;
                              shipmentLabel?: Maybe<
                                  { __typename?: 'ShipmentLabel' } & Pick<
                                      ShipmentLabel,
                                      'shippingLabelUrl' | 'trackingUrl' | 'trackingStatus' | 'type'
                                  >
                              >;
                          }
                  >;
              })
        | { __typename?: 'SubscriptionDetails' }
    >;
};

export type UserGroupBillingQueryVariables = Exact<{ [key: string]: never }>;

export type UserGroupBillingQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                groupBilling?: Maybe<
                    { __typename?: 'GroupBilling' } & Pick<GroupBilling, 'enabled'>
                >;
            }
    >;
};

export type GetVotingTicketThumbsMutationMutationVariables = Exact<{
    slug: Scalars['String'];
}>;

export type GetVotingTicketThumbsMutationMutation = { __typename?: 'Mutation' } & {
    getVotingTicket: { __typename?: 'Ticket' } & Pick<Ticket, 'pollMode' | 'ticket'>;
};

export type MarketingContentQueryVariables = Exact<{
    page?: Maybe<Scalars['String']>;
    platform?: Maybe<PlatformTypes>;
}>;

export type MarketingContentQuery = { __typename?: 'Query' } & {
    MarketingContent: Array<
        | ({ __typename?: 'BasicMarketingCardModel' } & Pick<
              BasicMarketingCardModel,
              'uuid' | 'imageUrl' | 'bodyTemplate' | 'largeImage' | 'colorFunction'
          > & {
                  actions?: Maybe<
                      Array<
                          | ({ __typename?: 'CopyToClipboardActionModel' } & Pick<
                                CopyToClipboardActionModel,
                                'text' | 'value'
                            >)
                          | { __typename?: 'LaunchFlowActionModel' }
                          | ({ __typename?: 'LinkActionModel' } & Pick<
                                LinkActionModel,
                                'text' | 'path'
                            >)
                      >
                  >;
              })
        | ({ __typename?: 'PollCardModel' } & Pick<PollCardModel, 'pollSlug' | 'uuid'> & {
                  copy: { __typename?: 'PollCardCopyModel' } & {
                      voteStep: { __typename?: 'PollCardItemModel' } & Pick<
                          PollCardItemModel,
                          'title' | 'body'
                      >;
                      commentStep: { __typename?: 'PollCardCommentStepModel' } & Pick<
                          PollCardCommentStepModel,
                          'title' | 'body' | 'buttonLabel'
                      >;
                      positiveOutcome: { __typename?: 'PollCardItemModel' } & Pick<
                          PollCardItemModel,
                          'title' | 'body'
                      >;
                      negativeOutcome: { __typename?: 'PollCardItemModel' } & Pick<
                          PollCardItemModel,
                          'title' | 'body'
                      >;
                  };
              })
        | { __typename?: 'SubscriptionBadgeModel' }
    >;
};

export type MixDeviceDetailsQueryVariables = Exact<{
    contractId: Scalars['ID'];
    id: Scalars['ID'];
}>;

export type MixDeviceDetailsQuery = { __typename?: 'Query' } & {
    contract:
        | { __typename?: 'Flex' }
        | ({ __typename?: 'Mix' } & Pick<Mix, 'id' | 'createdAt'> & {
                  good: { __typename?: 'MixDevice' } & Pick<
                      MixDevice,
                      'id' | 'state' | 'returnedAt' | 'deliveredAt' | 'contractId'
                  > & {
                          product: { __typename?: 'Product' } & Pick<Product, 'name'> & {
                                  category: { __typename?: 'Category' } & Pick<Category, 'name'> & {
                                          parent?: Maybe<
                                              { __typename?: 'Category' } & Pick<Category, 'name'>
                                          >;
                                      };
                              };
                          variant: { __typename?: 'Variant' } & Pick<
                              Variant,
                              'id' | 'imageUrl' | 'sku'
                          >;
                      };
              });
};

export type MixDevicesFilterQueryVariables = Exact<{
    after?: Maybe<Scalars['String']>;
    first?: Maybe<Scalars['Int']>;
}>;

export type MixDevicesFilterQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                mixSummary?: Maybe<
                    { __typename?: 'MixSummary' } & Pick<MixSummary, 'contractId'> & {
                            pastDevices?: Maybe<
                                { __typename?: 'MixDeviceConnection' } & Pick<
                                    MixDeviceConnection,
                                    'totalCount'
                                > & {
                                        nodes?: Maybe<
                                            Array<
                                                Maybe<
                                                    { __typename: 'MixDevice' } & Pick<
                                                        MixDevice,
                                                        'id' | 'returnedAt'
                                                    > & {
                                                            product: {
                                                                __typename?: 'Product';
                                                            } & Pick<
                                                                Product,
                                                                | 'id'
                                                                | 'imageUrl'
                                                                | 'name'
                                                                | 'sku'
                                                                | 'slug'
                                                            >;
                                                            variant: {
                                                                __typename?: 'Variant';
                                                            } & Pick<
                                                                Variant,
                                                                'id' | 'imageUrl' | 'sku'
                                                            >;
                                                        }
                                                >
                                            >
                                        >;
                                        pageInfo: { __typename?: 'PageInfo' } & Pick<
                                            PageInfo,
                                            | 'startCursor'
                                            | 'endCursor'
                                            | 'hasNextPage'
                                            | 'hasPreviousPage'
                                        >;
                                    }
                            >;
                        }
                >;
            }
    >;
};

export type MixPaymentsCardQueryVariables = Exact<{ [key: string]: never }>;

export type MixPaymentsCardQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                mixSummary?: Maybe<
                    { __typename?: 'MixSummary' } & Pick<MixSummary, 'contractId'> & {
                            payments: {
                                __typename?: 'PaymentsUnionConnection';
                            } & PaymentsFragmentFragment;
                        }
                >;
            }
    >;
};

export type ShippingProgressCardQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type ShippingProgressCardQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | { __typename?: 'Flex' }
        | ({ __typename?: 'SubscriptionDetails' } & Pick<SubscriptionDetails, 'id'> & {
                  shippingProgress?: Maybe<
                      Array<
                          { __typename?: 'ShippingProgress' } & Pick<
                              ShippingProgress,
                              'description' | 'name' | 'state'
                          > & {
                                  subSteps?: Maybe<
                                      Array<
                                          { __typename?: 'SubStep' } & Pick<
                                              SubStep,
                                              'description' | 'name' | 'state'
                                          >
                                      >
                                  >;
                                  actions?: Maybe<
                                      Array<
                                          { __typename?: 'Action' } & Pick<
                                              Action,
                                              'defaultMessage' | 'href' | 'text' | 'type'
                                          >
                                      >
                                  >;
                              }
                      >
                  >;
              })
    >;
};

export type SubscriptionActionsQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type SubscriptionActionsQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id'> & {
                  actions?: Maybe<
                      Array<
                          | ({ __typename?: 'Buyout' } & Pick<
                                Buyout,
                                'type' | 'remainingMonths' | 'unavailableReason'
                            > & { action: 'Buyout' })
                          | { __typename?: 'CancelOrderEarly' }
                          | ({ __typename?: 'PrintReturnLabel' } & Pick<
                                PrintReturnLabel,
                                'remainingMonths' | 'unavailableReason'
                            > & { action: 'PrintReturnLabel' })
                          | ({ __typename?: 'ReportDamage' } & Pick<
                                ReportDamage,
                                'claimFormUrl' | 'unavailableReason'
                            > & { action: 'ReportDamage' })
                          | ({ __typename?: 'SupportRequest' } & Pick<
                                SupportRequest,
                                'orderNumber'
                            > & { action: 'SupportRequest' })
                      >
                  >;
              })
        | ({ __typename?: 'SubscriptionDetails' } & Pick<SubscriptionDetails, 'id'> & {
                  subscriptionActions: Array<
                      | ({ __typename?: 'Buyout' } & Pick<
                            Buyout,
                            'type' | 'remainingMonths' | 'unavailableReason'
                        > & { action: 'Buyout' })
                      | { __typename?: 'CancelSubscription' }
                      | { __typename?: 'ChangePaymentMethod' }
                      | { __typename?: 'PaymentMethodPresenter' }
                      | ({ __typename?: 'PrintReturnLabel' } & Pick<
                            PrintReturnLabel,
                            'remainingMonths' | 'unavailableReason'
                        > & { action: 'PrintReturnLabel' })
                      | ({ __typename?: 'ReportDamage' } & Pick<
                            ReportDamage,
                            'claimFormUrl' | 'unavailableReason'
                        > & { action: 'ReportDamage' })
                      | ({ __typename?: 'SupportRequest' } & Pick<SupportRequest, 'orderNumber'> & {
                                action: 'SupportRequest';
                            })
                      | { __typename?: 'UpgradeRentalPlan' }
                  >;
              })
    >;
};

export type SubscriptionDataPriceFragmentFragment = { __typename?: 'Price' } & Pick<
    Price,
    'inCents' | 'currency'
>;

export type SubscriptionDataProductFragmentFragment = { __typename?: 'Product' } & Pick<
    Product,
    'id' | 'name'
> & {
        category: { __typename?: 'Category' } & Pick<Category, 'id' | 'iconSvgPath' | 'name'> & {
                parent?: Maybe<{ __typename?: 'Category' } & Pick<Category, 'name'>>;
            };
    };

export type SubscriptionDataVariantFragmentFragment = { __typename?: 'Variant' } & Pick<
    Variant,
    'id' | 'colorCodes' | 'colorTitle' | 'imageUrl' | 'sku'
>;

type SubscriptionDataNoteFragmentAttentionNoteFragment = { __typename?: 'AttentionNote' } & Pick<
    AttentionNote,
    'text'
>;

type SubscriptionDataNoteFragmentEndedNoteFragment = { __typename?: 'EndedNote' } & Pick<
    EndedNote,
    'text'
>;

type SubscriptionDataNoteFragmentNextPaymentNoteFragment = {
    __typename?: 'NextPaymentNote';
} & Pick<NextPaymentNote, 'date'> & {
        paymentMethod?: Maybe<
            | { __typename: 'ByInvoice' }
            | { __typename: 'Card' }
            | { __typename: 'Paypal' }
            | { __typename: 'Sepa' }
        >;
    };

type SubscriptionDataNoteFragmentPausedNoteFragment = { __typename?: 'PausedNote' } & Pick<
    PausedNote,
    'text'
>;

type SubscriptionDataNoteFragmentProcessingNoteFragment = { __typename?: 'ProcessingNote' } & Pick<
    ProcessingNote,
    'text'
>;

export type SubscriptionDataNoteFragmentFragment =
    | SubscriptionDataNoteFragmentAttentionNoteFragment
    | SubscriptionDataNoteFragmentEndedNoteFragment
    | SubscriptionDataNoteFragmentNextPaymentNoteFragment
    | SubscriptionDataNoteFragmentPausedNoteFragment
    | SubscriptionDataNoteFragmentProcessingNoteFragment;

export type SubscriptionDataQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type SubscriptionDataQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id' | 'orderNumber' | 'currentFlow'> & {
                  contractState: Flex['state'];
                  contractName: Flex['name'];
              } & {
                  note?: Maybe<
                      | ({
                            __typename?: 'AttentionNote';
                        } & SubscriptionDataNoteFragmentAttentionNoteFragment)
                      | ({
                            __typename?: 'EndedNote';
                        } & SubscriptionDataNoteFragmentEndedNoteFragment)
                      | ({
                            __typename?: 'NextPaymentNote';
                        } & SubscriptionDataNoteFragmentNextPaymentNoteFragment)
                      | ({
                            __typename?: 'PausedNote';
                        } & SubscriptionDataNoteFragmentPausedNoteFragment)
                      | ({
                            __typename?: 'ProcessingNote';
                        } & SubscriptionDataNoteFragmentProcessingNoteFragment)
                  >;
                  billingTerms: { __typename?: 'BillingTerms' } & {
                      price: { __typename?: 'Price' } & SubscriptionDataPriceFragmentFragment;
                      basePrice: { __typename?: 'Price' } & SubscriptionDataPriceFragmentFragment;
                      periodLength: { __typename?: 'Duration' } & Pick<Duration, 'value' | 'unit'>;
                  };
                  goods: Array<
                      { __typename?: 'FlexDevice' } & Pick<
                          FlexDevice,
                          'id' | 'assetId' | 'state'
                      > & {
                              product: {
                                  __typename?: 'Product';
                              } & SubscriptionDataProductFragmentFragment;
                              variant: {
                                  __typename?: 'Variant';
                              } & SubscriptionDataVariantFragmentFragment;
                          }
                  >;
                  actions?: Maybe<
                      Array<
                          | { __typename: 'Buyout' }
                          | ({ __typename?: 'CancelOrderEarly' } & Pick<
                                CancelOrderEarly,
                                'available'
                            >)
                          | { __typename?: 'PrintReturnLabel' }
                          | { __typename: 'ReportDamage' }
                          | { __typename: 'SupportRequest' }
                      >
                  >;
                  flow?: Maybe<
                      | ({ __typename?: 'Completion' } & Pick<
                            Completion,
                            'completedAt' | 'startedAt' | 'state'
                        >)
                      | { __typename?: 'Purchase' }
                      | ({ __typename?: 'Replacement' } & Pick<
                            Replacement,
                            'completedAt' | 'startedAt'
                        > & { replacementState: Replacement['state'] })
                      | ({ __typename?: 'Revocation' } & Pick<
                            Revocation,
                            'completedAt' | 'startedAt' | 'state'
                        >)
                  >;
              })
        | ({ __typename?: 'SubscriptionDetails' } & Pick<
              SubscriptionDetails,
              'id' | 'sfId' | 'state' | 'name'
          > & {
                  order: { __typename?: 'Order' } & Pick<Order, 'id' | 'number'>;
                  note?: Maybe<
                      | ({
                            __typename?: 'AttentionNote';
                        } & SubscriptionDataNoteFragmentAttentionNoteFragment)
                      | ({
                            __typename?: 'EndedNote';
                        } & SubscriptionDataNoteFragmentEndedNoteFragment)
                      | ({
                            __typename?: 'NextPaymentNote';
                        } & SubscriptionDataNoteFragmentNextPaymentNoteFragment)
                      | ({
                            __typename?: 'PausedNote';
                        } & SubscriptionDataNoteFragmentPausedNoteFragment)
                      | ({
                            __typename?: 'ProcessingNote';
                        } & SubscriptionDataNoteFragmentProcessingNoteFragment)
                  >;
                  price: { __typename?: 'Price' } & SubscriptionDataPriceFragmentFragment;
                  product?: Maybe<
                      { __typename?: 'Product' } & SubscriptionDataProductFragmentFragment
                  >;
                  variant?: Maybe<
                      { __typename?: 'Variant' } & SubscriptionDataVariantFragmentFragment
                  >;
                  subscriptionActions: Array<
                      | ({ __typename?: 'Buyout' } & Pick<Buyout, 'remainingMonths'>)
                      | ({ __typename?: 'CancelSubscription' } & Pick<
                            CancelSubscription,
                            'available'
                        >)
                      | { __typename?: 'ChangePaymentMethod' }
                      | { __typename?: 'PaymentMethodPresenter' }
                      | { __typename: 'PrintReturnLabel' }
                      | { __typename: 'ReportDamage' }
                      | { __typename: 'SupportRequest' }
                      | { __typename?: 'UpgradeRentalPlan' }
                  >;
              })
    >;
};

export type PriceFragmentFragment = { __typename?: 'Price' } & Pick<Price, 'inCents' | 'currency'>;

type DetailsCardPaymentMethodFragmentByInvoiceFragment = { __typename?: 'ByInvoice' };

type DetailsCardPaymentMethodFragmentCardFragment = { __typename?: 'Card' } & Pick<
    Card,
    'lastDigits'
>;

type DetailsCardPaymentMethodFragmentPaypalFragment = { __typename?: 'Paypal' } & Pick<
    Paypal,
    'email'
>;

type DetailsCardPaymentMethodFragmentSepaFragment = { __typename?: 'Sepa' } & Pick<
    Sepa,
    'ibanLastDigits'
>;

export type DetailsCardPaymentMethodFragmentFragment =
    | DetailsCardPaymentMethodFragmentByInvoiceFragment
    | DetailsCardPaymentMethodFragmentCardFragment
    | DetailsCardPaymentMethodFragmentPaypalFragment
    | DetailsCardPaymentMethodFragmentSepaFragment;

export type SubscriptionDetailsCardQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type SubscriptionDetailsCardQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id' | 'orderNumber' | 'createdAt'> & {
                  contractState: Flex['state'];
              } & {
                  billingTerms: { __typename?: 'BillingTerms' } & {
                      price: { __typename?: 'Price' } & PriceFragmentFragment;
                      basePrice: { __typename?: 'Price' } & PriceFragmentFragment;
                      periodLength: { __typename?: 'Duration' } & Pick<Duration, 'value' | 'unit'>;
                  };
                  contractPaymentMethod?: Maybe<
                      | ({
                            __typename?: 'ByInvoice';
                        } & DetailsCardPaymentMethodFragmentByInvoiceFragment)
                      | ({ __typename?: 'Card' } & DetailsCardPaymentMethodFragmentCardFragment)
                      | ({ __typename?: 'Paypal' } & DetailsCardPaymentMethodFragmentPaypalFragment)
                      | ({ __typename?: 'Sepa' } & DetailsCardPaymentMethodFragmentSepaFragment)
                  >;
              })
        | ({ __typename?: 'SubscriptionDetails' } & Pick<
              SubscriptionDetails,
              'id' | 'sfId' | 'state' | 'number' | 'contractNumber'
          > & {
                  shippingAddress?: Maybe<
                      { __typename?: 'Address' } & Pick<
                          Address,
                          'id' | 'city' | 'line1' | 'line2' | 'zip'
                      >
                  >;
                  asset?: Maybe<
                      { __typename?: 'Asset' } & Pick<Asset, 'serialNumber' | 'productNumber'>
                  >;
                  order: { __typename?: 'Order' } & Pick<Order, 'id' | 'number' | 'completedAt'>;
                  minimumDuration?: Maybe<
                      { __typename?: 'Duration' } & Pick<Duration, 'value' | 'unit'>
                  >;
                  paymentMethod:
                      | ({
                            __typename?: 'ByInvoice';
                        } & DetailsCardPaymentMethodFragmentByInvoiceFragment)
                      | ({ __typename?: 'Card' } & DetailsCardPaymentMethodFragmentCardFragment)
                      | ({ __typename?: 'Paypal' } & DetailsCardPaymentMethodFragmentPaypalFragment)
                      | ({ __typename?: 'Sepa' } & DetailsCardPaymentMethodFragmentSepaFragment);
                  subscriptionActions: Array<
                      | { __typename?: 'Buyout' }
                      | { __typename?: 'CancelSubscription' }
                      | { __typename?: 'ChangePaymentMethod' }
                      | ({ __typename?: 'PaymentMethodPresenter' } & Pick<
                            PaymentMethodPresenter,
                            'type' | 'email' | 'last4Digits'
                        > & { action: 'PaymentMethodPresenter' })
                      | { __typename?: 'PrintReturnLabel' }
                      | { __typename?: 'ReportDamage' }
                      | { __typename?: 'SupportRequest' }
                      | ({ __typename?: 'UpgradeRentalPlan' } & {
                            availablePlans?: Maybe<
                                Array<
                                    { __typename?: 'RentalPlan' } & Pick<RentalPlan, 'id'> & {
                                            price: { __typename?: 'Price' } & PriceFragmentFragment;
                                        }
                                >
                            >;
                        })
                  >;
              })
    >;
};

export type SubscriptionPaymentsCardQueryVariables = Exact<{
    id: Scalars['ID'];
    firstPayments: Scalars['Int'];
    cursor?: Maybe<Scalars['String']>;
}>;

export type SubscriptionPaymentsCardQuery = { __typename?: 'Query' } & {
    payments?: Maybe<
        {
            __typename?: 'PaymentsUnionConnection';
        } & PaymentsFragmentWithoutSubscriptionDetailsFragment
    >;
};

export type SubscriptionsFilterQueryVariables = Exact<{
    filter: SubscriptionListFilterInput;
    first?: Maybe<Scalars['Int']>;
    cursor?: Maybe<Scalars['String']>;
    searchTerm?: Maybe<Scalars['String']>;
}>;

export type SubscriptionsFilterQuery = { __typename?: 'Query' } & {
    subscriptionCollection?: Maybe<
        { __typename?: 'SubscriptionListEntryConnection' } & Pick<
            SubscriptionListEntryConnection,
            'totalCount'
        > & {
                nodes?: Maybe<
                    Array<
                        Maybe<
                            | ({ __typename?: 'SubscriptionCard' } & Pick<
                                  SubscriptionCard,
                                  'id' | 'name' | 'state'
                              > & {
                                      marketingSubscriptionData: Array<
                                          | { __typename?: 'BasicMarketingCardModel' }
                                          | { __typename?: 'PollCardModel' }
                                          | ({ __typename?: 'SubscriptionBadgeModel' } & Pick<
                                                SubscriptionBadgeModel,
                                                'uuid' | 'svgPath' | 'bodyTemplate'
                                            > & {
                                                    actions?: Maybe<
                                                        Array<
                                                            | {
                                                                  __typename?: 'CopyToClipboardActionModel';
                                                              }
                                                            | ({
                                                                  __typename?: 'LaunchFlowActionModel';
                                                              } & Pick<
                                                                  LaunchFlowActionModel,
                                                                  'flow'
                                                              >)
                                                            | { __typename?: 'LinkActionModel' }
                                                        >
                                                    >;
                                                })
                                      >;
                                      note?: Maybe<
                                          | ({ __typename?: 'AttentionNote' } & Pick<
                                                AttentionNote,
                                                'text'
                                            >)
                                          | ({ __typename?: 'EndedNote' } & Pick<EndedNote, 'text'>)
                                          | ({ __typename?: 'NextPaymentNote' } & Pick<
                                                NextPaymentNote,
                                                'date'
                                            > & {
                                                    paymentMethod?: Maybe<
                                                        | { __typename: 'ByInvoice' }
                                                        | { __typename: 'Card' }
                                                        | { __typename: 'Paypal' }
                                                        | { __typename: 'Sepa' }
                                                    >;
                                                })
                                          | ({ __typename?: 'PausedNote' } & Pick<
                                                PausedNote,
                                                'text'
                                            >)
                                          | ({ __typename?: 'ProcessingNote' } & Pick<
                                                ProcessingNote,
                                                'text'
                                            >)
                                      >;
                                      variant: { __typename?: 'Variant' } & Pick<
                                          Variant,
                                          'id' | 'colorCodes' | 'colorTitle' | 'imageUrl'
                                      >;
                                  })
                            | ({ __typename?: 'SubscriptionStack' } & Pick<
                                  SubscriptionStack,
                                  'quantity'
                              > & {
                                      filter: { __typename?: 'SubscriptionListFilter' } & Pick<
                                          SubscriptionListFilter,
                                          'state' | 'orderId' | 'productId'
                                      >;
                                      product: { __typename?: 'Product' } & Pick<
                                          Product,
                                          'id' | 'name' | 'imageUrl'
                                      >;
                                  })
                        >
                    >
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                    PageInfo,
                    'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
                >;
            }
    >;
};

export type SubscriptionsFilterProductQueryVariables = Exact<{
    productId: Scalars['ID'];
}>;

export type SubscriptionsFilterProductQuery = { __typename?: 'Query' } & {
    product?: Maybe<{ __typename?: 'Product' } & Pick<Product, 'id' | 'name' | 'coreAttribute'>>;
};

export type SubscriptionSummaryQueryVariables = Exact<{ [key: string]: never }>;

export type SubscriptionSummaryQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                subscriptionSummary: Array<
                    | ({ __typename?: 'FilterButton' } & Pick<FilterButton, 'title'> & {
                              filterConfig: { __typename?: 'SubscriptionListFilter' } & Pick<
                                  SubscriptionListFilter,
                                  'state' | 'orderId' | 'productId'
                              >;
                          })
                    | ({ __typename?: 'Section' } & Pick<Section, 'title' | 'quantity'> & {
                              filter?: Maybe<
                                  { __typename?: 'SubscriptionListFilter' } & Pick<
                                      SubscriptionListFilter,
                                      'state'
                                  >
                              >;
                              items: Array<
                                  | ({ __typename?: 'SubscriptionCard' } & Pick<
                                        SubscriptionCard,
                                        'id' | 'name' | 'state'
                                    > & {
                                            marketingSubscriptionData: Array<
                                                | { __typename?: 'BasicMarketingCardModel' }
                                                | { __typename?: 'PollCardModel' }
                                                | ({ __typename?: 'SubscriptionBadgeModel' } & Pick<
                                                      SubscriptionBadgeModel,
                                                      'uuid' | 'svgPath' | 'bodyTemplate'
                                                  > & {
                                                          actions?: Maybe<
                                                              Array<
                                                                  | {
                                                                        __typename?: 'CopyToClipboardActionModel';
                                                                    }
                                                                  | ({
                                                                        __typename?: 'LaunchFlowActionModel';
                                                                    } & Pick<
                                                                        LaunchFlowActionModel,
                                                                        'flow'
                                                                    >)
                                                                  | {
                                                                        __typename?: 'LinkActionModel';
                                                                    }
                                                              >
                                                          >;
                                                      })
                                            >;
                                            note?: Maybe<
                                                | ({ __typename?: 'AttentionNote' } & Pick<
                                                      AttentionNote,
                                                      'text'
                                                  >)
                                                | ({ __typename?: 'EndedNote' } & Pick<
                                                      EndedNote,
                                                      'text'
                                                  >)
                                                | ({ __typename?: 'NextPaymentNote' } & Pick<
                                                      NextPaymentNote,
                                                      'date'
                                                  > & {
                                                          paymentMethod?: Maybe<
                                                              | { __typename: 'ByInvoice' }
                                                              | { __typename: 'Card' }
                                                              | { __typename: 'Paypal' }
                                                              | { __typename: 'Sepa' }
                                                          >;
                                                      })
                                                | ({ __typename?: 'PausedNote' } & Pick<
                                                      PausedNote,
                                                      'text'
                                                  >)
                                                | ({ __typename?: 'ProcessingNote' } & Pick<
                                                      ProcessingNote,
                                                      'text'
                                                  >)
                                            >;
                                            variant: { __typename?: 'Variant' } & Pick<
                                                Variant,
                                                'id' | 'colorCodes' | 'colorTitle' | 'imageUrl'
                                            >;
                                        })
                                  | ({ __typename?: 'SubscriptionStack' } & Pick<
                                        SubscriptionStack,
                                        'quantity'
                                    > & {
                                            filter: {
                                                __typename?: 'SubscriptionListFilter';
                                            } & Pick<
                                                SubscriptionListFilter,
                                                'state' | 'orderId' | 'productId'
                                            >;
                                            product: { __typename?: 'Product' } & Pick<
                                                Product,
                                                'id' | 'name' | 'imageUrl'
                                            >;
                                        })
                              >;
                          })
                >;
                mixSummary?: Maybe<
                    { __typename?: 'MixSummary' } & Pick<
                        MixSummary,
                        'contractId' | 'orderNumber' | 'state'
                    > & {
                            contract:
                                | ({ __typename?: 'Flex' } & {
                                      endingTerm: { __typename?: 'EndingTerm' } & Pick<
                                          EndingTerm,
                                          'availableAfter'
                                      > & {
                                              timeUntilAvailable?: Maybe<
                                                  { __typename?: 'Duration' } & Pick<
                                                      Duration,
                                                      'unit' | 'value'
                                                  >
                                              >;
                                          };
                                  })
                                | ({ __typename?: 'Mix' } & {
                                      endingTerm: { __typename?: 'EndingTerm' } & Pick<
                                          EndingTerm,
                                          'availableAfter'
                                      > & {
                                              timeUntilAvailable?: Maybe<
                                                  { __typename?: 'Duration' } & Pick<
                                                      Duration,
                                                      'unit' | 'value'
                                                  >
                                              >;
                                          };
                                  });
                            devices: Array<
                                { __typename?: 'MixDevice' } & Pick<MixDevice, 'id'> & {
                                        product: { __typename?: 'Product' } & Pick<
                                            Product,
                                            'id' | 'name'
                                        >;
                                        variant: { __typename?: 'Variant' } & Pick<
                                            Variant,
                                            'id' | 'imageUrl'
                                        >;
                                    }
                            >;
                            pastDevices?: Maybe<
                                { __typename?: 'MixDeviceConnection' } & Pick<
                                    MixDeviceConnection,
                                    'totalCount'
                                >
                            >;
                            swap?: Maybe<
                                { __typename?: 'Swap' } & Pick<
                                    Swap,
                                    'id' | 'orderNumber' | 'trackingUrl' | 'shippingProgress'
                                > & {
                                        newDevice: { __typename?: 'MixDevice' } & Pick<
                                            MixDevice,
                                            'id' | 'state'
                                        > & {
                                                product: { __typename?: 'Product' } & Pick<
                                                    Product,
                                                    'id' | 'name'
                                                >;
                                                variant: { __typename?: 'Variant' } & Pick<
                                                    Variant,
                                                    'id' | 'imageUrl'
                                                >;
                                            };
                                        oldDevice: { __typename?: 'MixDevice' } & Pick<
                                            MixDevice,
                                            'id' | 'state'
                                        > & {
                                                product: { __typename?: 'Product' } & Pick<
                                                    Product,
                                                    'id' | 'name'
                                                >;
                                                variant: { __typename?: 'Variant' } & Pick<
                                                    Variant,
                                                    'id' | 'imageUrl'
                                                >;
                                            };
                                    }
                            >;
                        }
                >;
            }
    >;
};

export type SwappingTermsQueryVariables = Exact<{
    mixContractId: Scalars['ID'];
}>;

export type SwappingTermsQuery = { __typename?: 'Query' } & {
    contract:
        | { __typename?: 'Flex' }
        | ({ __typename?: 'Mix' } & {
              swappingTerms: { __typename?: 'SwappingTerms' } & Pick<
                  SwappingTerms,
                  'available' | 'availableAfter' | 'unavailabilityReason'
              > & {
                      timeUntilAvailable?: Maybe<
                          { __typename?: 'Duration' } & Pick<Duration, 'unit' | 'value'>
                      >;
                  };
          });
};

export type UpdateSubscriptionNameMutationVariables = Exact<{
    input: UpdateSubscriptionInput;
}>;

export type UpdateSubscriptionNameMutation = { __typename?: 'Mutation' } & {
    updateSubscription?: Maybe<
        { __typename?: 'UpdateSubscriptionPayload' } & {
            subscriptionDetails: { __typename?: 'SubscriptionDetails' } & Pick<
                SubscriptionDetails,
                'id' | 'name'
            >;
        }
    >;
};

export type CastSatisfactionSurveyVoteMutationVariables = Exact<{
    mood: Scalars['String'];
    ticket: Scalars['String'];
    comment?: Maybe<Scalars['String']>;
}>;

export type CastSatisfactionSurveyVoteMutation = { __typename?: 'Mutation' } & {
    castVote: { __typename?: 'Vote' } & Pick<
        Vote,
        'voteSlug' | 'comment' | 'userId' | 'entityId' | 'entityType'
    >;
};

export type GetSatisfactionSurveyVotingTicketMutationVariables = Exact<{
    slug: Scalars['String'];
    entityId?: Maybe<Scalars['String']>;
}>;

export type GetSatisfactionSurveyVotingTicketMutation = { __typename?: 'Mutation' } & {
    getVotingTicket: { __typename?: 'Ticket' } & Pick<
        Ticket,
        'ticket' | 'entityId' | 'entityType' | 'pollMode'
    > & {
            payload:
                | ({ __typename?: 'MoodOptions' } & {
                      options: Array<{ __typename?: 'MoodOption' } & Pick<MoodOption, 'mood'>>;
                  })
                | { __typename?: 'SingleChoiceOptions' }
                | { __typename?: 'ThumbsOptions' };
        };
};

export type EnergyLabelQueryQueryVariables = Exact<{
    productId: Scalars['ID'];
}>;

export type EnergyLabelQueryQuery = { __typename?: 'Query' } & {
    product?: Maybe<
        { __typename?: 'Product' } & {
            energyLabel?: Maybe<
                { __typename?: 'EnergyLabel' } & Pick<
                    EnergyLabel,
                    'id' | 'energyRating' | 'imageUrl' | 'energySpecs'
                >
            >;
        }
    >;
};

export type CheckContractsQueryVariables = Exact<{
    contractsFilter?: Maybe<ContractFilterInput>;
    product: ProductVariantInput;
}>;

export type CheckContractsQuery = { __typename?: 'Query' } & {
    contracts?: Maybe<
        { __typename?: 'ContractConnection' } & {
            nodes?: Maybe<
                Array<
                    Maybe<
                        | { __typename: 'Flex' }
                        | ({ __typename: 'Mix' } & Pick<Mix, 'orderNumber' | 'state'> & {
                                  swappingTerms: { __typename?: 'SwappingTerms' } & Pick<
                                      SwappingTerms,
                                      'available' | 'availableAfter' | 'unavailabilityReason'
                                  > & {
                                          timeUntilAvailable?: Maybe<
                                              { __typename?: 'Duration' } & Pick<
                                                  Duration,
                                                  'unit' | 'value'
                                              >
                                          >;
                                      };
                                  goods: Array<
                                      { __typename: 'MixDevice' } & Pick<
                                          MixDevice,
                                          | 'id'
                                          | 'contractId'
                                          | 'categoryId'
                                          | 'subCategoryId'
                                          | 'state'
                                          | 'swappable'
                                      > & {
                                              variant: { __typename?: 'Variant' } & Pick<
                                                  Variant,
                                                  'id' | 'imageUrl' | 'coreAttribute' | 'sku'
                                              >;
                                              product: { __typename?: 'Product' } & Pick<
                                                  Product,
                                                  | 'id'
                                                  | 'imageUrl'
                                                  | 'name'
                                                  | 'sku'
                                                  | 'slug'
                                                  | 'coreAttribute'
                                              >;
                                          }
                                  >;
                              })
                    >
                >
            >;
        }
    >;
};

export type CartSummaryFragment = { __typename?: 'MixCartOrder' } & Pick<
    MixCartOrder,
    'orderNumber' | 'orderMode' | 'shippingAddressId' | 'billingAddressId' | 'currency'
> & {
        paymentMethod?: Maybe<
            { __typename?: 'PaymentMethodStub' } & Pick<
                PaymentMethodStub,
                'paymentMethodId' | 'billingAccountId'
            >
        >;
        itemTotal: { __typename?: 'Price' } & Pick<Price, 'inCents' | 'currency'>;
        total?: Maybe<{ __typename?: 'Price' } & Pick<Price, 'inCents' | 'currency'>>;
        lineItems: Array<
            Maybe<
                { __typename?: 'MixLineItem' } & Pick<MixLineItem, 'id' | 'quantity'> & {
                        meta:
                            | ({ __typename?: 'FlexCartLineItemMeta' } & Pick<
                                  FlexCartLineItemMeta,
                                  'committedMonths'
                              > & {
                                      total: { __typename?: 'Price' } & Pick<
                                          Price,
                                          'inCents' | 'currency'
                                      >;
                                      price: { __typename?: 'Price' } & Pick<
                                          Price,
                                          'inCents' | 'currency'
                                      >;
                                      product?: Maybe<
                                          { __typename?: 'Product' } & Pick<
                                              Product,
                                              'id' | 'sku' | 'name' | 'slug' | 'coreAttribute'
                                          >
                                      >;
                                      variant: { __typename?: 'LineItemVariant' } & Pick<
                                          LineItemVariant,
                                          | 'id'
                                          | 'sku'
                                          | 'colorTitle'
                                          | 'colorCodes'
                                          | 'imageUrl'
                                          | 'mixable'
                                      >;
                                  })
                            | ({ __typename?: 'LineItemCatalogMeta' } & {
                                  category?: Maybe<
                                      { __typename?: 'LineItemCategory' } & Pick<
                                          LineItemCategory,
                                          'categoryId' | 'subCategoryId'
                                      >
                                  >;
                                  product?: Maybe<
                                      { __typename?: 'Product' } & Pick<
                                          Product,
                                          'id' | 'sku' | 'name' | 'slug' | 'coreAttribute'
                                      >
                                  >;
                                  variant: { __typename?: 'LineItemVariant' } & Pick<
                                      LineItemVariant,
                                      | 'id'
                                      | 'sku'
                                      | 'colorTitle'
                                      | 'colorCodes'
                                      | 'imageUrl'
                                      | 'mixable'
                                  >;
                              })
                            | ({ __typename?: 'ReplacedLineItemMeta' } & {
                                  product?: Maybe<
                                      { __typename?: 'Product' } & Pick<
                                          Product,
                                          'id' | 'sku' | 'name' | 'slug' | 'coreAttribute'
                                      >
                                  >;
                                  variant: { __typename?: 'LineItemVariant' } & Pick<
                                      LineItemVariant,
                                      | 'id'
                                      | 'sku'
                                      | 'colorTitle'
                                      | 'colorCodes'
                                      | 'imageUrl'
                                      | 'mixable'
                                  >;
                              });
                    }
            >
        >;
    };

export type AddressAddMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    input?: Maybe<CartOrderUpdateInput>;
}>;

export type AddressAddMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type AddressChangeMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    input?: Maybe<CartOrderUpdateInput>;
}>;

export type AddressChangeMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type OrderAddLineItemMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    item?: Maybe<MixLineItemInput>;
}>;

export type OrderAddLineItemMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type EditLineItemMutationVariables = Exact<{
    orderNumber: Scalars['ID'];
    item: LineItemUpdateInput;
}>;

export type EditLineItemMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type RemoveLineItemMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    itemId?: Maybe<Scalars['Int']>;
}>;

export type RemoveLineItemMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type GetOrderQueryVariables = Exact<{
    orderNumber: Scalars['ID'];
}>;

export type GetOrderQuery = { __typename?: 'Query' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type OrderCreateMutationVariables = Exact<{
    order?: Maybe<CartOrderCreateInput>;
}>;

export type OrderCreateMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type OrderSubmitMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    input?: Maybe<CartOrderSubmitInput>;
}>;

export type OrderSubmitMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type OrderUpdateMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    step?: Maybe<Scalars['String']>;
}>;

export type OrderUpdateMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type OrderValidateQueryVariables = Exact<{
    products: Array<ProductVariantInput> | ProductVariantInput;
}>;

export type OrderValidateQuery = { __typename?: 'Query' } & {
    validateMixProductSelection: { __typename?: 'ContractValidationResult' } & Pick<
        ContractValidationResult,
        'valid'
    >;
};

export type AddPaymentMethodMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    input?: Maybe<CartOrderUpdateInput>;
}>;

export type AddPaymentMethodMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type ChangePaymentMethodMutationVariables = Exact<{
    orderNumber?: Maybe<Scalars['ID']>;
    input?: Maybe<CartOrderUpdateInput>;
}>;

export type ChangePaymentMethodMutation = { __typename?: 'Mutation' } & {
    order?: Maybe<{ __typename?: 'MixCartOrder' } & CartSummaryFragment>;
};

export type CardOnboardingStatusQueryVariables = Exact<{ [key: string]: never }>;

export type CardOnboardingStatusQuery = { __typename?: 'Query' } & {
    onboardingStatus: { __typename: 'OnboardingStatusResult' } & Pick<
        OnboardingStatusResult,
        'cardStatus'
    >;
};

export type CardWaitingListQueryVariables = Exact<{ [key: string]: never }>;

export type CardWaitingListQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename: 'User' } & Pick<User, 'id'> & {
                waitingListTickets?: Maybe<
                    Array<
                        { __typename: 'WaitingListTicket' } & Pick<
                            WaitingListTicket,
                            'id' | 'state'
                        > & {
                                waitingList: { __typename: 'WaitingList' } & Pick<
                                    WaitingList,
                                    'id' | 'slug'
                                >;
                            }
                    >
                >;
            }
    >;
};

export type MixWaitingListQueryVariables = Exact<{ [key: string]: never }>;

export type MixWaitingListQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                waitingListTickets?: Maybe<
                    Array<
                        { __typename?: 'WaitingListTicket' } & Pick<
                            WaitingListTicket,
                            'id' | 'state'
                        > & {
                                waitingList: { __typename?: 'WaitingList' } & Pick<
                                    WaitingList,
                                    'id' | 'slug'
                                >;
                            }
                    >
                >;
            }
    >;
};

export type GetCountdownTimerByIdQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type GetCountdownTimerByIdQuery = { __typename?: 'Query' } & {
    findCountdownTimerById?: Maybe<
        { __typename?: 'CountdownTimer' } & Pick<
            CountdownTimer,
            'id' | 'name' | 'storeCodes' | 'startAt' | 'endAt' | 'isActive'
        >
    >;
};

export type CastVoteSatisfactionMutationMutationVariables = Exact<{
    voteSlug: Scalars['String'];
    ticket: Scalars['String'];
    comment?: Maybe<Scalars['String']>;
}>;

export type CastVoteSatisfactionMutationMutation = { __typename?: 'Mutation' } & {
    castVote: { __typename?: 'Vote' } & Pick<
        Vote,
        'voteSlug' | 'comment' | 'userId' | 'entityId' | 'entityType'
    >;
};

export type GetRecommendationEngineProductsQueryVariables = Exact<{
    sku: Scalars['String'];
}>;

export type GetRecommendationEngineProductsQuery = { __typename?: 'Query' } & {
    recommendations: { __typename?: 'RecommendationResponse' } & {
        recommendations: Array<
            { __typename?: 'Recommendation' } & Pick<Recommendation, 'productSku'>
        >;
    };
};

export type GetRecommendedProductDetailsQueryVariables = Exact<{
    skus: Array<Scalars['String']> | Scalars['String'];
    showProductEnergyLabelEnabled: Scalars['Boolean'];
}>;

export type GetRecommendedProductDetailsQuery = { __typename?: 'Query' } & {
    products?: Maybe<
        Array<
            { __typename?: 'Product' } & Pick<
                Product,
                | 'id'
                | 'sku'
                | 'slug'
                | 'name'
                | 'promotionalLabel'
                | 'isNew'
                | 'coreAttribute'
                | 'originalImageUrl'
                | 'brandName'
            > & {
                    category: { __typename?: 'Category' } & Pick<Category, 'title'>;
                    variants: Array<
                        { __typename?: 'Variant' } & Pick<Variant, 'id' | 'mixable'> & {
                                flags?: Maybe<
                                    Array<
                                        { __typename?: 'VariantFlag' } & Pick<
                                            VariantFlag,
                                            'name' | 'isActive'
                                        >
                                    >
                                >;
                            }
                    >;
                    rentalPlans: Array<
                        { __typename?: 'RentalPlan' } & Pick<RentalPlan, 'id'> & {
                                discount?: Maybe<
                                    { __typename?: 'RentalPlanDiscount' } & Pick<
                                        RentalPlanDiscount,
                                        'percentage'
                                    >
                                >;
                                price: { __typename?: 'Price' } & Pick<Price, 'inCents'>;
                                length: { __typename?: 'Duration' } & Pick<
                                    Duration,
                                    'unit' | 'value'
                                >;
                                oldPrice?: Maybe<{ __typename?: 'Price' } & Pick<Price, 'inCents'>>;
                            }
                    >;
                    energyLabel?: Maybe<
                        { __typename?: 'EnergyLabel' } & Pick<EnergyLabel, 'energyRating'>
                    >;
                }
        >
    >;
};

export type ProductBundleQueryQueryVariables = Exact<{
    productId: Scalars['ID'];
    includeDiscount?: Maybe<Scalars['Boolean']>;
}>;

export type ProductBundleQueryQuery = { __typename?: 'Query' } & {
    product?: Maybe<
        { __typename?: 'Product' } & Pick<Product, 'available' | 'name' | 'sku' | 'slug'> & {
                rentalPlans: Array<
                    { __typename?: 'RentalPlan' } & Pick<RentalPlan, 'id'> & {
                            length: { __typename?: 'Duration' } & Pick<Duration, 'unit' | 'value'>;
                            price: { __typename?: 'Price' } & Pick<Price, 'inCents'>;
                            oldPrice?: Maybe<{ __typename?: 'Price' } & Pick<Price, 'inCents'>>;
                        }
                >;
                variants: Array<{ __typename?: 'Variant' } & Pick<Variant, 'id' | 'imageUrl'>>;
                bundle?: Maybe<
                    { __typename?: 'Bundle' } & MakeOptional<
                        Pick<Bundle, 'id' | 'title' | 'description' | 'active' | 'discountCode'>,
                        'discountCode'
                    > & {
                            secondaryProducts?: Maybe<
                                Array<
                                    Maybe<
                                        { __typename?: 'Product' } & Pick<
                                            Product,
                                            'available' | 'name' | 'sku' | 'slug'
                                        > & {
                                                rentalPlans: Array<
                                                    { __typename?: 'RentalPlan' } & Pick<
                                                        RentalPlan,
                                                        'id'
                                                    > & {
                                                            length: {
                                                                __typename?: 'Duration';
                                                            } & Pick<Duration, 'unit' | 'value'>;
                                                            price: { __typename?: 'Price' } & Pick<
                                                                Price,
                                                                'inCents'
                                                            >;
                                                            oldPrice?: Maybe<
                                                                { __typename?: 'Price' } & Pick<
                                                                    Price,
                                                                    'inCents'
                                                                >
                                                            >;
                                                        }
                                                >;
                                                variants: Array<
                                                    { __typename?: 'Variant' } & Pick<
                                                        Variant,
                                                        'id' | 'imageUrl'
                                                    >
                                                >;
                                            }
                                    >
                                >
                            >;
                        }
                >;
            }
    >;
};

export type CastFeedbackVoteMutationMutationVariables = Exact<{
    vote: Scalars['String'];
    ticket: Scalars['String'];
    comment?: Maybe<Scalars['String']>;
}>;

export type CastFeedbackVoteMutationMutation = { __typename?: 'Mutation' } & {
    castVote: { __typename?: 'Vote' } & Pick<Vote, 'voteSlug'>;
};

export type CompanyVibanQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyVibanQuery = { __typename?: 'Query' } & {
    company?: Maybe<{ __typename?: 'Company' } & Pick<Company, 'id' | 'name' | 'viban'>>;
};

export type GroupPaymentQueryVariables = Exact<{
    contractsPerPage: Scalars['Int'];
    cursor?: Maybe<Scalars['String']>;
    groupPaymentId: Scalars['ID'];
}>;

export type GroupPaymentQuery = { __typename?: 'Query' } & {
    dashboardGroupPayment?: Maybe<
        { __typename?: 'GroupPayment' } & Pick<
            GroupPayment,
            'id' | 'byInvoice' | 'invoiceNumber' | 'invoiceUrl' | 'state'
        > & {
                contracts?: Maybe<
                    { __typename?: 'ContractConnection' } & Pick<
                        ContractConnection,
                        'totalCount'
                    > & {
                            pageInfo: { __typename?: 'PageInfo' } & Pick<
                                PageInfo,
                                'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
                            >;
                            nodes?: Maybe<
                                Array<
                                    Maybe<
                                        | ({ __typename?: 'Flex' } & Pick<
                                              Flex,
                                              'id' | 'orderNumber' | 'name'
                                          > & {
                                                  billingTerms: { __typename?: 'BillingTerms' } & {
                                                      price: { __typename?: 'Price' } & Pick<
                                                          Price,
                                                          'currency' | 'inCents'
                                                      >;
                                                  };
                                                  goods: Array<
                                                      { __typename?: 'FlexDevice' } & Pick<
                                                          FlexDevice,
                                                          'id' | 'assetId' | 'contractId' | 'name'
                                                      > & {
                                                              product: {
                                                                  __typename?: 'Product';
                                                              } & {
                                                                  category: {
                                                                      __typename?: 'Category';
                                                                  } & Pick<Category, 'iconSvgPath'>;
                                                              };
                                                          }
                                                  >;
                                              })
                                        | { __typename?: 'Mix' }
                                    >
                                >
                            >;
                        }
                >;
                dueDate:
                    | ({ __typename: 'Date' } & Pick<Date, 'iso8601'>)
                    | ({ __typename: 'TimeEstimate' } & {
                          atLeast: { __typename?: 'Duration' } & Pick<Duration, 'unit' | 'value'>;
                          atMost?: Maybe<
                              { __typename?: 'Duration' } & Pick<Duration, 'unit' | 'value'>
                          >;
                      });
                price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
            }
    >;
};

export type PaymentsQueryVariables = Exact<{
    firstPayments: Scalars['Int'];
    cursor?: Maybe<Scalars['String']>;
}>;

export type PaymentsQuery = { __typename?: 'Query' } & {
    payments?: Maybe<{ __typename?: 'PaymentsUnionConnection' } & PaymentsFragmentFragment>;
};

export type PaymentsDetailsQueryVariables = Exact<{
    userId: Scalars['ID'];
}>;

export type PaymentsDetailsQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                activeSubscriptionValue: { __typename?: 'Price' } & Pick<
                    Price,
                    'currency' | 'inCents'
                >;
                monthlyTotal: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
            }
    >;
};

export type PaymentsFragmentFragment = { __typename?: 'PaymentsUnionConnection' } & Pick<
    PaymentsUnionConnection,
    'totalCount'
> & {
        pageInfo: { __typename?: 'PageInfo' } & Pick<
            PageInfo,
            'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
        >;
        nodes?: Maybe<
            Array<
                Maybe<
                    | ({ __typename?: 'GroupPayment' } & Pick<GroupPayment, 'id' | 'state'> & {
                              contracts?: Maybe<
                                  { __typename?: 'ContractConnection' } & Pick<
                                      ContractConnection,
                                      'totalCount'
                                  >
                              >;
                              dueDate:
                                  | ({ __typename?: 'Date' } & Pick<Date, 'iso8601'>)
                                  | ({ __typename?: 'TimeEstimate' } & {
                                        atLeast: { __typename?: 'Duration' } & Pick<
                                            Duration,
                                            'unit' | 'value'
                                        >;
                                        atMost?: Maybe<
                                            { __typename?: 'Duration' } & Pick<
                                                Duration,
                                                'unit' | 'value'
                                            >
                                        >;
                                    });
                              price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                          })
                    | ({ __typename?: 'OrderPayment' } & Pick<
                          OrderPayment,
                          'id' | 'state' | 'byInvoice' | 'invoiceNumber' | 'invoiceUrl'
                      > & {
                              price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                              basePrice: { __typename?: 'Price' } & Pick<
                                  Price,
                                  'currency' | 'inCents'
                              >;
                              dueDate:
                                  | ({ __typename?: 'Date' } & Pick<Date, 'iso8601'>)
                                  | ({ __typename?: 'TimeEstimate' } & {
                                        atLeast: { __typename?: 'Duration' } & Pick<
                                            Duration,
                                            'unit' | 'value'
                                        >;
                                        atMost?: Maybe<
                                            { __typename?: 'Duration' } & Pick<
                                                Duration,
                                                'unit' | 'value'
                                            >
                                        >;
                                    });
                              order:
                                  | ({ __typename?: 'MixCartOrder' } & Pick<
                                        MixCartOrder,
                                        'orderMode' | 'orderNumber' | 'storeCode'
                                    > & {
                                            itemTotal: { __typename?: 'Price' } & Pick<
                                                Price,
                                                'currency' | 'inCents'
                                            >;
                                            itemTotalDiscount?: Maybe<
                                                { __typename?: 'Price' } & Pick<
                                                    Price,
                                                    'currency' | 'inCents'
                                                >
                                            >;
                                            mixLineItems: Array<
                                                Maybe<
                                                    { __typename?: 'MixLineItem' } & Pick<
                                                        MixLineItem,
                                                        'quantity'
                                                    > & {
                                                            meta:
                                                                | ({
                                                                      __typename?: 'FlexCartLineItemMeta';
                                                                  } & {
                                                                      price: {
                                                                          __typename?: 'Price';
                                                                      } & Pick<
                                                                          Price,
                                                                          'currency' | 'inCents'
                                                                      >;
                                                                      product?: Maybe<
                                                                          {
                                                                              __typename?: 'Product';
                                                                          } & Pick<Product, 'name'>
                                                                      >;
                                                                  })
                                                                | ({
                                                                      __typename?: 'LineItemCatalogMeta';
                                                                  } & {
                                                                      product?: Maybe<
                                                                          {
                                                                              __typename?: 'Product';
                                                                          } & Pick<Product, 'name'>
                                                                      >;
                                                                  })
                                                                | ({
                                                                      __typename?: 'ReplacedLineItemMeta';
                                                                  } & {
                                                                      product?: Maybe<
                                                                          {
                                                                              __typename?: 'Product';
                                                                          } & Pick<Product, 'name'>
                                                                      >;
                                                                  });
                                                        }
                                                >
                                            >;
                                            shippingCost?: Maybe<
                                                { __typename?: 'Price' } & Pick<
                                                    Price,
                                                    'currency' | 'inCents'
                                                >
                                            >;
                                            total?: Maybe<
                                                { __typename?: 'Price' } & Pick<
                                                    Price,
                                                    'currency' | 'inCents'
                                                >
                                            >;
                                        })
                                  | ({ __typename?: 'Order' } & Pick<
                                        Order,
                                        'number' | 'completedAt'
                                    > & {
                                            discountAmount: { __typename?: 'Price' } & Pick<
                                                Price,
                                                'currency' | 'inCents'
                                            >;
                                            shippingPrice: { __typename?: 'Price' } & Pick<
                                                Price,
                                                'currency' | 'inCents'
                                            >;
                                            price: { __typename?: 'Price' } & Pick<
                                                Price,
                                                'currency' | 'inCents'
                                            >;
                                            lineItems: Array<
                                                { __typename?: 'LineItem' } & Pick<
                                                    LineItem,
                                                    'name' | 'quantity'
                                                > & {
                                                        price: { __typename?: 'Price' } & Pick<
                                                            Price,
                                                            'inCents' | 'currency'
                                                        >;
                                                    }
                                            >;
                                        });
                              marketingOrderPaymentData: Array<
                                  { __typename?: 'HintModel' } & Pick<
                                      HintModel,
                                      'uuid' | 'bodyTemplate'
                                  >
                              >;
                          })
                    | ({ __typename?: 'PurchasePayment' } & Pick<
                          PurchasePayment,
                          'state' | 'datePaid' | 'invoiceUrl'
                      > & {
                              dueDate:
                                  | ({ __typename?: 'Date' } & Pick<Date, 'iso8601'>)
                                  | ({ __typename?: 'TimeEstimate' } & {
                                        atLeast: { __typename?: 'Duration' } & Pick<
                                            Duration,
                                            'unit' | 'value'
                                        >;
                                        atMost?: Maybe<
                                            { __typename?: 'Duration' } & Pick<
                                                Duration,
                                                'unit' | 'value'
                                            >
                                        >;
                                    });
                              price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                              basePrice: { __typename?: 'Price' } & Pick<
                                  Price,
                                  'currency' | 'inCents'
                              >;
                              contract?: Maybe<
                                  | ({ __typename?: 'Flex' } & Pick<Flex, 'id' | 'name'> & {
                                            goods: Array<
                                                { __typename?: 'FlexDevice' } & Pick<
                                                    FlexDevice,
                                                    'id'
                                                > & {
                                                        product: { __typename?: 'Product' } & Pick<
                                                            Product,
                                                            'id'
                                                        > & {
                                                                category: {
                                                                    __typename?: 'Category';
                                                                } & Pick<Category, 'iconSvgPath'>;
                                                            };
                                                    }
                                            >;
                                        })
                                  | ({ __typename?: 'Mix' } & Pick<Mix, 'id'>)
                              >;
                              subscriptionDetails?: Maybe<
                                  { __typename?: 'SubscriptionDetails' } & Pick<
                                      SubscriptionDetails,
                                      'id' | 'name'
                                  > & {
                                          product?: Maybe<
                                              { __typename?: 'Product' } & Pick<Product, 'id'> & {
                                                      category: { __typename?: 'Category' } & Pick<
                                                          Category,
                                                          'iconSvgPath'
                                                      >;
                                                  }
                                          >;
                                      }
                              >;
                          })
                    | ({ __typename?: 'SubscriptionPayment' } & Pick<
                          SubscriptionPayment,
                          'id' | 'state' | 'invoiceUrl'
                      > & {
                              price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                              basePrice: { __typename?: 'Price' } & Pick<
                                  Price,
                                  'currency' | 'inCents'
                              >;
                              dueDate:
                                  | ({ __typename?: 'Date' } & Pick<Date, 'iso8601'>)
                                  | ({ __typename?: 'TimeEstimate' } & {
                                        atLeast: { __typename?: 'Duration' } & Pick<
                                            Duration,
                                            'unit' | 'value'
                                        >;
                                        atMost?: Maybe<
                                            { __typename?: 'Duration' } & Pick<
                                                Duration,
                                                'unit' | 'value'
                                            >
                                        >;
                                    });
                              contract?: Maybe<
                                  | ({ __typename?: 'Flex' } & Pick<Flex, 'id' | 'name'> & {
                                            goods: Array<
                                                { __typename?: 'FlexDevice' } & Pick<
                                                    FlexDevice,
                                                    'id'
                                                > & {
                                                        product: { __typename?: 'Product' } & Pick<
                                                            Product,
                                                            'id'
                                                        > & {
                                                                category: {
                                                                    __typename?: 'Category';
                                                                } & Pick<Category, 'iconSvgPath'>;
                                                            };
                                                    }
                                            >;
                                        })
                                  | ({ __typename?: 'Mix' } & Pick<Mix, 'id'>)
                              >;
                              subscriptionDetails?: Maybe<
                                  { __typename?: 'SubscriptionDetails' } & Pick<
                                      SubscriptionDetails,
                                      'id' | 'name'
                                  > & {
                                          product?: Maybe<
                                              { __typename?: 'Product' } & Pick<Product, 'id'> & {
                                                      category: { __typename?: 'Category' } & Pick<
                                                          Category,
                                                          'iconSvgPath'
                                                      >;
                                                  }
                                          >;
                                      }
                              >;
                              marketingSubscriptionPaymentData: Array<
                                  { __typename?: 'HintModel' } & Pick<
                                      HintModel,
                                      'uuid' | 'bodyTemplate'
                                  >
                              >;
                          })
                >
            >
        >;
    };

export type PaymentsFragmentWithoutSubscriptionDetailsFragment = {
    __typename?: 'PaymentsUnionConnection';
} & Pick<PaymentsUnionConnection, 'totalCount'> & {
        pageInfo: { __typename?: 'PageInfo' } & Pick<
            PageInfo,
            'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
        >;
        nodes?: Maybe<
            Array<
                Maybe<
                    | { __typename?: 'GroupPayment' }
                    | ({ __typename?: 'OrderPayment' } & Pick<
                          OrderPayment,
                          'id' | 'state' | 'invoiceUrl'
                      > & {
                              price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                              basePrice: { __typename?: 'Price' } & Pick<
                                  Price,
                                  'currency' | 'inCents'
                              >;
                              dueDate:
                                  | ({ __typename?: 'Date' } & Pick<Date, 'iso8601'>)
                                  | ({ __typename?: 'TimeEstimate' } & {
                                        atLeast: { __typename?: 'Duration' } & Pick<
                                            Duration,
                                            'unit' | 'value'
                                        >;
                                        atMost?: Maybe<
                                            { __typename?: 'Duration' } & Pick<
                                                Duration,
                                                'unit' | 'value'
                                            >
                                        >;
                                    });
                              order:
                                  | ({ __typename?: 'MixCartOrder' } & Pick<
                                        MixCartOrder,
                                        'orderNumber'
                                    >)
                                  | ({ __typename?: 'Order' } & Pick<
                                        Order,
                                        'id' | 'number' | 'completedAt'
                                    > & {
                                            discountAmount: { __typename?: 'Price' } & Pick<
                                                Price,
                                                'currency' | 'inCents'
                                            >;
                                            shippingPrice: { __typename?: 'Price' } & Pick<
                                                Price,
                                                'currency' | 'inCents'
                                            >;
                                            price: { __typename?: 'Price' } & Pick<
                                                Price,
                                                'currency' | 'inCents'
                                            >;
                                            lineItems: Array<
                                                { __typename?: 'LineItem' } & Pick<
                                                    LineItem,
                                                    'name' | 'quantity'
                                                > & {
                                                        price: { __typename?: 'Price' } & Pick<
                                                            Price,
                                                            'inCents' | 'currency'
                                                        >;
                                                    }
                                            >;
                                        });
                              marketingOrderPaymentData: Array<
                                  { __typename?: 'HintModel' } & Pick<
                                      HintModel,
                                      'uuid' | 'bodyTemplate'
                                  >
                              >;
                          })
                    | ({ __typename?: 'PurchasePayment' } & Pick<
                          PurchasePayment,
                          'id' | 'state' | 'datePaid' | 'invoiceUrl'
                      > & {
                              dueDate:
                                  | ({ __typename?: 'Date' } & Pick<Date, 'iso8601'>)
                                  | ({ __typename?: 'TimeEstimate' } & {
                                        atLeast: { __typename?: 'Duration' } & Pick<
                                            Duration,
                                            'unit' | 'value'
                                        >;
                                        atMost?: Maybe<
                                            { __typename?: 'Duration' } & Pick<
                                                Duration,
                                                'unit' | 'value'
                                            >
                                        >;
                                    });
                              price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                              basePrice: { __typename?: 'Price' } & Pick<
                                  Price,
                                  'currency' | 'inCents'
                              >;
                          })
                    | ({ __typename?: 'SubscriptionPayment' } & Pick<
                          SubscriptionPayment,
                          'id' | 'state' | 'invoiceUrl'
                      > & {
                              price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                              basePrice: { __typename?: 'Price' } & Pick<
                                  Price,
                                  'currency' | 'inCents'
                              >;
                              dueDate:
                                  | ({ __typename?: 'Date' } & Pick<Date, 'iso8601'>)
                                  | ({ __typename?: 'TimeEstimate' } & {
                                        atLeast: { __typename?: 'Duration' } & Pick<
                                            Duration,
                                            'unit' | 'value'
                                        >;
                                        atMost?: Maybe<
                                            { __typename?: 'Duration' } & Pick<
                                                Duration,
                                                'unit' | 'value'
                                            >
                                        >;
                                    });
                              contract?: Maybe<{ __typename: 'Flex' } | { __typename: 'Mix' }>;
                              marketingSubscriptionPaymentData: Array<
                                  { __typename?: 'HintModel' } & Pick<
                                      HintModel,
                                      'uuid' | 'bodyTemplate'
                                  >
                              >;
                          })
                >
            >
        >;
    };

export type SubscriptionPaymentsQueryVariables = Exact<{
    id: Scalars['ID'];
    firstPayments: Scalars['Int'];
    cursor?: Maybe<Scalars['String']>;
}>;

export type SubscriptionPaymentsQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id'> & { contractName: Flex['name'] } & {
                  goods: Array<
                      { __typename?: 'FlexDevice' } & Pick<FlexDevice, 'id'> & {
                              product: { __typename?: 'Product' } & Pick<Product, 'id'> & {
                                      category: { __typename?: 'Category' } & Pick<
                                          Category,
                                          'iconSvgPath'
                                      >;
                                  };
                          }
                  >;
              })
        | ({ __typename?: 'SubscriptionDetails' } & Pick<SubscriptionDetails, 'id' | 'name'> & {
                  product?: Maybe<
                      { __typename?: 'Product' } & Pick<Product, 'id'> & {
                              category: { __typename?: 'Category' } & Pick<Category, 'iconSvgPath'>;
                          }
                  >;
              })
    >;
    payments?: Maybe<
        {
            __typename?: 'PaymentsUnionConnection';
        } & PaymentsFragmentWithoutSubscriptionDetailsFragment
    >;
};

export type SubscriptionPaymentsDetailsQueryVariables = Exact<{
    id: Scalars['ID'];
}>;

export type SubscriptionPaymentsDetailsQuery = { __typename?: 'Query' } & {
    subscriptionDetails?: Maybe<
        | ({ __typename?: 'Flex' } & Pick<Flex, 'id'> & {
                  contractName: Flex['name'];
                  contractState: Flex['state'];
              } & {
                  note?: Maybe<
                      | ({ __typename?: 'AttentionNote' } & Pick<AttentionNote, 'text'>)
                      | ({ __typename?: 'EndedNote' } & Pick<EndedNote, 'text'>)
                      | ({ __typename?: 'NextPaymentNote' } & Pick<NextPaymentNote, 'date'> & {
                                paymentMethod?: Maybe<
                                    | { __typename: 'ByInvoice' }
                                    | { __typename: 'Card' }
                                    | { __typename: 'Paypal' }
                                    | { __typename: 'Sepa' }
                                >;
                            })
                      | ({ __typename?: 'PausedNote' } & Pick<PausedNote, 'text'>)
                      | ({ __typename?: 'ProcessingNote' } & Pick<ProcessingNote, 'text'>)
                  >;
                  goods: Array<
                      { __typename?: 'FlexDevice' } & Pick<FlexDevice, 'id'> & {
                              variant: { __typename?: 'Variant' } & Pick<
                                  Variant,
                                  'id' | 'colorCodes' | 'colorTitle' | 'imageUrl'
                              >;
                          }
                  >;
                  billingTerms: { __typename?: 'BillingTerms' } & {
                      price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
                  };
              })
        | ({ __typename?: 'SubscriptionDetails' } & Pick<
              SubscriptionDetails,
              'id' | 'name' | 'state'
          > & {
                  note?: Maybe<
                      | ({ __typename?: 'AttentionNote' } & Pick<AttentionNote, 'text'>)
                      | ({ __typename?: 'EndedNote' } & Pick<EndedNote, 'text'>)
                      | ({ __typename?: 'NextPaymentNote' } & Pick<NextPaymentNote, 'date'> & {
                                paymentMethod?: Maybe<
                                    | { __typename: 'ByInvoice' }
                                    | { __typename: 'Card' }
                                    | { __typename: 'Paypal' }
                                    | { __typename: 'Sepa' }
                                >;
                            })
                      | ({ __typename?: 'PausedNote' } & Pick<PausedNote, 'text'>)
                      | ({ __typename?: 'ProcessingNote' } & Pick<ProcessingNote, 'text'>)
                  >;
                  variant?: Maybe<
                      { __typename?: 'Variant' } & Pick<
                          Variant,
                          'id' | 'colorCodes' | 'colorTitle' | 'imageUrl'
                      >
                  >;
                  price: { __typename?: 'Price' } & Pick<Price, 'currency' | 'inCents'>;
              })
    >;
};

export type DeleteAuthDeviceMutationVariables = Exact<{
    input: DeleteAuthDeviceInput;
}>;

export type DeleteAuthDeviceMutation = { __typename?: 'Mutation' } & {
    deleteAuthDevice?: Maybe<
        { __typename?: 'DeleteAuthDevicePayload' } & Pick<
            DeleteAuthDevicePayload,
            'clientMutationId'
        >
    >;
};

export type UpdateUserNewsletterOptInStateMutationVariables = Exact<{
    input: UpdateUserNewsletterOptInStateInput;
}>;

export type UpdateUserNewsletterOptInStateMutation = { __typename?: 'Mutation' } & {
    updateUserNewsletterOptInState?: Maybe<
        { __typename?: 'UpdateUserNewsletterOptInStatePayload' } & Pick<
            UpdateUserNewsletterOptInStatePayload,
            'clientMutationId'
        > & { user: { __typename?: 'User' } & Pick<User, 'newsletterOptInState'> }
    >;
};

export type AccountSecurityQueryVariables = Exact<{
    userId: Scalars['ID'];
}>;

export type AccountSecurityQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<
            User,
            'id' | 'email' | 'emailVerified' | 'phone' | 'phoneVerified'
        >
    >;
};

export type DevicesQueryVariables = Exact<{ [key: string]: never }>;

export type DevicesQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                devices?: Maybe<
                    { __typename?: 'AuthDeviceConnection' } & {
                        nodes?: Maybe<
                            Array<
                                Maybe<
                                    { __typename?: 'AuthDevice' } & Pick<
                                        AuthDevice,
                                        | 'deviceType'
                                        | 'id'
                                        | 'createdAt'
                                        | 'os'
                                        | 'platform'
                                        | 'stale'
                                    > & {
                                            lastLocation?: Maybe<
                                                { __typename?: 'AuthDeviceHistoryItem' } & Pick<
                                                    AuthDeviceHistoryItem,
                                                    | 'city'
                                                    | 'country'
                                                    | 'countryIso'
                                                    | 'ipAddress'
                                                    | 'lastSeenAt'
                                                    | 'createdAt'
                                                >
                                            >;
                                        }
                                >
                            >
                        >;
                    }
                >;
            }
    >;
};

export type DevicesWithHistoryQueryVariables = Exact<{ [key: string]: never }>;

export type DevicesWithHistoryQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'id'> & {
                devices?: Maybe<
                    { __typename?: 'AuthDeviceConnection' } & {
                        nodes?: Maybe<
                            Array<
                                Maybe<
                                    { __typename?: 'AuthDevice' } & Pick<
                                        AuthDevice,
                                        'deviceType' | 'id' | 'os' | 'platform' | 'stale'
                                    > & {
                                            history: Array<
                                                { __typename?: 'AuthDeviceHistoryItem' } & Pick<
                                                    AuthDeviceHistoryItem,
                                                    | 'city'
                                                    | 'country'
                                                    | 'countryIso'
                                                    | 'createdAt'
                                                    | 'ipAddress'
                                                    | 'lastSeenAt'
                                                >
                                            >;
                                            lastLocation?: Maybe<
                                                { __typename?: 'AuthDeviceHistoryItem' } & Pick<
                                                    AuthDeviceHistoryItem,
                                                    | 'city'
                                                    | 'country'
                                                    | 'countryIso'
                                                    | 'ipAddress'
                                                    | 'lastSeenAt'
                                                    | 'createdAt'
                                                >
                                            >;
                                        }
                                >
                            >
                        >;
                    }
                >;
            }
    >;
};

export type PersonalInformationQueryVariables = Exact<{ [key: string]: never }>;

export type PersonalInformationQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<
            User,
            | 'id'
            | 'birthdate'
            | 'email'
            | 'emailVerified'
            | 'firstName'
            | 'lastName'
            | 'phone'
            | 'phoneVerified'
        >
    >;
};

export type UserNewsletterOptInStateQueryQueryVariables = Exact<{
    userId: Scalars['ID'];
}>;

export type UserNewsletterOptInStateQueryQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<User, 'email' | 'emailVerified' | 'newsletterOptInState'>
    >;
};

export type YourProfileQueryQueryVariables = Exact<{
    userId: Scalars['ID'];
}>;

export type YourProfileQueryQuery = { __typename?: 'Query' } & {
    user?: Maybe<
        { __typename?: 'User' } & Pick<
            User,
            'id' | 'email' | 'firstName' | 'lastName' | 'verificationState'
        >
    >;
};

export type GetVoucherDiscountQueryVariables = Exact<{
    code: Scalars['String'];
}>;

export type GetVoucherDiscountQuery = { __typename?: 'Query' } & {
    voucher: { __typename?: 'Voucher' } & {
        discount: { __typename?: 'VoucherDiscount' } & Pick<
            VoucherDiscount,
            'type' | 'amountOff' | 'percentOff'
        >;
    };
};
